import { Injectable, ɵɵdefineInjectable, InjectionToken, EventEmitter, Component, ChangeDetectionStrategy, ViewEncapsulation, Inject, Input, Output, Directive, Optional, HostListener, ViewContainerRef, HostBinding, ContentChild, ElementRef, ViewChild, Pipe, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { BehaviorSubject, Subject } from 'rxjs';
import { DateTime, Info } from 'ts-luxon';
import { tap, map, distinctUntilChanged, takeUntil, shareReplay } from 'rxjs/operators';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { Overlay, CdkOverlayOrigin, OverlayModule } from '@angular/cdk/overlay';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatFormField, MatFormFieldModule } from '@angular/material/form-field';
import { PortalModule } from '@angular/cdk/portal';
import { DOCUMENT, CommonModule } from '@angular/common';
import { A11yModule } from '@angular/cdk/a11y';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { trigger, transition, style, animate, sequence } from '@angular/animations';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/forms';
import * as ɵngcc3 from '@angular/material/form-field';
import * as ɵngcc4 from '@angular/material/select';
import * as ɵngcc5 from '@angular/material/core';
import * as ɵngcc6 from '@angular/material/icon';
import * as ɵngcc7 from '@angular/material/dialog';
import * as ɵngcc8 from '@angular/cdk/a11y';
import * as ɵngcc9 from '@angular/material/button';
import * as ɵngcc10 from '@angular/material/toolbar';
import * as ɵngcc11 from '@angular/cdk/overlay';
import * as ɵngcc12 from '@angular/material/input';

function NgxMatTimepickerFieldComponent_mat_select_8_mat_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-option", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r6 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", option_r6);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(option_r6);
} }
function NgxMatTimepickerFieldComponent_mat_select_8_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "mat-select", 10);
    ɵngcc0.ɵɵlistener("selectionChange", function NgxMatTimepickerFieldComponent_mat_select_8_Template_mat_select_selectionChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r7.changePeriod($event)); });
    ɵngcc0.ɵɵtemplate(1, NgxMatTimepickerFieldComponent_mat_select_8_mat_option_1_Template, 2, 2, "mat-option", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("disabled", ctx_r0.disabled || ctx_r0.isChangePeriodDisabled)("ngModel", ctx_r0.period);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.periods);
} }
function NgxMatTimepickerFieldComponent_ngx_mat_timepicker_toggle_9_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function NgxMatTimepickerFieldComponent_ngx_mat_timepicker_toggle_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ngx-mat-timepicker-toggle", 13)(1, "span", 14);
    ɵngcc0.ɵɵtemplate(2, NgxMatTimepickerFieldComponent_ngx_mat_timepicker_toggle_9_ng_container_2_Template, 1, 0, "ng-container", 15);
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r2 = ɵngcc0.ɵɵreference(11);
    const _r3 = ɵngcc0.ɵɵreference(13);
    ɵngcc0.ɵɵproperty("for", _r2)("disabled", ctx_r1.disabled);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.toggleIcon || _r3);
} }
function NgxMatTimepickerFieldComponent_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "mat-icon");
    ɵngcc0.ɵɵtext(1, "watch_later");
    ɵngcc0.ɵɵelementEnd();
} }
const _c0 = function (a0) { return { "ngx-mat-timepicker--disabled": a0 }; };
function NgxMatTimepickerDialogComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 14);
    ɵngcc0.ɵɵtext(1, "CANCEL ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("color", ctx_r1.color);
} }
function NgxMatTimepickerDialogComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 14);
    ɵngcc0.ɵɵtext(1, "OK ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("color", ctx_r3.color);
} }
function NgxMatTimepickerDialogComponent_div_14_ngx_mat_timepicker_24_hours_face_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngx-mat-timepicker-24-hours-face", 17);
    ɵngcc0.ɵɵlistener("hourChange", function NgxMatTimepickerDialogComponent_div_14_ngx_mat_timepicker_24_hours_face_1_Template_ngx_mat_timepicker_24_hours_face_hourChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r11.onHourChange($event)); })("hourSelected", function NgxMatTimepickerDialogComponent_div_14_ngx_mat_timepicker_24_hours_face_1_Template_ngx_mat_timepicker_24_hours_face_hourSelected_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r13.onHourSelected($event)); });
    ɵngcc0.ɵɵpipe(1, "async");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("color", ctx_r8.color)("selectedHour", ɵngcc0.ɵɵpipeBind1(1, 5, ctx_r8.selectedHour))("minTime", ctx_r8.data.minTime)("maxTime", ctx_r8.data.maxTime)("format", ctx_r8.data.format);
} }
function NgxMatTimepickerDialogComponent_div_14_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngx-mat-timepicker-12-hours-face", 18);
    ɵngcc0.ɵɵlistener("hourChange", function NgxMatTimepickerDialogComponent_div_14_ng_template_2_Template_ngx_mat_timepicker_12_hours_face_hourChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r14.onHourChange($event)); })("hourSelected", function NgxMatTimepickerDialogComponent_div_14_ng_template_2_Template_ngx_mat_timepicker_12_hours_face_hourSelected_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r16.onHourSelected($event)); });
    ɵngcc0.ɵɵpipe(1, "async");
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("color", ctx_r10.color)("selectedHour", ɵngcc0.ɵɵpipeBind1(1, 5, ctx_r10.selectedHour))("period", ɵngcc0.ɵɵpipeBind1(2, 7, ctx_r10.selectedPeriod))("minTime", ctx_r10.data.minTime)("maxTime", ctx_r10.data.maxTime);
} }
function NgxMatTimepickerDialogComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, NgxMatTimepickerDialogComponent_div_14_ngx_mat_timepicker_24_hours_face_1_Template, 2, 7, "ngx-mat-timepicker-24-hours-face", 15);
    ɵngcc0.ɵɵtemplate(2, NgxMatTimepickerDialogComponent_div_14_ng_template_2_Template, 3, 9, "ng-template", null, 16, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r9 = ɵngcc0.ɵɵreference(3);
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.data.format === 24)("ngIfElse", _r9);
} }
function NgxMatTimepickerDialogComponent_ngx_mat_timepicker_minutes_face_15_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngx-mat-timepicker-minutes-face", 19);
    ɵngcc0.ɵɵlistener("minuteChange", function NgxMatTimepickerDialogComponent_ngx_mat_timepicker_minutes_face_15_Template_ngx_mat_timepicker_minutes_face_minuteChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r17.onMinuteChange($event)); });
    ɵngcc0.ɵɵpipe(1, "async");
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵpipe(3, "async");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    let tmp_2_0;
    ɵngcc0.ɵɵproperty("color", ctx_r5.color)("selectedMinute", ɵngcc0.ɵɵpipeBind1(1, 8, ctx_r5.selectedMinute))("selectedHour", (tmp_2_0 = ɵngcc0.ɵɵpipeBind1(2, 10, ctx_r5.selectedHour)) == null ? null : tmp_2_0.time)("minTime", ctx_r5.data.minTime)("maxTime", ctx_r5.data.maxTime)("format", ctx_r5.data.format)("period", ɵngcc0.ɵɵpipeBind1(3, 12, ctx_r5.selectedPeriod))("minutesGap", ctx_r5.data.minutesGap);
} }
function NgxMatTimepickerDialogComponent_ng_container_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function NgxMatTimepickerDialogComponent_ng_container_20_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function NgxMatTimepickerComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ngx-mat-timepicker-standalone");
} }
function NgxMatTimepickerToggleComponent__svg_svg_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵnamespaceSVG();
    ɵngcc0.ɵɵelementStart(0, "svg", 2);
    ɵngcc0.ɵɵelement(1, "path", 3);
    ɵngcc0.ɵɵelementEnd();
} }
const _c1 = [[["", "ngxMatTimepickerToggleIcon", ""]]];
const _c2 = ["[ngxMatTimepickerToggleIcon]"];
const _c3 = ["clockFace"];
const _c4 = ["clockHand"];
const _c5 = function (a0) { return { "transform": a0 }; };
function NgxMatTimepickerFaceComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 9);
    ɵngcc0.ɵɵpipe(1, "activeHour");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "timeLocalizer");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const time_r8 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("color", ɵngcc0.ɵɵpipeBind3(1, 4, time_r8.time, ctx_r1.selectedTime == null ? null : ctx_r1.selectedTime.time, ctx_r1.isClockFaceDisabled) ? ctx_r1.color : undefined)("ngStyle", ɵngcc0.ɵɵpureFunction1(11, _c5, "rotateZ(-" + time_r8.angle + "deg)"))("disabled", time_r8.disabled);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(3, 8, time_r8.time, ctx_r1.timeUnit.HOUR), " ");
} }
function NgxMatTimepickerFaceComponent_div_4_div_1_ng_content_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 0, ["*ngTemplateOutlet", "hourButton; context: {$implicit: time}"]);
} }
const _c6 = function (a0) { return { $implicit: a0 }; };
function NgxMatTimepickerFaceComponent_div_4_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵtemplate(1, NgxMatTimepickerFaceComponent_div_4_div_1_ng_content_1_Template, 1, 0, "ng-content", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const time_r11 = ctx.$implicit;
    ɵngcc0.ɵɵnextContext(2);
    const _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(3, _c5, "rotateZ(" + time_r11.angle + "deg)"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(5, _c6, time_r11));
} }
function NgxMatTimepickerFaceComponent_div_4_div_3_div_1_ng_content_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0, 1, ["*ngTemplateOutlet", "hourButton; context: {$implicit: time}"]);
} }
function NgxMatTimepickerFaceComponent_div_4_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵtemplate(1, NgxMatTimepickerFaceComponent_div_4_div_3_div_1_ng_content_1_Template, 1, 0, "ng-content", 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const time_r14 = ctx.$implicit;
    const ctx_r13 = ɵngcc0.ɵɵnextContext(3);
    const _r0 = ɵngcc0.ɵɵreference(1);
    ɵngcc0.ɵɵstyleProp("top", "calc(50% - " + ctx_r13.innerClockFaceSize + "px)")("height", ctx_r13.innerClockFaceSize, "px");
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(7, _c5, "rotateZ(" + time_r14.angle + "deg)"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r0)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(9, _c6, time_r14));
} }
function NgxMatTimepickerFaceComponent_div_4_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵtemplate(1, NgxMatTimepickerFaceComponent_div_4_div_3_div_1_Template, 2, 11, "div", 16);
    ɵngcc0.ɵɵpipe(2, "slice");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind3(2, 2, ctx_r10.faceTime, 12, 24))("ngForTrackBy", ctx_r10.trackByTime);
} }
function NgxMatTimepickerFaceComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵtemplate(1, NgxMatTimepickerFaceComponent_div_4_div_1_Template, 2, 7, "div", 11);
    ɵngcc0.ɵɵpipe(2, "slice");
    ɵngcc0.ɵɵtemplate(3, NgxMatTimepickerFaceComponent_div_4_div_3_Template, 3, 6, "div", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind3(2, 3, ctx_r3.faceTime, 0, 12))("ngForTrackBy", ctx_r3.trackByTime);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.faceTime.length > 12);
} }
function NgxMatTimepickerFaceComponent_button_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 18);
    ɵngcc0.ɵɵelement(1, "span", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("color", ctx_r5.color);
} }
function NgxMatTimepickerFaceComponent_ng_template_9_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13)(1, "button", 20);
    ɵngcc0.ɵɵpipe(2, "activeMinute");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "timeLocalizer");
    ɵngcc0.ɵɵpipe(5, "minutesFormatter");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    const time_r17 = ctx.$implicit;
    const ctx_r16 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(16, _c5, "rotateZ(" + time_r17.angle + "deg)"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("disableRipple", time_r17.time % ctx_r16.minutesGap !== 0)("color", ɵngcc0.ɵɵpipeBind4(2, 5, time_r17.time, ctx_r16.selectedTime == null ? null : ctx_r16.selectedTime.time, ctx_r16.minutesGap, ctx_r16.isClockFaceDisabled) ? ctx_r16.color : undefined)("ngStyle", ɵngcc0.ɵɵpureFunction1(18, _c5, "rotateZ(-" + time_r17.angle + "deg)"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(4, 10, ɵngcc0.ɵɵpipeBind2(5, 13, time_r17.time, ctx_r16.minutesGap), ctx_r16.timeUnit.MINUTE), " ");
} }
function NgxMatTimepickerFaceComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵtemplate(1, NgxMatTimepickerFaceComponent_ng_template_9_div_1_Template, 6, 20, "div", 11);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r7.faceTime)("ngForTrackBy", ctx_r7.trackByTime);
} }
const _c7 = ["*", "*"];
const _c8 = function (a0) { return { "clock-face__clock-hand_minute": a0 }; };
function NgxMatTimepickerDialComponent_ngx_mat_timepicker_period_7_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngx-mat-timepicker-period", 7);
    ɵngcc0.ɵɵlistener("periodChanged", function NgxMatTimepickerDialComponent_ngx_mat_timepicker_period_7_Template_ngx_mat_timepicker_period_periodChanged_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r2.changePeriod($event)); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("selectedPeriod", ctx_r0.period)("activeTimeUnit", ctx_r0.activeTimeUnit)("maxTime", ctx_r0.maxTime)("minTime", ctx_r0.minTime)("format", ctx_r0.format)("hours", ctx_r0.hours)("minutes", ctx_r0.minutes)("selectedHour", ctx_r0.hour)("meridiems", ctx_r0.meridiems);
} }
function NgxMatTimepickerDialComponent_div_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function NgxMatTimepickerDialComponent_div_8_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "small", 11);
    ɵngcc0.ɵɵtext(1, " * use arrows (");
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3, "\u21C5");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(4, ") to change the time");
    ɵngcc0.ɵɵelementEnd();
} }
const _c9 = function (a0) { return { "timepicker-dial__hint-container--hidden": a0 }; };
function NgxMatTimepickerDialComponent_div_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵtemplate(1, NgxMatTimepickerDialComponent_div_8_ng_container_1_Template, 1, 0, "ng-container", 9);
    ɵngcc0.ɵɵtemplate(2, NgxMatTimepickerDialComponent_div_8_ng_template_2_Template, 5, 0, "ng-template", null, 10, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r5 = ɵngcc0.ɵɵreference(3);
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(2, _c9, !ctx_r1.isHintVisible));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.editableHintTmpl ? ctx_r1.editableHintTmpl : _r5);
} }
const _c10 = function (a0) { return { "active": a0 }; };
function NgxMatTimepickerDialControlComponent_input_0_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 2);
    ɵngcc0.ɵɵlistener("ngModelChange", function NgxMatTimepickerDialControlComponent_input_0_Template_input_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r3.time = $event); })("input", function NgxMatTimepickerDialControlComponent_input_0_Template_input_input_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r5.updateTime()); })("focus", function NgxMatTimepickerDialControlComponent_input_0_Template_input_focus_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r6.saveTimeAndChangeTimeUnit($event, ctx_r6.timeUnit)); });
    ɵngcc0.ɵɵpipe(1, "timeLocalizer");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(8, _c10, ctx_r0.isActive))("ngModel", ɵngcc0.ɵɵpipeBind3(1, 4, ctx_r0.time, ctx_r0.timeUnit, true))("disabled", ctx_r0.disabled)("ngxMatTimepickerAutofocus", ctx_r0.isActive);
} }
function NgxMatTimepickerDialControlComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 3);
    ɵngcc0.ɵɵlistener("ngModelChange", function NgxMatTimepickerDialControlComponent_ng_template_1_Template_input_ngModelChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r7.onModelChange($event)); })("input", function NgxMatTimepickerDialControlComponent_ng_template_1_Template_input_input_0_listener() { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r9.updateTime()); })("focus", function NgxMatTimepickerDialControlComponent_ng_template_1_Template_input_focus_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r10 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r10.saveTimeAndChangeTimeUnit($event, ctx_r10.timeUnit)); })("keydown", function NgxMatTimepickerDialControlComponent_ng_template_1_Template_input_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r11.onKeydown($event)); })("keypress", function NgxMatTimepickerDialControlComponent_ng_template_1_Template_input_keypress_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r12.changeTimeByKeyboard($event)); });
    ɵngcc0.ɵɵpipe(1, "timeLocalizer");
    ɵngcc0.ɵɵpipe(2, "ngxMatTimepickerParser");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(11, _c10, ctx_r2.isActive))("ngModel", ɵngcc0.ɵɵpipeBind3(1, 4, ɵngcc0.ɵɵpipeBind2(2, 8, ctx_r2.time, ctx_r2.timeUnit), ctx_r2.timeUnit, true))("disabled", ctx_r2.disabled)("ngxMatTimepickerAutofocus", ctx_r2.isActive);
} }
function NgxMatTimepickerPeriodComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵlistener("@scaleInOut.done", function NgxMatTimepickerPeriodComponent_div_5_Template_div_animation_scaleInOut_done_0_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r1.animationDone()); });
    ɵngcc0.ɵɵelementStart(1, "p");
    ɵngcc0.ɵɵtext(2, "Current time would be invalid in this period.");
    ɵngcc0.ɵɵelementEnd()();
} if (rf & 2) {
    ɵngcc0.ɵɵproperty("@scaleInOut", undefined);
} }
function NgxMatTimepickerContentComponent_div_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function NgxMatTimepickerContentComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, NgxMatTimepickerContentComponent_div_0_ng_container_1_Template, 1, 0, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function NgxMatTimepickerContentComponent_ng_template_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function NgxMatTimepickerContentComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, NgxMatTimepickerContentComponent_ng_template_1_ng_container_0_Template, 1, 0, "ng-container", 3);
} if (rf & 2) {
    ɵngcc0.ɵɵnextContext();
    const _r3 = ɵngcc0.ɵɵreference(4);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r3);
} }
function NgxMatTimepickerContentComponent_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
const _c11 = ["*"];
function NgxMatTimepickerStandaloneComponent_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 13);
    ɵngcc0.ɵɵtext(1, "CANCEL ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("color", ctx_r1.color);
} }
function NgxMatTimepickerStandaloneComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "button", 13);
    ɵngcc0.ɵɵtext(1, "OK ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("color", ctx_r3.color);
} }
function NgxMatTimepickerStandaloneComponent_div_13_ngx_mat_timepicker_24_hours_face_1_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngx-mat-timepicker-24-hours-face", 16);
    ɵngcc0.ɵɵlistener("hourChange", function NgxMatTimepickerStandaloneComponent_div_13_ngx_mat_timepicker_24_hours_face_1_Template_ngx_mat_timepicker_24_hours_face_hourChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r11.onHourChange($event)); })("hourSelected", function NgxMatTimepickerStandaloneComponent_div_13_ngx_mat_timepicker_24_hours_face_1_Template_ngx_mat_timepicker_24_hours_face_hourSelected_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r12); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r13.onHourSelected($event)); });
    ɵngcc0.ɵɵpipe(1, "async");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("color", ctx_r8.color)("selectedHour", ɵngcc0.ɵɵpipeBind1(1, 5, ctx_r8.selectedHour))("minTime", ctx_r8.data.minTime)("maxTime", ctx_r8.data.maxTime)("format", ctx_r8.data.format);
} }
function NgxMatTimepickerStandaloneComponent_div_13_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngx-mat-timepicker-12-hours-face", 17);
    ɵngcc0.ɵɵlistener("hourChange", function NgxMatTimepickerStandaloneComponent_div_13_ng_template_2_Template_ngx_mat_timepicker_12_hours_face_hourChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r14.onHourChange($event)); })("hourSelected", function NgxMatTimepickerStandaloneComponent_div_13_ng_template_2_Template_ngx_mat_timepicker_12_hours_face_hourSelected_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ɵngcc0.ɵɵresetView(ctx_r16.onHourSelected($event)); });
    ɵngcc0.ɵɵpipe(1, "async");
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("color", ctx_r10.color)("selectedHour", ɵngcc0.ɵɵpipeBind1(1, 5, ctx_r10.selectedHour))("period", ɵngcc0.ɵɵpipeBind1(2, 7, ctx_r10.selectedPeriod))("minTime", ctx_r10.data.minTime)("maxTime", ctx_r10.data.maxTime);
} }
function NgxMatTimepickerStandaloneComponent_div_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, NgxMatTimepickerStandaloneComponent_div_13_ngx_mat_timepicker_24_hours_face_1_Template, 2, 7, "ngx-mat-timepicker-24-hours-face", 14);
    ɵngcc0.ɵɵtemplate(2, NgxMatTimepickerStandaloneComponent_div_13_ng_template_2_Template, 3, 9, "ng-template", null, 15, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r9 = ɵngcc0.ɵɵreference(3);
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.data.format === 24)("ngIfElse", _r9);
} }
function NgxMatTimepickerStandaloneComponent_ngx_mat_timepicker_minutes_face_14_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ngx-mat-timepicker-minutes-face", 18);
    ɵngcc0.ɵɵlistener("minuteChange", function NgxMatTimepickerStandaloneComponent_ngx_mat_timepicker_minutes_face_14_Template_ngx_mat_timepicker_minutes_face_minuteChange_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ɵngcc0.ɵɵresetView(ctx_r17.onMinuteChange($event)); });
    ɵngcc0.ɵɵpipe(1, "async");
    ɵngcc0.ɵɵpipe(2, "async");
    ɵngcc0.ɵɵpipe(3, "async");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    let tmp_2_0;
    ɵngcc0.ɵɵproperty("color", ctx_r5.color)("selectedMinute", ɵngcc0.ɵɵpipeBind1(1, 8, ctx_r5.selectedMinute))("selectedHour", (tmp_2_0 = ɵngcc0.ɵɵpipeBind1(2, 10, ctx_r5.selectedHour)) == null ? null : tmp_2_0.time)("minTime", ctx_r5.data.minTime)("maxTime", ctx_r5.data.maxTime)("format", ctx_r5.data.format)("period", ɵngcc0.ɵɵpipeBind1(3, 12, ctx_r5.selectedPeriod))("minutesGap", ctx_r5.data.minutesGap);
} }
function NgxMatTimepickerStandaloneComponent_ng_container_17_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function NgxMatTimepickerStandaloneComponent_ng_container_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const NgxMatTimepickerPeriods = {
    AM: "AM",
    PM: "PM",
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const NgxMatTimepickerFormat = {
    TWELVE: "hh:mm a",
    TWELVE_SHORT: "h:m a",
    TWENTY_FOUR: "HH:mm",
    TWENTY_FOUR_SHORT: "H:m",
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxMatTimepickerAdapter {
    /**
     *
     *  Format hour according to time format (12 or 24)
     * @param {?} currentHour
     * @param {?} format
     * @param {?} period
     * @return {?}
     */
    static formatHour(currentHour, format, period) {
        if (format === 24) {
            return currentHour;
        }
        const /** @type {?} */ hour = period === NgxMatTimepickerPeriods.AM ? currentHour : currentHour + 12;
        if (period === NgxMatTimepickerPeriods.AM && hour === 12) {
            return 0;
        }
        else if (period === NgxMatTimepickerPeriods.PM && hour === 24) {
            return 12;
        }
        return hour;
    }
    /**
     * @param {?} time
     * @param {?} opts
     * @return {?}
     */
    static formatTime(time, opts) {
        if (!time) {
            return "Invalid Time";
        }
        const /** @type {?} */ parsedTime = this.parseTime(time, opts).setLocale(this.defaultLocale);
        const /** @type {?} */ isTwelve = !this.isTwentyFour(opts.format);
        if (isTwelve) {
            return parsedTime.toLocaleString(Object.assign(Object.assign({}, DateTime.TIME_SIMPLE), { hour12: isTwelve })).replace(/\u200E/g, "");
        }
        return parsedTime.toISOTime({
            includeOffset: false,
            suppressMilliseconds: true,
            suppressSeconds: true
        }).replace(/\u200E/g, "");
    }
    /**
     * @param {?} time
     * @param {?} format
     * @return {?}
     */
    static fromDateTimeToString(time, format) {
        return time.reconfigure({
            numberingSystem: this.defaultNumberingSistem,
            locale: this.defaultLocale
        }).toFormat(this.isTwentyFour(format) ? NgxMatTimepickerFormat.TWENTY_FOUR : NgxMatTimepickerFormat.TWELVE);
    }
    /**
     * @param {?} time
     * @param {?} before
     * @param {?} after
     * @param {?=} unit
     * @return {?}
     */
    static isBetween(time, before, after, unit = "minutes") {
        const /** @type {?} */ innerUnit = unit === "hours" ? unit : void 0;
        return this.isSameOrBefore(time, after, innerUnit) && this.isSameOrAfter(time, before, innerUnit);
    }
    /**
     * @param {?} time
     * @param {?} compareWith
     * @param {?=} unit
     * @return {?}
     */
    static isSameOrAfter(time, compareWith, unit = "minutes") {
        if (unit === "hours") {
            return time.hour >= compareWith.hour;
        }
        return time.hasSame(compareWith, unit) || time.valueOf() > compareWith.valueOf();
    }
    /**
     * @param {?} time
     * @param {?} compareWith
     * @param {?=} unit
     * @return {?}
     */
    static isSameOrBefore(time, compareWith, unit = "minutes") {
        if (unit === "hours") {
            return time.hour <= compareWith.hour;
        }
        return time.hasSame(compareWith, unit) || time.valueOf() <= compareWith.valueOf();
    }
    /**
     * @param {?} time
     * @param {?=} min
     * @param {?=} max
     * @param {?=} granularity
     * @param {?=} minutesGap
     * @param {?=} format
     * @return {?}
     */
    static isTimeAvailable(time, min, max, granularity, minutesGap, format) {
        if (!time) {
            return void 0;
        }
        const /** @type {?} */ convertedTime = this.parseTime(time, { format });
        const /** @type {?} */ minutes = convertedTime.minute;
        if (minutesGap && minutes === minutes && minutes % minutesGap !== 0) {
            throw new Error(`Your minutes - ${minutes} doesn\'t match your minutesGap - ${minutesGap}`);
        }
        const /** @type {?} */ isAfter = (min && !max)
            && this.isSameOrAfter(convertedTime, min, granularity);
        const /** @type {?} */ isBefore = (max && !min)
            && this.isSameOrBefore(convertedTime, max, granularity);
        const /** @type {?} */ between = (min && max)
            && this.isBetween(convertedTime, min, max, granularity);
        const /** @type {?} */ isAvailable = !min && !max;
        return isAfter || isBefore || between || isAvailable;
    }
    /**
     * @param {?} format
     * @return {?}
     */
    static isTwentyFour(format) {
        return format === 24;
    }
    /**
     * @param {?} time
     * @param {?} opts
     * @return {?}
     */
    static parseTime(time, opts) {
        const { numberingSystem, locale } = this._getLocaleOptionsByTime(time, opts);
        let /** @type {?} */ timeMask = NgxMatTimepickerFormat.TWENTY_FOUR_SHORT;
        // If there's a space, means we have the meridiem. Way faster than splitting text
        // if (~time.indexOf(" ")) {
        // 09/02/2023 it seems that sometimes the space from the formatter is a nnbsp (Chromium >= 110)
        // which causes the indexOf(" ") to fail: charCode 32, while nbsp is 8239
        if (time.match(/\s/g)) {
            /*
                         * We translate the meridiem in simple AM or PM letters (instead of A.M.)
                         * because even if we set the locale with NgxMatTimepickerModule.setLocale
                         * the default (en-US) will always be used here
                         */
            time = time.replace(/\.\s*/g, "");
            timeMask = NgxMatTimepickerFormat.TWELVE_SHORT;
        }
        return DateTime.fromFormat(time.replace(/\s+/g, " "), timeMask, { numberingSystem, locale });
    }
    /**
     * @param {?} time
     * @param {?=} opts
     * @return {?}
     */
    static toLocaleTimeString(time, opts = {}) {
        const { format = this.defaultFormat, locale = this.defaultLocale } = opts;
        let /** @type {?} */ hour12 = !0;
        let /** @type {?} */ timeMask = NgxMatTimepickerFormat.TWELVE_SHORT;
        if (this.isTwentyFour(format)) {
            hour12 = !1;
            timeMask = NgxMatTimepickerFormat.TWENTY_FOUR_SHORT;
        }
        return DateTime.fromFormat(time, timeMask).setLocale(locale).toLocaleString(Object.assign(Object.assign({}, DateTime.TIME_SIMPLE), { hour12 }));
    }
    /**
     * @param {?} time
     * @param {?} opts
     * @return {?}
     */
    static _getLocaleOptionsByTime(time, opts) {
        const { numberingSystem, locale } = DateTime.local().setLocale(opts.locale).resolvedLocaleOpts();
        const /** @type {?} */ localeConfig = {
            numberingSystem: numberingSystem,
            locale
        };
        const /** @type {?} */ defaultConfig = {
            numberingSystem: NgxMatTimepickerAdapter.defaultNumberingSistem,
            locale: NgxMatTimepickerAdapter.defaultLocale
        };
        return isNaN(parseInt(time, 10)) ? localeConfig : defaultConfig;
    }
}
NgxMatTimepickerAdapter.defaultFormat = 12;
NgxMatTimepickerAdapter.defaultLocale = "en-US";
NgxMatTimepickerAdapter.defaultNumberingSistem = "latn";
function NgxMatTimepickerAdapter_tsickle_Closure_declarations() {
    /** @type {?} */
    NgxMatTimepickerAdapter.defaultFormat;
    /** @type {?} */
    NgxMatTimepickerAdapter.defaultLocale;
    /** @type {?} */
    NgxMatTimepickerAdapter.defaultNumberingSistem;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
const /** @type {?} */ DEFAULT_HOUR = {
    time: 12,
    angle: 360
};
const /** @type {?} */ DEFAULT_MINUTE = {
    time: 0,
    angle: 360
};
class NgxMatTimepickerService {
    constructor() {
        this._hour$ = new BehaviorSubject(DEFAULT_HOUR);
        this._minute$ = new BehaviorSubject(DEFAULT_MINUTE);
        this._period$ = new BehaviorSubject(NgxMatTimepickerPeriods.AM);
    }
    /**
     * @param {?} hour
     * @return {?}
     */
    set hour(hour) {
        this._hour$.next(hour);
    }
    /**
     * @param {?} minute
     * @return {?}
     */
    set minute(minute) {
        this._minute$.next(minute);
    }
    /**
     * @param {?} period
     * @return {?}
     */
    set period(period) {
        const /** @type {?} */ isPeriodValid = (period === NgxMatTimepickerPeriods.AM) || (period === NgxMatTimepickerPeriods.PM);
        if (isPeriodValid) {
            this._period$.next(period);
        }
    }
    /**
     * @return {?}
     */
    get selectedHour() {
        return this._hour$.asObservable();
    }
    /**
     * @return {?}
     */
    get selectedMinute() {
        return this._minute$.asObservable();
    }
    /**
     * @return {?}
     */
    get selectedPeriod() {
        return this._period$.asObservable();
    }
    /**
     * @param {?} format
     * @return {?}
     */
    getFullTime(format) {
        const /** @type {?} */ selectedHour = this._hour$.getValue().time;
        const /** @type {?} */ selectedMinute = this._minute$.getValue().time;
        const /** @type {?} */ hour = selectedHour != null ? selectedHour : DEFAULT_HOUR.time;
        const /** @type {?} */ minute = selectedMinute != null ? selectedMinute : DEFAULT_MINUTE.time;
        const /** @type {?} */ period = format === 12 ? this._period$.getValue() : "";
        const /** @type {?} */ time = `${hour}:${minute} ${period}`.trim();
        return NgxMatTimepickerAdapter.formatTime(time, { format });
    }
    /**
     * @param {?} time
     * @param {?} min
     * @param {?} max
     * @param {?} format
     * @param {?=} minutesGap
     * @return {?}
     */
    setDefaultTimeIfAvailable(time, min, max, format, minutesGap) {
        /* Workaround to double error message*/
        try {
            if (NgxMatTimepickerAdapter.isTimeAvailable(time, min, max, "minutes", minutesGap)) {
                this._setDefaultTime(time, format);
            }
        }
        catch (/** @type {?} */ e) {
            console.error(e);
        }
    }
    /**
     * @return {?}
     */
    _resetTime() {
        this.hour = Object.assign({}, DEFAULT_HOUR);
        this.minute = Object.assign({}, DEFAULT_MINUTE);
        this.period = NgxMatTimepickerPeriods.AM;
    }
    /**
     * @param {?} time
     * @param {?} format
     * @return {?}
     */
    _setDefaultTime(time, format) {
        const /** @type {?} */ defaultTime = NgxMatTimepickerAdapter.parseTime(time, { format }).toJSDate();
        // Check on null, because invalid date will be null
        if (DateTime.fromJSDate(defaultTime) !== null) {
            const /** @type {?} */ period = time.substr(time.length - 2).toUpperCase();
            const /** @type {?} */ hour = defaultTime.getHours();
            this.hour = Object.assign(Object.assign({}, DEFAULT_HOUR), { time: formatHourByPeriod(hour, period) });
            this.minute = Object.assign(Object.assign({}, DEFAULT_MINUTE), { time: defaultTime.getMinutes() });
            this.period = period;
        }
        else {
            this._resetTime();
        }
    }
}
NgxMatTimepickerService.ɵfac = function NgxMatTimepickerService_Factory(t) { return new (t || NgxMatTimepickerService)(); };
/** @nocollapse */ NgxMatTimepickerService.ɵprov = ɵɵdefineInjectable({ factory: function NgxMatTimepickerService_Factory() { return new NgxMatTimepickerService(); }, token: NgxMatTimepickerService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepickerService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return []; }, null); })();
function NgxMatTimepickerService_tsickle_Closure_declarations() {
    /** @type {?} */
    NgxMatTimepickerService.prototype._hour$;
    /** @type {?} */
    NgxMatTimepickerService.prototype._minute$;
    /** @type {?} */
    NgxMatTimepickerService.prototype._period$;
}
/**
 *
 *  Format hour in 24hours format to meridian (AM or PM) format
 * @param {?} hour
 * @param {?} period
 * @return {?}
 */
function formatHourByPeriod(hour, period) {
    switch (period) {
        case NgxMatTimepickerPeriods.AM:
            return hour === 0 ? 12 : hour;
        case NgxMatTimepickerPeriods.PM:
            return hour === 12 ? 12 : hour - 12;
        default:
            return hour;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {number} */
const NgxMatTimepickerUnits = {
    HOUR: 0,
    MINUTE: 1,
};
NgxMatTimepickerUnits[NgxMatTimepickerUnits.HOUR] = "HOUR";
NgxMatTimepickerUnits[NgxMatTimepickerUnits.MINUTE] = "MINUTE";

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
const /** @type {?} */ NGX_MAT_TIMEPICKER_LOCALE = new InjectionToken("TimeLocale", {
    providedIn: "root",
    factory: () => NgxMatTimepickerAdapter.defaultLocale
});

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxMatTimepickerUtils {
    /**
     * @param {?} hours
     * @param {?} config
     * @return {?}
     */
    static disableHours(hours, config) {
        if (config.min || config.max) {
            return hours.map(value => {
                const /** @type {?} */ hour = config.format === 24 ? value.time : NgxMatTimepickerAdapter.formatHour(value.time, config.format, config.period);
                const /** @type {?} */ currentTime = DateTime.fromObject({ hour }).toFormat(NgxMatTimepickerFormat.TWELVE);
                return Object.assign(Object.assign({}, value), { disabled: !NgxMatTimepickerAdapter.isTimeAvailable(currentTime, config.min, config.max, "hours") });
            });
        }
        return hours;
    }
    /**
     * @param {?} minutes
     * @param {?} selectedHour
     * @param {?} config
     * @return {?}
     */
    static disableMinutes(minutes, selectedHour, config) {
        if (config.min || config.max) {
            const /** @type {?} */ hour = NgxMatTimepickerAdapter.formatHour(selectedHour, config.format, config.period);
            return minutes.map(value => {
                const /** @type {?} */ currentTime = DateTime.fromObject({
                    hour,
                    minute: value.time
                }).toFormat(NgxMatTimepickerFormat.TWELVE);
                return Object.assign(Object.assign({}, value), { disabled: !NgxMatTimepickerAdapter.isTimeAvailable(currentTime, config.min, config.max, "minutes") });
            });
        }
        return minutes;
    }
    /**
     * @param {?} format
     * @return {?}
     */
    static getHours(format) {
        return Array(format).fill(1).map((v, i) => {
            const /** @type {?} */ angleStep = 30;
            const /** @type {?} */ time = v + i;
            const /** @type {?} */ angle = angleStep * time;
            return { time: time === 24 ? 0 : time, angle };
        });
    }
    /**
     * @param {?=} gap
     * @return {?}
     */
    static getMinutes(gap = 1) {
        const /** @type {?} */ minutesCount = 60;
        const /** @type {?} */ angleStep = 360 / minutesCount;
        const /** @type {?} */ minutes = [];
        for (let /** @type {?} */ i = 0; i < minutesCount; i++) {
            const /** @type {?} */ angle = angleStep * i;
            if (i % gap === 0) {
                minutes.push({ time: i, angle: angle !== 0 ? angle : 360 });
            }
        }
        return minutes;
    }
    /**
     * @param {?} e
     * @return {?}
     */
    static isDigit(e) {
        // Allow: backspace, delete, tab, escape, enter
        if ([46, 8, 9, 27, 13].some(n => n === e.keyCode) ||
            // Allow: Ctrl/cmd+A
            (e.keyCode == 65 && (e.ctrlKey === true || e.metaKey === true)) ||
            // Allow: Ctrl/cmd+C
            (e.keyCode == 67 && (e.ctrlKey === true || e.metaKey === true)) ||
            // Allow: Ctrl/cmd+X
            (e.keyCode == 88 && (e.ctrlKey === true || e.metaKey === true)) ||
            // Allow: home, end, left, right, up, down
            (e.keyCode >= 35 && e.keyCode <= 40)) {
            return true;
        }
        return !((e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105));
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxMatTimepickerFieldComponent {
    /**
     * @param {?} _timepickerService
     * @param {?} _locale
     */
    constructor(_timepickerService, _locale) {
        this._timepickerService = _timepickerService;
        this._locale = _locale;
        this.maxHour = 12;
        this.minHour = 1;
        this.period = NgxMatTimepickerPeriods.AM;
        this.periods = [
            NgxMatTimepickerPeriods.AM,
            NgxMatTimepickerPeriods.PM
        ];
        this.timeChanged = new EventEmitter();
        this.timeUnit = NgxMatTimepickerUnits;
        this._color = "primary";
        this._floatLabel = "never";
        this._format = 12;
        this._isFirstTimeChange = true;
        this._subsCtrl$ = new Subject();
        this._onChange = () => {
        };
    }
    /**
     * @return {?}
     */
    get color() {
        return this._color;
    }
    /**
     * @param {?} newValue
     * @return {?}
     */
    set color(newValue) {
        this._color = newValue;
    }
    /**
     * @return {?}
     */
    get defaultTime() {
        return this._defaultTime;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    set defaultTime(val) {
        this._defaultTime = val;
        this._isDefaultTime = !!val;
    }
    /**
     * @return {?}
     */
    get floatLabel() {
        return this._floatLabel;
    }
    /**
     * @param {?} newValue
     * @return {?}
     */
    set floatLabel(newValue) {
        this._floatLabel = newValue;
    }
    /**
     * @return {?}
     */
    get format() {
        return this._format;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set format(value) {
        this._format = value === 24 ? 24 : 12;
        this.minHour = this._format === 12 ? 1 : 0;
        this.maxHour = this._format === 12 ? 12 : 23;
        this.hoursList = NgxMatTimepickerUtils.getHours(this._format);
        const /** @type {?} */ isDynamicallyChanged = value && (this._previousFormat && this._previousFormat !== this._format);
        if (isDynamicallyChanged) {
            this._updateTime(this.timepickerTime);
        }
        this._previousFormat = this._format;
    }
    /**
     * @return {?}
     */
    get max() {
        return this._max;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set max(value) {
        if (typeof value === "string") {
            this._max = NgxMatTimepickerAdapter.parseTime(value, { locale: this._locale, format: this.format });
            return;
        }
        this._max = value;
    }
    /**
     * @return {?}
     */
    get min() {
        return this._min;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set min(value) {
        if (typeof value === "string") {
            this._min = NgxMatTimepickerAdapter.parseTime(value, { locale: this._locale, format: this.format });
            return;
        }
        this._min = value;
    }
    /**
     * @param {?} hour
     * @return {?}
     */
    changeHour(hour) {
        this._timepickerService.hour = this.hoursList.find(h => h.time === hour);
        this._changeTime();
    }
    /**
     * @param {?} minute
     * @return {?}
     */
    changeMinute(minute) {
        this._timepickerService.minute = this.minutesList.find(m => m.time === minute);
        this._changeTime();
    }
    /**
     * @param {?} event
     * @return {?}
     */
    changePeriod(event) {
        this._timepickerService.period = event.value;
        this._changeTime();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this._subsCtrl$.next();
        this._subsCtrl$.complete();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this._initTime(this.defaultTime);
        this.hoursList = NgxMatTimepickerUtils.getHours(this._format);
        this.minutesList = NgxMatTimepickerUtils.getMinutes();
        this.isTimeRangeSet = !!(this.min || this.max);
        this.hour$ = this._timepickerService.selectedHour.pipe(tap((clockTime) => this._selectedHour = clockTime.time), map(this._changeDefaultTimeValue.bind(this)), tap(() => this.isTimeRangeSet && this._updateAvailableMinutes()));
        this.minute$ = this._timepickerService.selectedMinute.pipe(map(this._changeDefaultTimeValue.bind(this)), tap(() => this._isFirstTimeChange = false));
        if (this.format === 12) {
            this._timepickerService.selectedPeriod.pipe(distinctUntilChanged(), tap((period) => this.period = period), tap(period => this.isChangePeriodDisabled = this._isPeriodDisabled(period)), takeUntil(this._subsCtrl$)).subscribe(() => this.isTimeRangeSet && this._updateAvailableTime());
        }
    }
    /**
     * @param {?} time
     * @return {?}
     */
    onTimeSet(time) {
        this._updateTime(time);
        this._emitLocalTimeChange(time);
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this._onChange = fn;
    }
    /**
     * @param {?} _fn_
     * @return {?}
     */
    registerOnTouched(_fn_) {
    }
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    /**
     * @param {?} val
     * @return {?}
     */
    writeValue(val) {
        if (val) {
            this._initTime(val);
        }
        else {
            this._resetTime();
        }
    }
    /**
     * @param {?} clockFaceTime
     * @return {?}
     */
    _changeDefaultTimeValue(clockFaceTime) {
        if (!this._isDefaultTime && this._isFirstTimeChange) {
            return Object.assign(Object.assign({}, clockFaceTime), { time: null });
        }
        return clockFaceTime;
    }
    /**
     * @return {?}
     */
    _changeTime() {
        const /** @type {?} */ time = this._timepickerService.getFullTime(this.format);
        this.timepickerTime = time;
        this._emitLocalTimeChange(time);
    }
    /**
     * @param {?} time
     * @return {?}
     */
    _emitLocalTimeChange(time) {
        const /** @type {?} */ localTime = NgxMatTimepickerAdapter.toLocaleTimeString(time, { format: this.format, locale: this._locale });
        this._onChange(localTime);
        this.timeChanged.emit(localTime);
    }
    /**
     * @param {?} time
     * @return {?}
     */
    _initTime(time) {
        const /** @type {?} */ isDefaultTimeAvailable = NgxMatTimepickerAdapter
            .isTimeAvailable(time, this.min, this.max, "minutes", null, this.format);
        if (!isDefaultTimeAvailable) {
            if (this.min) {
                this._updateTime(NgxMatTimepickerAdapter.fromDateTimeToString(this.min, this.format));
                return;
            }
            if (this.max) {
                this._updateTime(NgxMatTimepickerAdapter.fromDateTimeToString(this.max, this.format));
                return;
            }
        }
        this._updateTime(time);
    }
    /**
     * @param {?} period
     * @return {?}
     */
    _isPeriodDisabled(period) {
        return NgxMatTimepickerUtils.disableHours(NgxMatTimepickerUtils.getHours(12), {
            min: this.min,
            max: this.max,
            format: 12,
            period: period === NgxMatTimepickerPeriods.AM ? NgxMatTimepickerPeriods.PM : NgxMatTimepickerPeriods.AM
        }).every(time => time.disabled);
    }
    /**
     * @return {?}
     */
    _resetTime() {
        this._timepickerService.hour = { angle: 0, time: null };
        this._timepickerService.minute = { angle: 0, time: null };
    }
    /**
     * @return {?}
     */
    _updateAvailableHours() {
        this.hoursList = NgxMatTimepickerUtils.disableHours(this.hoursList, {
            min: this.min,
            max: this.max,
            format: this.format,
            period: this.period
        });
    }
    /**
     * @return {?}
     */
    _updateAvailableMinutes() {
        this.minutesList = NgxMatTimepickerUtils.disableMinutes(this.minutesList, this._selectedHour, {
            min: this.min,
            max: this.max,
            format: this.format,
            period: this.period
        });
    }
    /**
     * @return {?}
     */
    _updateAvailableTime() {
        this._updateAvailableHours();
        if (this._selectedHour) {
            this._updateAvailableMinutes();
        }
    }
    /**
     * @param {?} time
     * @return {?}
     */
    _updateTime(time) {
        if (time) {
            const /** @type {?} */ formattedTime = NgxMatTimepickerAdapter.formatTime(time, { locale: this._locale, format: this.format });
            this._timepickerService.setDefaultTimeIfAvailable(formattedTime, this.min, this.max, this.format);
            this.timepickerTime = formattedTime;
        }
    }
}
NgxMatTimepickerFieldComponent.ɵfac = function NgxMatTimepickerFieldComponent_Factory(t) { return new (t || NgxMatTimepickerFieldComponent)(ɵngcc0.ɵɵdirectiveInject(NgxMatTimepickerService), ɵngcc0.ɵɵdirectiveInject(NGX_MAT_TIMEPICKER_LOCALE)); };
NgxMatTimepickerFieldComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxMatTimepickerFieldComponent, selectors: [["ngx-mat-timepicker-field"]], inputs: { color: "color", defaultTime: "defaultTime", floatLabel: "floatLabel", format: "format", max: "max", min: "min", disabled: "disabled", cancelBtnTmpl: "cancelBtnTmpl", clockTheme: "clockTheme", confirmBtnTmpl: "confirmBtnTmpl", controlOnly: "controlOnly", toggleIcon: "toggleIcon" }, outputs: { timeChanged: "timeChanged" }, features: [ɵngcc0.ɵɵProvidersFeature([
            NgxMatTimepickerService,
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: NgxMatTimepickerFieldComponent,
                multi: true
            }
        ])], decls: 14, vars: 38, consts: [[1, "ngx-mat-timepicker", 3, "ngClass"], [1, "ngx-mat-timepicker__control--first", 3, "color", "floatLabel", "placeholder", "time", "min", "max", "timeUnit", "disabled", "timeList", "preventTyping", "timeChanged"], [1, "separator-colon", "ngx-mat-timepicker__control--second"], [1, "ngx-mat-timepicker__control--third", 3, "color", "floatLabel", "placeholder", "time", "min", "max", "timeUnit", "disabled", "timeList", "preventTyping", "timeChanged"], [1, "period-select", "ngx-mat-timepicker__control--forth", 3, "color"], [3, "disabled", "ngModel", "selectionChange", 4, "ngIf"], ["class", "ngx-mat-timepicker__toggle", 3, "for", "disabled", 4, "ngIf"], [3, "color", "min", "max", "theme", "defaultTime", "format", "cancelBtnTmpl", "confirmBtnTmpl", "timeSet"], ["timepicker", ""], ["defaultIcon", ""], [3, "disabled", "ngModel", "selectionChange"], [3, "value", 4, "ngFor", "ngForOf"], [3, "value"], [1, "ngx-mat-timepicker__toggle", 3, "for", "disabled"], ["ngxMatTimepickerToggleIcon", ""], [4, "ngTemplateOutlet"]], template: function NgxMatTimepickerFieldComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "ngx-mat-timepicker-time-control", 1);
        ɵngcc0.ɵɵlistener("timeChanged", function NgxMatTimepickerFieldComponent_Template_ngx_mat_timepicker_time_control_timeChanged_1_listener($event) { return ctx.changeHour($event); });
        ɵngcc0.ɵɵpipe(2, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "span", 2);
        ɵngcc0.ɵɵtext(4, ":");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "ngx-mat-timepicker-time-control", 3);
        ɵngcc0.ɵɵlistener("timeChanged", function NgxMatTimepickerFieldComponent_Template_ngx_mat_timepicker_time_control_timeChanged_5_listener($event) { return ctx.changeMinute($event); });
        ɵngcc0.ɵɵpipe(6, "async");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "mat-form-field", 4);
        ɵngcc0.ɵɵtemplate(8, NgxMatTimepickerFieldComponent_mat_select_8_Template, 2, 3, "mat-select", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, NgxMatTimepickerFieldComponent_ngx_mat_timepicker_toggle_9_Template, 3, 3, "ngx-mat-timepicker-toggle", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "ngx-mat-timepicker", 7, 8);
        ɵngcc0.ɵɵlistener("timeSet", function NgxMatTimepickerFieldComponent_Template_ngx_mat_timepicker_timeSet_10_listener($event) { return ctx.onTimeSet($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(12, NgxMatTimepickerFieldComponent_ng_template_12_Template, 2, 0, "ng-template", null, 9, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        let tmp_4_0;
        let tmp_14_0;
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(36, _c0, ctx.disabled));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("color", ctx.color)("floatLabel", ctx.floatLabel)("placeholder", "HH")("time", (tmp_4_0 = ɵngcc0.ɵɵpipeBind1(2, 32, ctx.hour$)) == null ? null : tmp_4_0.time)("min", ctx.minHour)("max", ctx.maxHour)("timeUnit", ctx.timeUnit.HOUR)("disabled", ctx.disabled)("timeList", ctx.hoursList)("preventTyping", ctx.isTimeRangeSet);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("color", ctx.color)("floatLabel", ctx.floatLabel)("placeholder", "MM")("time", (tmp_14_0 = ɵngcc0.ɵɵpipeBind1(6, 34, ctx.minute$)) == null ? null : tmp_14_0.time)("min", 0)("max", 59)("timeUnit", ctx.timeUnit.MINUTE)("disabled", ctx.disabled)("timeList", ctx.minutesList)("preventTyping", ctx.isTimeRangeSet);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("color", ctx.color);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.format !== 24);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.controlOnly);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("color", ctx.color)("min", ctx.min)("max", ctx.max)("theme", ctx.clockTheme)("defaultTime", ctx.timepickerTime)("format", ctx.format)("cancelBtnTmpl", ctx.cancelBtnTmpl)("confirmBtnTmpl", ctx.confirmBtnTmpl);
    } }, dependencies: function () { return [ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc2.NgControlStatus, ɵngcc2.NgModel, ɵngcc3.MatFormField, ɵngcc4.MatSelect, ɵngcc5.MatOption, ɵngcc6.MatIcon, NgxMatTimepickerComponent, NgxMatTimepickerToggleComponent, NgxMatTimepickerToggleIconDirective, NgxMatTimepickerControlComponent, ɵngcc1.AsyncPipe]; }, styles: [".ngx-mat-timepicker{align-items:center;display:flex;height:100%}.ngx-mat-timepicker--disabled{background:rgba(0,0,0,.07);pointer-events:none}.ngx-mat-timepicker .separator-colon{margin-left:5px;margin-right:5px}.ngx-mat-timepicker .period-select{margin-left:8px;min-width:60px;text-align:center;width:60px}.ngx-mat-timepicker__control--first{order:1}.ngx-mat-timepicker__control--second{order:2}.ngx-mat-timepicker__control--third{order:3}.ngx-mat-timepicker__control--forth,.ngx-mat-timepicker__toggle{order:4}"], encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
NgxMatTimepickerFieldComponent.ctorParameters = () => [
    { type: NgxMatTimepickerService },
    { type: String, decorators: [{ type: Inject, args: [NGX_MAT_TIMEPICKER_LOCALE,] }] }
];
NgxMatTimepickerFieldComponent.propDecorators = {
    color: [{ type: Input }],
    defaultTime: [{ type: Input }],
    floatLabel: [{ type: Input }],
    format: [{ type: Input }],
    max: [{ type: Input }],
    min: [{ type: Input }],
    cancelBtnTmpl: [{ type: Input }],
    clockTheme: [{ type: Input }],
    confirmBtnTmpl: [{ type: Input }],
    controlOnly: [{ type: Input }],
    disabled: [{ type: Input }],
    timeChanged: [{ type: Output }],
    toggleIcon: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepickerFieldComponent, [{
        type: Component,
        args: [{ selector: "ngx-mat-timepicker-field", template: "<div class=\"ngx-mat-timepicker\"\r\n     [ngClass]=\"{'ngx-mat-timepicker--disabled': disabled}\">\r\n    <ngx-mat-timepicker-time-control\r\n            class=\"ngx-mat-timepicker__control--first\"\r\n            [color]=\"color\"\r\n            [floatLabel]=\"floatLabel\"\r\n            [placeholder]=\"'HH'\"\r\n            [time]=\"(hour$ | async)?.time\"\r\n            [min]=\"minHour\"\r\n            [max]=\"maxHour\"\r\n            [timeUnit]=\"timeUnit.HOUR\"\r\n            [disabled]=\"disabled\"\r\n            [timeList]=\"hoursList\"\r\n            [preventTyping]=\"isTimeRangeSet\"\r\n            (timeChanged)=\"changeHour($event)\"></ngx-mat-timepicker-time-control>\r\n    <span class=\"separator-colon ngx-mat-timepicker__control--second\">:</span>\r\n    <ngx-mat-timepicker-time-control\r\n            class=\"ngx-mat-timepicker__control--third\"\r\n            [color]=\"color\"\r\n            [floatLabel]=\"floatLabel\"\r\n            [placeholder]=\"'MM'\"\r\n            [time]=\"(minute$ | async)?.time\"\r\n            [min]=\"0\"\r\n            [max]=\"59\"\r\n            [timeUnit]=\"timeUnit.MINUTE\"\r\n            [disabled]=\"disabled\"\r\n            [timeList]=\"minutesList\"\r\n            [preventTyping]=\"isTimeRangeSet\"\r\n            (timeChanged)=\"changeMinute($event)\"></ngx-mat-timepicker-time-control>\r\n    <mat-form-field class=\"period-select ngx-mat-timepicker__control--forth\"\r\n                    [color]=\"color\">\r\n        <mat-select [disabled]=\"disabled || isChangePeriodDisabled\"\r\n                    *ngIf=\"format !== 24\"\r\n                    (selectionChange)=\"changePeriod($event)\"\r\n                    [ngModel]=\"period\">\r\n            <mat-option *ngFor=\"let option of periods\"\r\n                        [value]=\"option\">{{option}}</mat-option>\r\n        </mat-select>\r\n    </mat-form-field>\r\n    <ngx-mat-timepicker-toggle\r\n            class=\"ngx-mat-timepicker__toggle\"\r\n            *ngIf=\"!controlOnly\"\r\n            [for]=\"timepicker\"\r\n            [disabled]=\"disabled\">\r\n        <span ngxMatTimepickerToggleIcon>\r\n            <ng-container *ngTemplateOutlet=\"toggleIcon || defaultIcon\"></ng-container>\r\n        </span>\r\n    </ngx-mat-timepicker-toggle>\r\n</div>\r\n<ngx-mat-timepicker\r\n        [color]=\"color\"\r\n        [min]=\"min\"\r\n        [max]=\"max\"\r\n        [theme]=\"clockTheme\"\r\n        [defaultTime]=\"timepickerTime\"\r\n        [format]=\"format\"\r\n        [cancelBtnTmpl]=\"cancelBtnTmpl\"\r\n        [confirmBtnTmpl]=\"confirmBtnTmpl\"\r\n        (timeSet)=\"onTimeSet($event)\"\r\n        #timepicker></ngx-mat-timepicker>\r\n\r\n<ng-template #defaultIcon>\r\n    <mat-icon>watch_later</mat-icon>\r\n</ng-template>\r\n", providers: [
                    NgxMatTimepickerService,
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: NgxMatTimepickerFieldComponent,
                        multi: true
                    }
                ], changeDetection: ChangeDetectionStrategy.OnPush, encapsulation: ViewEncapsulation.None, styles: [".ngx-mat-timepicker{align-items:center;display:flex;height:100%}.ngx-mat-timepicker--disabled{background:rgba(0,0,0,.07);pointer-events:none}.ngx-mat-timepicker .separator-colon{margin-left:5px;margin-right:5px}.ngx-mat-timepicker .period-select{margin-left:8px;min-width:60px;text-align:center;width:60px}.ngx-mat-timepicker__control--first{order:1}.ngx-mat-timepicker__control--second{order:2}.ngx-mat-timepicker__control--third{order:3}.ngx-mat-timepicker__control--forth,.ngx-mat-timepicker__toggle{order:4}"] }]
    }], function () { return [{ type: NgxMatTimepickerService }, { type: String, decorators: [{
                type: Inject,
                args: [NGX_MAT_TIMEPICKER_LOCALE]
            }] }]; }, { timeChanged: [{
            type: Output
        }], color: [{
            type: Input
        }], defaultTime: [{
            type: Input
        }], floatLabel: [{
            type: Input
        }], format: [{
            type: Input
        }], max: [{
            type: Input
        }], min: [{
            type: Input
        }], disabled: [{
            type: Input
        }], cancelBtnTmpl: [{
            type: Input
        }], clockTheme: [{
            type: Input
        }], confirmBtnTmpl: [{
            type: Input
        }], controlOnly: [{
            type: Input
        }], toggleIcon: [{
            type: Input
        }] }); })();
function NgxMatTimepickerFieldComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype.cancelBtnTmpl;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype.clockTheme;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype.confirmBtnTmpl;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype.controlOnly;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype.disabled;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype.hour$;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype.hoursList;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype.isChangePeriodDisabled;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype.isTimeRangeSet;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype.maxHour;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype.minHour;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype.minute$;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype.minutesList;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype.period;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype.periods;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype.timeChanged;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype.timepickerTime;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype.timeUnit;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype.toggleIcon;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype._color;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype._defaultTime;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype._floatLabel;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype._format;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype._isDefaultTime;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype._isFirstTimeChange;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype._max;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype._min;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype._previousFormat;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype._selectedHour;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype._subsCtrl$;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype._onChange;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype._timepickerService;
    /** @type {?} */
    NgxMatTimepickerFieldComponent.prototype._locale;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxMatTimepickerToggleIconDirective {
}
NgxMatTimepickerToggleIconDirective.ɵfac = function NgxMatTimepickerToggleIconDirective_Factory(t) { return new (t || NgxMatTimepickerToggleIconDirective)(); };
NgxMatTimepickerToggleIconDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgxMatTimepickerToggleIconDirective, selectors: [["", "ngxMatTimepickerToggleIcon", ""]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepickerToggleIconDirective, [{
        type: Directive,
        args: [{ selector: "[ngxMatTimepickerToggleIcon]" }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxMatTimepickerEventService {
    constructor() {
        this._backdropClick$ = new Subject();
        this._keydownEvent$ = new Subject();
    }
    /**
     * @return {?}
     */
    get backdropClick() {
        return this._backdropClick$.asObservable().pipe(shareReplay({ bufferSize: 1, refCount: true }));
    }
    /**
     * @return {?}
     */
    get keydownEvent() {
        return this._keydownEvent$.asObservable().pipe(shareReplay({ bufferSize: 1, refCount: true }));
    }
    /**
     * @param {?} event
     * @return {?}
     */
    dispatchEvent(event) {
        switch (event.type) {
            case "click":
                this._backdropClick$.next(event);
                break;
            case "keydown":
                this._keydownEvent$.next(event);
                break;
            default:
                throw new Error("no such event type");
        }
    }
}
NgxMatTimepickerEventService.ɵfac = function NgxMatTimepickerEventService_Factory(t) { return new (t || NgxMatTimepickerEventService)(); };
/** @nocollapse */
NgxMatTimepickerEventService.ctorParameters = () => [];
/** @nocollapse */ NgxMatTimepickerEventService.ɵprov = ɵɵdefineInjectable({ factory: function NgxMatTimepickerEventService_Factory() { return new NgxMatTimepickerEventService(); }, token: NgxMatTimepickerEventService, providedIn: "root" });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepickerEventService, [{
        type: Injectable,
        args: [{
                providedIn: "root"
            }]
    }], function () { return []; }, null); })();
function NgxMatTimepickerEventService_tsickle_Closure_declarations() {
    /** @type {?} */
    NgxMatTimepickerEventService.prototype._backdropClick$;
    /** @type {?} */
    NgxMatTimepickerEventService.prototype._keydownEvent$;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
const /** @type {?} */ NGX_MAT_TIMEPICKER_CONFIG = new InjectionToken("NGX_MAT_TIMEPICKER_CONFIG");
/**
 * @param {?} config
 * @return {?}
 */
function provideNgxMatTimepickerOptions(config) {
    return [
        { provide: NGX_MAT_TIMEPICKER_CONFIG, useValue: config },
    ];
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxMatTimepickerBaseDirective {
    /**
     * @param {?} _timepickerSrv
     * @param {?} _eventSrv
     * @param {?} _locale
     * @param {?} data
     */
    constructor(_timepickerSrv, _eventSrv, _locale, data) {
        this._timepickerSrv = _timepickerSrv;
        this._eventSrv = _eventSrv;
        this._locale = _locale;
        this.data = data;
        this.activeTimeUnit = NgxMatTimepickerUnits.HOUR;
        this.timeUnit = NgxMatTimepickerUnits;
        this._color = "primary";
        this._subsCtrl$ = new Subject();
        this.color = data.color;
        this.defaultTime = data.defaultTime;
    }
    /**
     * @param {?} newValue
     * @return {?}
     */
    set color(newValue) {
        this._color = newValue;
    }
    /**
     * @return {?}
     */
    get color() {
        return this._color;
    }
    /**
     * @return {?}
     */
    get defaultTime() {
        return this._defaultTime;
    }
    /**
     * @param {?} time
     * @return {?}
     */
    set defaultTime(time) {
        this._defaultTime = time;
        this._setDefaultTime(time);
    }
    /**
     * @param {?} period
     * @return {?}
     */
    changePeriod(period) {
        this._timepickerSrv.period = period;
        this._onTimeChange();
    }
    /**
     * @param {?} unit
     * @return {?}
     */
    changeTimeUnit(unit) {
        this.activeTimeUnit = unit;
    }
    /**
     * @return {?}
     */
    close() {
        this.data.timepickerBaseRef.close();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this._subsCtrl$.next();
        this._subsCtrl$.complete();
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this._defineTime();
        this.selectedHour = this._timepickerSrv.selectedHour
            .pipe(shareReplay({ bufferSize: 1, refCount: true }));
        this.selectedMinute = this._timepickerSrv.selectedMinute
            .pipe(shareReplay({ bufferSize: 1, refCount: true }));
        this.selectedPeriod = this._timepickerSrv.selectedPeriod
            .pipe(shareReplay({ bufferSize: 1, refCount: true }));
        this.data.timepickerBaseRef.timeUpdated.pipe(takeUntil(this._subsCtrl$))
            .subscribe(this._setDefaultTime.bind(this));
    }
    /**
     * @param {?} hour
     * @return {?}
     */
    onHourChange(hour) {
        this._timepickerSrv.hour = hour;
        this._onTimeChange();
    }
    /**
     * @param {?} hour
     * @return {?}
     */
    onHourSelected(hour) {
        if (!this.data.hoursOnly) {
            this.changeTimeUnit(NgxMatTimepickerUnits.MINUTE);
        }
        this.data.timepickerBaseRef.hourSelected.next(hour);
    }
    /**
     * @param {?} e
     * @return {?}
     */
    onKeydown(e) {
        this._eventSrv.dispatchEvent(e);
        e.stopPropagation();
    }
    /**
     * @param {?} minute
     * @return {?}
     */
    onMinuteChange(minute) {
        this._timepickerSrv.minute = minute;
        this._onTimeChange();
    }
    /**
     * @return {?}
     */
    setTime() {
        this.data.timepickerBaseRef.timeSet.next(this._timepickerSrv.getFullTime(this.data.format));
        this.close();
    }
    /**
     * @return {?}
     */
    _defineTime() {
        const /** @type {?} */ minTime = this.data.minTime;
        if (minTime && (!this.data.time && !this.data.defaultTime)) {
            const /** @type {?} */ time = NgxMatTimepickerAdapter.fromDateTimeToString(minTime, this.data.format);
            this._setDefaultTime(time);
        }
    }
    /**
     * @return {?}
     */
    _onTimeChange() {
        const /** @type {?} */ time = NgxMatTimepickerAdapter.toLocaleTimeString(this._timepickerSrv.getFullTime(this.data.format), {
            locale: this._locale,
            format: this.data.format
        });
        this.data.timepickerBaseRef.timeChanged.emit(time);
    }
    /**
     * @param {?} time
     * @return {?}
     */
    _setDefaultTime(time) {
        this._timepickerSrv.setDefaultTimeIfAvailable(time, this.data.minTime, this.data.maxTime, this.data.format, this.data.minutesGap);
    }
}
NgxMatTimepickerBaseDirective.ɵfac = function NgxMatTimepickerBaseDirective_Factory(t) { return new (t || NgxMatTimepickerBaseDirective)(ɵngcc0.ɵɵdirectiveInject(NgxMatTimepickerService), ɵngcc0.ɵɵdirectiveInject(NgxMatTimepickerEventService), ɵngcc0.ɵɵdirectiveInject(NGX_MAT_TIMEPICKER_LOCALE), ɵngcc0.ɵɵdirectiveInject(NGX_MAT_TIMEPICKER_CONFIG, 8)); };
NgxMatTimepickerBaseDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgxMatTimepickerBaseDirective, selectors: [["", "ngxMatTimepickerBase", ""]], hostBindings: function NgxMatTimepickerBaseDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("keydown", function NgxMatTimepickerBaseDirective_keydown_HostBindingHandler($event) { return ctx.onKeydown($event); });
    } }, inputs: { color: "color", defaultTime: "defaultTime" } });
/** @nocollapse */
NgxMatTimepickerBaseDirective.ctorParameters = () => [
    { type: NgxMatTimepickerService },
    { type: NgxMatTimepickerEventService },
    { type: String, decorators: [{ type: Inject, args: [NGX_MAT_TIMEPICKER_LOCALE,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [NGX_MAT_TIMEPICKER_CONFIG,] }, { type: Optional }] }
];
NgxMatTimepickerBaseDirective.propDecorators = {
    color: [{ type: Input }],
    defaultTime: [{ type: Input }],
    onKeydown: [{ type: HostListener, args: ["keydown", ["$event"],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepickerBaseDirective, [{
        type: Directive,
        args: [{
                selector: "[ngxMatTimepickerBase]"
            }]
    }], function () { return [{ type: NgxMatTimepickerService }, { type: NgxMatTimepickerEventService }, { type: String, decorators: [{
                type: Inject,
                args: [NGX_MAT_TIMEPICKER_LOCALE]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [NGX_MAT_TIMEPICKER_CONFIG]
            }, {
                type: Optional
            }] }]; }, { color: [{
            type: Input
        }], defaultTime: [{
            type: Input
        }], 
    /**
     * @param {?} e
     * @return {?}
     */
    onKeydown: [{
            type: HostListener,
            args: ["keydown", ["$event"]]
        }] }); })();
function NgxMatTimepickerBaseDirective_tsickle_Closure_declarations() {
    /** @type {?} */
    NgxMatTimepickerBaseDirective.prototype.activeTimeUnit;
    /** @type {?} */
    NgxMatTimepickerBaseDirective.prototype.selectedHour;
    /** @type {?} */
    NgxMatTimepickerBaseDirective.prototype.selectedMinute;
    /** @type {?} */
    NgxMatTimepickerBaseDirective.prototype.selectedPeriod;
    /** @type {?} */
    NgxMatTimepickerBaseDirective.prototype.timeUnit;
    /** @type {?} */
    NgxMatTimepickerBaseDirective.prototype._color;
    /** @type {?} */
    NgxMatTimepickerBaseDirective.prototype._defaultTime;
    /** @type {?} */
    NgxMatTimepickerBaseDirective.prototype._subsCtrl$;
    /** @type {?} */
    NgxMatTimepickerBaseDirective.prototype._timepickerSrv;
    /** @type {?} */
    NgxMatTimepickerBaseDirective.prototype._eventSrv;
    /** @type {?} */
    NgxMatTimepickerBaseDirective.prototype._locale;
    /** @type {?} */
    NgxMatTimepickerBaseDirective.prototype.data;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxMatTimepickerDialogComponent extends NgxMatTimepickerBaseDirective {
    /**
     * @param {?} data
     * @param {?} _dialogRef
     * @param {?} timepickerSrv
     * @param {?} eventSrv
     * @param {?} locale
     */
    constructor(data, _dialogRef, timepickerSrv, eventSrv, locale) {
        super(timepickerSrv, eventSrv, locale, data);
        this.data = data;
        this._dialogRef = _dialogRef;
    }
    /**
     * @return {?}
     */
    close() {
        this._dialogRef.close();
    }
}
NgxMatTimepickerDialogComponent.ɵfac = function NgxMatTimepickerDialogComponent_Factory(t) { return new (t || NgxMatTimepickerDialogComponent)(ɵngcc0.ɵɵdirectiveInject(MAT_DIALOG_DATA), ɵngcc0.ɵɵdirectiveInject(ɵngcc7.MatDialogRef), ɵngcc0.ɵɵdirectiveInject(NgxMatTimepickerService), ɵngcc0.ɵɵdirectiveInject(NgxMatTimepickerEventService), ɵngcc0.ɵɵdirectiveInject(NGX_MAT_TIMEPICKER_LOCALE)); };
NgxMatTimepickerDialogComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxMatTimepickerDialogComponent, selectors: [["ngx-mat-timepicker-dialog"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 21, vars: 30, consts: [["cancelBtnDefault", ""], ["confirmBtnDefault", ""], ["mat-dialog-content", ""], ["cdkTrapFocus", "", "cdkTrapFocusAutoCapture", "", 3, "appendToInput", "inputElement", "ngxMatTimepickerTheme"], [1, "timepicker", 3, "ngClass"], [1, "timepicker-header", 3, "color"], [3, "color", "format", "hour", "minute", "period", "activeTimeUnit", "minTime", "maxTime", "isEditable", "editableHintTmpl", "minutesGap", "hoursOnly", "periodChanged", "timeUnitChanged", "hourChanged", "minuteChanged"], [1, "timepicker__main-content"], [1, "timepicker__body", 3, "ngSwitch"], [4, "ngSwitchCase"], [3, "color", "selectedMinute", "selectedHour", "minTime", "maxTime", "format", "period", "minutesGap", "minuteChange", 4, "ngSwitchCase"], ["mat-dialog-actions", ""], [3, "click"], [4, "ngTemplateOutlet"], ["mat-button", "", 3, "color"], [3, "color", "selectedHour", "minTime", "maxTime", "format", "hourChange", "hourSelected", 4, "ngIf", "ngIfElse"], ["ampmHours", ""], [3, "color", "selectedHour", "minTime", "maxTime", "format", "hourChange", "hourSelected"], [3, "color", "selectedHour", "period", "minTime", "maxTime", "hourChange", "hourSelected"], [3, "color", "selectedMinute", "selectedHour", "minTime", "maxTime", "format", "period", "minutesGap", "minuteChange"]], template: function NgxMatTimepickerDialogComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, NgxMatTimepickerDialogComponent_ng_template_0_Template, 2, 1, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(2, NgxMatTimepickerDialogComponent_ng_template_2_Template, 2, 1, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementStart(4, "div", 2)(5, "ngx-mat-timepicker-content", 3)(6, "div", 4)(7, "mat-toolbar", 5)(8, "ngx-mat-timepicker-dial", 6);
        ɵngcc0.ɵɵlistener("periodChanged", function NgxMatTimepickerDialogComponent_Template_ngx_mat_timepicker_dial_periodChanged_8_listener($event) { return ctx.changePeriod($event); })("timeUnitChanged", function NgxMatTimepickerDialogComponent_Template_ngx_mat_timepicker_dial_timeUnitChanged_8_listener($event) { return ctx.changeTimeUnit($event); })("hourChanged", function NgxMatTimepickerDialogComponent_Template_ngx_mat_timepicker_dial_hourChanged_8_listener($event) { return ctx.onHourChange($event); })("minuteChanged", function NgxMatTimepickerDialogComponent_Template_ngx_mat_timepicker_dial_minuteChanged_8_listener($event) { return ctx.onMinuteChange($event); });
        ɵngcc0.ɵɵpipe(9, "async");
        ɵngcc0.ɵɵpipe(10, "async");
        ɵngcc0.ɵɵpipe(11, "async");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(12, "div", 7)(13, "div", 8);
        ɵngcc0.ɵɵtemplate(14, NgxMatTimepickerDialogComponent_div_14_Template, 4, 2, "div", 9);
        ɵngcc0.ɵɵtemplate(15, NgxMatTimepickerDialogComponent_ngx_mat_timepicker_minutes_face_15_Template, 4, 14, "ngx-mat-timepicker-minutes-face", 10);
        ɵngcc0.ɵɵelementEnd()()()()();
        ɵngcc0.ɵɵelementStart(16, "div", 11)(17, "div", 12);
        ɵngcc0.ɵɵlistener("click", function NgxMatTimepickerDialogComponent_Template_div_click_17_listener() { return ctx.close(); });
        ɵngcc0.ɵɵtemplate(18, NgxMatTimepickerDialogComponent_ng_container_18_Template, 1, 0, "ng-container", 13);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(19, "div", 12);
        ɵngcc0.ɵɵlistener("click", function NgxMatTimepickerDialogComponent_Template_div_click_19_listener() { return ctx.setTime(); });
        ɵngcc0.ɵɵtemplate(20, NgxMatTimepickerDialogComponent_ng_container_20_Template, 1, 0, "ng-container", 13);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(1);
        const _r2 = ɵngcc0.ɵɵreference(3);
        let tmp_8_0;
        let tmp_9_0;
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("appendToInput", ctx.data.appendToInput)("inputElement", ctx.data.inputElement)("ngxMatTimepickerTheme", ctx.data.theme);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.data.timepickerClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("is-editable", ctx.data.enableKeyboardInput);
        ɵngcc0.ɵɵproperty("color", ctx.color);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("color", ctx.color)("format", ctx.data.format)("hour", (tmp_8_0 = ɵngcc0.ɵɵpipeBind1(9, 24, ctx.selectedHour)) == null ? null : tmp_8_0.time)("minute", (tmp_9_0 = ɵngcc0.ɵɵpipeBind1(10, 26, ctx.selectedMinute)) == null ? null : tmp_9_0.time)("period", ɵngcc0.ɵɵpipeBind1(11, 28, ctx.selectedPeriod))("activeTimeUnit", ctx.activeTimeUnit)("minTime", ctx.data.minTime)("maxTime", ctx.data.maxTime)("isEditable", ctx.data.enableKeyboardInput)("editableHintTmpl", ctx.data.editableHintTmpl)("minutesGap", ctx.data.minutesGap)("hoursOnly", ctx.data.hoursOnly);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.activeTimeUnit);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.timeUnit.HOUR);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.timeUnit.MINUTE);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.data.cancelBtnTmpl ? ctx.data.cancelBtnTmpl : _r0);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.data.confirmBtnTmpl ? ctx.data.confirmBtnTmpl : _r2);
    } }, dependencies: function () { return [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase, ɵngcc8.CdkTrapFocus, ɵngcc9.MatButton, ɵngcc7.MatDialogContent, ɵngcc7.MatDialogActions, ɵngcc10.MatToolbar, NgxMatTimepickerDialComponent, NgxMatTimepickerMinutesFaceComponent, NgxMatTimepicker12HoursFaceComponent, NgxMatTimepicker24HoursFaceComponent, NgxMatTimepickerThemeDirective, NgxMatTimepickerContentComponent, ɵngcc1.AsyncPipe]; }, styles: ["div.ngx-mat-timepicker-dialog>mat-dialog-container.mat-dialog-container{padding-top:0}div.ngx-mat-timepicker-dialog>mat-dialog-container.mat-dialog-container .mat-dialog-content{max-height:85vh;padding:0}div.ngx-mat-timepicker-dialog>mat-dialog-container.mat-dialog-container .mat-dialog-content mat-toolbar.timepicker-header{align-items:center;display:flex;justify-content:center}div.ngx-mat-timepicker-dialog>mat-dialog-container.mat-dialog-container .mat-dialog-content mat-toolbar.timepicker-header.is-editable{height:auto}div.ngx-mat-timepicker-dialog>mat-dialog-container.mat-dialog-container .mat-dialog-content .clock-face{margin:16px}div.ngx-mat-timepicker-dialog>mat-dialog-container.mat-dialog-container div[mat-dialog-actions]{display:flex;justify-content:flex-end}"], encapsulation: 2 });
/** @nocollapse */
NgxMatTimepickerDialogComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [MAT_DIALOG_DATA,] }] },
    { type: MatDialogRef },
    { type: NgxMatTimepickerService },
    { type: NgxMatTimepickerEventService },
    { type: String, decorators: [{ type: Inject, args: [NGX_MAT_TIMEPICKER_LOCALE,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepickerDialogComponent, [{
        type: Component,
        args: [{ selector: "ngx-mat-timepicker-dialog", template: "<ng-template #cancelBtnDefault>\r\n    <button mat-button\r\n            [color]=\"color\">CANCEL\r\n    </button>\r\n</ng-template>\r\n<ng-template #confirmBtnDefault>\r\n    <button mat-button\r\n            [color]=\"color\">OK\r\n    </button>\r\n</ng-template>\r\n<div mat-dialog-content>\r\n    <ngx-mat-timepicker-content [appendToInput]=\"data.appendToInput\"\r\n                                [inputElement]=\"data.inputElement\"\r\n                                [ngxMatTimepickerTheme]=\"data.theme\"\r\n                                cdkTrapFocus\r\n                                cdkTrapFocusAutoCapture>\r\n        <div class=\"timepicker\"\r\n             [ngClass]=\"data.timepickerClass\">\r\n            <mat-toolbar [color]=\"color\"\r\n                         [class.is-editable]=\"data.enableKeyboardInput\"\r\n                         class=\"timepicker-header\">\r\n                <ngx-mat-timepicker-dial [color]=\"color\"\r\n                                         [format]=\"data.format\"\r\n                                         [hour]=\"(selectedHour | async)?.time\"\r\n                                         [minute]=\"(selectedMinute | async)?.time\"\r\n                                         [period]=\"selectedPeriod | async\"\r\n                                         [activeTimeUnit]=\"activeTimeUnit\"\r\n                                         [minTime]=\"data.minTime\"\r\n                                         [maxTime]=\"data.maxTime\"\r\n                                         [isEditable]=\"data.enableKeyboardInput\"\r\n                                         [editableHintTmpl]=\"data.editableHintTmpl\"\r\n                                         [minutesGap]=\"data.minutesGap\"\r\n                                         [hoursOnly]=\"data.hoursOnly\"\r\n                                         (periodChanged)=\"changePeriod($event)\"\r\n                                         (timeUnitChanged)=\"changeTimeUnit($event)\"\r\n                                         (hourChanged)=\"onHourChange($event)\"\r\n                                         (minuteChanged)=\"onMinuteChange($event)\"\r\n                ></ngx-mat-timepicker-dial>\r\n            </mat-toolbar>\r\n            <div class=\"timepicker__main-content\">\r\n                <div class=\"timepicker__body\"\r\n                     [ngSwitch]=\"activeTimeUnit\">\r\n                    <div *ngSwitchCase=\"timeUnit.HOUR\">\r\n                        <ngx-mat-timepicker-24-hours-face *ngIf=\"data.format === 24;else ampmHours\"\r\n                                                          [color]=\"color\"\r\n                                                          (hourChange)=\"onHourChange($event)\"\r\n                                                          [selectedHour]=\"selectedHour | async\"\r\n                                                          [minTime]=\"data.minTime\"\r\n                                                          [maxTime]=\"data.maxTime\"\r\n                                                          [format]=\"data.format\"\r\n                                                          (hourSelected)=\"onHourSelected($event)\"></ngx-mat-timepicker-24-hours-face>\r\n                        <ng-template #ampmHours>\r\n                            <ngx-mat-timepicker-12-hours-face\r\n                                    [color]=\"color\"\r\n                                    (hourChange)=\"onHourChange($event)\"\r\n                                    [selectedHour]=\"selectedHour | async\"\r\n                                    [period]=\"selectedPeriod | async\"\r\n                                    [minTime]=\"data.minTime\"\r\n                                    [maxTime]=\"data.maxTime\"\r\n                                    (hourSelected)=\"onHourSelected($event)\"></ngx-mat-timepicker-12-hours-face>\r\n                        </ng-template>\r\n                    </div>\r\n                    <ngx-mat-timepicker-minutes-face *ngSwitchCase=\"timeUnit.MINUTE\"\r\n                                                     [color]=\"color\"\r\n                                                     [selectedMinute]=\"selectedMinute | async\"\r\n                                                     [selectedHour]=\"(selectedHour | async)?.time\"\r\n                                                     [minTime]=\"data.minTime\"\r\n                                                     [maxTime]=\"data.maxTime\"\r\n                                                     [format]=\"data.format\"\r\n                                                     [period]=\"selectedPeriod | async\"\r\n                                                     [minutesGap]=\"data.minutesGap\"\r\n                                                     (minuteChange)=\"onMinuteChange($event)\"></ngx-mat-timepicker-minutes-face>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </ngx-mat-timepicker-content>\r\n</div>\r\n<div mat-dialog-actions>\r\n    <div (click)=\"close()\">\r\n        <ng-container\r\n                *ngTemplateOutlet=\"data.cancelBtnTmpl ? data.cancelBtnTmpl : cancelBtnDefault\"></ng-container>\r\n    </div>\r\n    <div (click)=\"setTime()\">\r\n        <ng-container\r\n                *ngTemplateOutlet=\"data.confirmBtnTmpl ? data.confirmBtnTmpl : confirmBtnDefault\"></ng-container>\r\n    </div>\r\n</div>\r\n", encapsulation: ViewEncapsulation.None, styles: ["div.ngx-mat-timepicker-dialog>mat-dialog-container.mat-dialog-container{padding-top:0}div.ngx-mat-timepicker-dialog>mat-dialog-container.mat-dialog-container .mat-dialog-content{max-height:85vh;padding:0}div.ngx-mat-timepicker-dialog>mat-dialog-container.mat-dialog-container .mat-dialog-content mat-toolbar.timepicker-header{align-items:center;display:flex;justify-content:center}div.ngx-mat-timepicker-dialog>mat-dialog-container.mat-dialog-container .mat-dialog-content mat-toolbar.timepicker-header.is-editable{height:auto}div.ngx-mat-timepicker-dialog>mat-dialog-container.mat-dialog-container .mat-dialog-content .clock-face{margin:16px}div.ngx-mat-timepicker-dialog>mat-dialog-container.mat-dialog-container div[mat-dialog-actions]{display:flex;justify-content:flex-end}"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [MAT_DIALOG_DATA]
            }] }, { type: ɵngcc7.MatDialogRef }, { type: NgxMatTimepickerService }, { type: NgxMatTimepickerEventService }, { type: String, decorators: [{
                type: Inject,
                args: [NGX_MAT_TIMEPICKER_LOCALE]
            }] }]; }, null); })();
function NgxMatTimepickerDialogComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    NgxMatTimepickerDialogComponent.prototype.data;
    /** @type {?} */
    NgxMatTimepickerDialogComponent.prototype._dialogRef;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
let /** @type {?} */ config;
class NgxMatTimepickerComponent {
    /**
     * @param {?} _vcr
     * @param {?} _eventService
     * @param {?} _dialog
     * @param {?} _overlay
     */
    constructor(_vcr, _eventService, _dialog, _overlay) {
        this._vcr = _vcr;
        this._eventService = _eventService;
        this._dialog = _dialog;
        this._overlay = _overlay;
        this.closed = new EventEmitter();
        this.hourSelected = new EventEmitter();
        this.hoursOnly = false;
        this.id = `ngx_mat_timepicker_${++NgxMatTimepickerComponent.nextId}`;
        this.isEsc = !0;
        this.opened = new EventEmitter();
        this.overlayPositions = [
            {
                originX: "center",
                originY: "bottom",
                overlayX: "center",
                overlayY: "top",
                offsetY: 0
            },
            {
                originX: "center",
                originY: "top",
                overlayX: "center",
                overlayY: "bottom",
                offsetY: 0
            }
        ];
        this.showPicker = !1;
        this.timeChanged = new EventEmitter();
        this.timeSet = new EventEmitter();
        this.timeUpdated = new Subject();
        this._color = "primary";
        this._enableKeyboardInput = false;
    }
    /**
     * @param {?} newValue
     * @return {?}
     */
    set color(newValue) {
        this._color = newValue;
    }
    /**
     * @return {?}
     */
    get color() {
        return this._color;
    }
    /**
     * @return {?}
     */
    get disabled() {
        return this._timepickerInput && this._timepickerInput.disabled;
    }
    /**
     * @param {?} newValue
     * @return {?}
     */
    set enableKeyboardInput(newValue) {
        this._enableKeyboardInput = coerceBooleanProperty(newValue);
    }
    /**
     * @return {?}
     */
    get enableKeyboardInput() {
        return this._enableKeyboardInput;
    }
    /**
     * @return {?}
     */
    get format() {
        return this._timepickerInput ? this._timepickerInput.format : this._format;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set format(value) {
        this._format = value === 24 ? 24 : 12;
    }
    /**
     * @return {?}
     */
    get inputElement() {
        return this._timepickerInput && this._timepickerInput.element;
    }
    /**
     * @return {?}
     */
    get maxTime() {
        return this._timepickerInput ? this._timepickerInput.max : this.max;
    }
    /**
     * @return {?}
     */
    get minTime() {
        return this._timepickerInput ? this._timepickerInput.min : this.min;
    }
    /**
     * @return {?}
     */
    get minutesGap() {
        return this._minutesGap;
    }
    /**
     * @param {?} gap
     * @return {?}
     */
    set minutesGap(gap) {
        if (gap == null) {
            return;
        }
        gap = Math.floor(gap);
        this._minutesGap = gap <= 59 ? gap : 1;
    }
    /**
     * @return {?}
     */
    get overlayOrigin() {
        return this._timepickerInput ? this._timepickerInput.cdkOverlayOrigin : void 0;
    }
    /**
     * @return {?}
     */
    get time() {
        return this._timepickerInput && this._timepickerInput.value;
    }
    /**
     * @param {?} newValue
     * @return {?}
     */
    set ngxMatTimepickerTheme(newValue) {
        this._ngxMatTimepickerTheme = newValue;
    }
    /**
     * @return {?}
     */
    close() {
        if (this.appendToInput) {
            this._overlayRef && this._overlayRef.dispose();
        }
        else {
            this._dialogRef && this._dialogRef.close();
        }
        this.showPicker = !1;
        this.closed.emit();
    }
    /**
     * @return {?}
     */
    open() {
        config = {
            timepickerBaseRef: this,
            time: this.time,
            defaultTime: this.defaultTime,
            maxTime: this.maxTime,
            minTime: this.minTime,
            format: this.format,
            minutesGap: this.minutesGap,
            disableAnimation: this.disableAnimation,
            cancelBtnTmpl: this.cancelBtnTmpl,
            confirmBtnTmpl: this.confirmBtnTmpl,
            editableHintTmpl: this.editableHintTmpl,
            disabled: this.disabled,
            enableKeyboardInput: this.enableKeyboardInput,
            preventOverlayClick: this.preventOverlayClick,
            appendToInput: this.appendToInput,
            hoursOnly: this.hoursOnly,
            theme: this.theme || this._ngxMatTimepickerTheme,
            timepickerClass: this.timepickerClass,
            inputElement: this.inputElement,
            color: this.color
        };
        if (this.appendToInput) {
            this.showPicker = !0;
        }
        else {
            this._dialogRef = this._dialog.open(NgxMatTimepickerDialogComponent, {
                panelClass: "ngx-mat-timepicker-dialog",
                data: Object.assign({}, config)
            });
            this._dialogRef
                .afterClosed()
                .subscribe(() => {
                this.closed.emit();
            });
        }
        this.opened.emit();
    }
    /**
     *
     * Register an input with this timepicker.
     * input - The timepicker input to register with this timepicker
     * @param {?} input
     * @return {?}
     */
    registerInput(input) {
        if (this._timepickerInput) {
            throw Error("A Timepicker can only be associated with a single input.");
        }
        this._timepickerInput = input;
    }
    /**
     * @return {?}
     */
    unregisterInput() {
        this._timepickerInput = void 0;
    }
    /**
     * @param {?} time
     * @return {?}
     */
    updateTime(time) {
        this.timeUpdated.next(time);
    }
}
NgxMatTimepickerComponent.ɵfac = function NgxMatTimepickerComponent_Factory(t) { return new (t || NgxMatTimepickerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ViewContainerRef), ɵngcc0.ɵɵdirectiveInject(NgxMatTimepickerEventService), ɵngcc0.ɵɵdirectiveInject(ɵngcc7.MatDialog), ɵngcc0.ɵɵdirectiveInject(ɵngcc11.Overlay)); };
NgxMatTimepickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxMatTimepickerComponent, selectors: [["ngx-mat-timepicker"]], hostVars: 1, hostBindings: function NgxMatTimepickerComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("id", ctx.id);
    } }, inputs: { hoursOnly: "hoursOnly", isEsc: "isEsc", color: "color", enableKeyboardInput: "enableKeyboardInput", format: "format", minutesGap: "minutesGap", appendToInput: "appendToInput", cancelBtnTmpl: "cancelBtnTmpl", confirmBtnTmpl: "confirmBtnTmpl", defaultTime: "defaultTime", disableAnimation: "disableAnimation", editableHintTmpl: "editableHintTmpl", max: "max", min: "min", preventOverlayClick: "preventOverlayClick", theme: "theme", timepickerClass: "timepickerClass" }, outputs: { closed: "closed", hourSelected: "hourSelected", opened: "opened", timeChanged: "timeChanged", timeSet: "timeSet" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NGX_MAT_TIMEPICKER_CONFIG,
                useFactory() {
                    return config;
                }
            }
        ])], decls: 1, vars: 4, consts: [["cdkConnectedOverlay", "", "cdkConnectedOverlayBackdropClass", "cdk-overlay-transparent-backdrop", 3, "cdkConnectedOverlayPositions", "cdkConnectedOverlayHasBackdrop", "cdkConnectedOverlayOrigin", "cdkConnectedOverlayOpen", "backdropClick"]], template: function NgxMatTimepickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, NgxMatTimepickerComponent_ng_template_0_Template, 1, 0, "ng-template", 0);
        ɵngcc0.ɵɵlistener("backdropClick", function NgxMatTimepickerComponent_Template_ng_template_backdropClick_0_listener() { return ctx.close(); });
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("cdkConnectedOverlayPositions", ctx.overlayPositions)("cdkConnectedOverlayHasBackdrop", !0)("cdkConnectedOverlayOrigin", ctx.overlayOrigin)("cdkConnectedOverlayOpen", ctx.showPicker);
    } }, dependencies: function () { return [ɵngcc11.CdkConnectedOverlay, NgxMatTimepickerStandaloneComponent]; }, encapsulation: 2 });
NgxMatTimepickerComponent.nextId = 0;
/** @nocollapse */
NgxMatTimepickerComponent.ctorParameters = () => [
    { type: ViewContainerRef },
    { type: NgxMatTimepickerEventService },
    { type: MatDialog },
    { type: Overlay }
];
NgxMatTimepickerComponent.propDecorators = {
    color: [{ type: Input }],
    enableKeyboardInput: [{ type: Input }],
    format: [{ type: Input }],
    minutesGap: [{ type: Input }],
    appendToInput: [{ type: Input }],
    cancelBtnTmpl: [{ type: Input }],
    closed: [{ type: Output }],
    confirmBtnTmpl: [{ type: Input }],
    defaultTime: [{ type: Input }],
    disableAnimation: [{ type: Input }],
    editableHintTmpl: [{ type: Input }],
    hourSelected: [{ type: Output }],
    hoursOnly: [{ type: Input }],
    id: [{ type: HostBinding, args: ["id",] }],
    isEsc: [{ type: Input }],
    max: [{ type: Input }],
    min: [{ type: Input }],
    opened: [{ type: Output }],
    preventOverlayClick: [{ type: Input }],
    theme: [{ type: Input }],
    timeChanged: [{ type: Output }],
    timepickerClass: [{ type: Input }],
    timeSet: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepickerComponent, [{
        type: Component,
        args: [{
                selector: "ngx-mat-timepicker",
                template: `
		<ng-template
				cdkConnectedOverlay
				[cdkConnectedOverlayPositions]="overlayPositions"
				[cdkConnectedOverlayHasBackdrop]="!0"
				cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
				(backdropClick)="close()"
				[cdkConnectedOverlayOrigin]="overlayOrigin"
				[cdkConnectedOverlayOpen]="showPicker">
			<ngx-mat-timepicker-standalone></ngx-mat-timepicker-standalone>
		</ng-template>`,
                providers: [
                    {
                        provide: NGX_MAT_TIMEPICKER_CONFIG,
                        useFactory() {
                            return config;
                        }
                    }
                ]
            }]
    }], function () { return [{ type: ɵngcc0.ViewContainerRef }, { type: NgxMatTimepickerEventService }, { type: ɵngcc7.MatDialog }, { type: ɵngcc11.Overlay }]; }, { closed: [{
            type: Output
        }], hourSelected: [{
            type: Output
        }], hoursOnly: [{
            type: Input
        }], id: [{
            type: HostBinding,
            args: ["id"]
        }], isEsc: [{
            type: Input
        }], opened: [{
            type: Output
        }], timeChanged: [{
            type: Output
        }], timeSet: [{
            type: Output
        }], color: [{
            type: Input
        }], enableKeyboardInput: [{
            type: Input
        }], format: [{
            type: Input
        }], minutesGap: [{
            type: Input
        }], appendToInput: [{
            type: Input
        }], cancelBtnTmpl: [{
            type: Input
        }], confirmBtnTmpl: [{
            type: Input
        }], defaultTime: [{
            type: Input
        }], disableAnimation: [{
            type: Input
        }], editableHintTmpl: [{
            type: Input
        }], max: [{
            type: Input
        }], min: [{
            type: Input
        }], preventOverlayClick: [{
            type: Input
        }], theme: [{
            type: Input
        }], timepickerClass: [{
            type: Input
        }] }); })();
function NgxMatTimepickerComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    NgxMatTimepickerComponent.nextId;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype.appendToInput;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype.cancelBtnTmpl;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype.closed;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype.confirmBtnTmpl;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype.defaultTime;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype.disableAnimation;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype.editableHintTmpl;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype.hourSelected;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype.hoursOnly;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype.id;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype.isEsc;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype.max;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype.min;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype.opened;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype.overlayPositions;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype.preventOverlayClick;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype.showPicker;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype.theme;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype.timeChanged;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype.timepickerClass;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype.timeSet;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype.timeUpdated;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype._color;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype._dialogRef;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype._enableKeyboardInput;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype._format;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype._minutesGap;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype._ngxMatTimepickerTheme;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype._overlayRef;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype._timepickerInput;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype._vcr;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype._eventService;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype._dialog;
    /** @type {?} */
    NgxMatTimepickerComponent.prototype._overlay;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxMatTimepickerToggleComponent {
    /**
     * @return {?}
     */
    get disabled() {
        return this._disabled === undefined ? this.timepicker.disabled : this._disabled;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set disabled(value) {
        this._disabled = value;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    open(event) {
        if (this.timepicker) {
            this.timepicker.open();
            event.stopPropagation();
        }
    }
}
NgxMatTimepickerToggleComponent.ɵfac = function NgxMatTimepickerToggleComponent_Factory(t) { return new (t || NgxMatTimepickerToggleComponent)(); };
NgxMatTimepickerToggleComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxMatTimepickerToggleComponent, selectors: [["ngx-mat-timepicker-toggle"]], contentQueries: function NgxMatTimepickerToggleComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, NgxMatTimepickerToggleIconDirective, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.customIcon = _t.first);
    } }, inputs: { disabled: "disabled", timepicker: ["for", "timepicker"] }, ngContentSelectors: _c2, decls: 3, vars: 2, consts: [["color", "", "mat-mini-fab", "", "type", "button", 1, "ngx-mat-timepicker-toggle", "mat-elevation-z0", 3, "disabled", "click"], ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 24 24", "width", "24px", "height", "24px", 4, "ngIf"], ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 24 24", "width", "24px", "height", "24px"], ["d", "M 12 2 C 6.4889971 2 2 6.4889971 2 12 C 2 17.511003                   6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 11 6 L 11 12.414062 L 15.292969 16.707031 L 16.707031 15.292969 L 13 11.585938 L 13 6 L 11 6 z"]], template: function NgxMatTimepickerToggleComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c1);
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("click", function NgxMatTimepickerToggleComponent_Template_button_click_0_listener($event) { return ctx.open($event); });
        ɵngcc0.ɵɵtemplate(1, NgxMatTimepickerToggleComponent__svg_svg_1_Template, 2, 0, "svg", 1);
        ɵngcc0.ɵɵprojection(2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("disabled", ctx.disabled);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.customIcon);
    } }, dependencies: [ɵngcc1.NgIf, ɵngcc9.MatButton], styles: ["button.ngx-mat-timepicker-toggle[_ngcontent-%COMP%]{-moz-user-select:none;-webkit-user-select:none;background-color:transparent;box-shadow:none;cursor:pointer;text-align:center;user-select:none}"] });
NgxMatTimepickerToggleComponent.propDecorators = {
    disabled: [{ type: Input }],
    customIcon: [{ type: ContentChild, args: [NgxMatTimepickerToggleIconDirective, { static: true },] }],
    timepicker: [{ type: Input, args: ["for",] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepickerToggleComponent, [{
        type: Component,
        args: [{ selector: "ngx-mat-timepicker-toggle", template: "<button class=\"ngx-mat-timepicker-toggle mat-elevation-z0\"\r\n        color=\"\"\r\n        mat-mini-fab\r\n        (click)=\"open($event)\"\r\n        [disabled]=\"disabled\"\r\n        type=\"button\">\r\n    <svg xmlns=\"http://www.w3.org/2000/svg\"\r\n         viewBox=\"0 0 24 24\"\r\n         width=\"24px\"\r\n         height=\"24px\"\r\n         *ngIf=\"!customIcon\">\r\n        <path d=\"M 12 2 C 6.4889971 2 2 6.4889971 2 12 C 2 17.511003                   6.4889971 22 12 22 C 17.511003 22 22 17.511003 22 12 C 22 6.4889971 17.511003 2 12 2 z M 12 4 C 16.430123 4 20 7.5698774 20 12 C 20 16.430123 16.430123 20 12 20 C 7.5698774 20 4 16.430123 4 12 C 4 7.5698774 7.5698774 4 12 4 z M 11 6 L 11 12.414062 L 15.292969 16.707031 L 16.707031 15.292969 L 13 11.585938 L 13 6 L 11 6 z\" />\r\n    </svg>\r\n\r\n    <ng-content select=\"[ngxMatTimepickerToggleIcon]\"></ng-content>\r\n</button>\r\n", styles: ["button.ngx-mat-timepicker-toggle{-moz-user-select:none;-webkit-user-select:none;background-color:transparent;box-shadow:none;cursor:pointer;text-align:center;user-select:none}"] }]
    }], null, { disabled: [{
            type: Input
        }], customIcon: [{
            type: ContentChild,
            args: [NgxMatTimepickerToggleIconDirective, { static: true }]
        }], timepicker: [{
            type: Input,
            args: ["for"]
        }] }); })();
function NgxMatTimepickerToggleComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    NgxMatTimepickerToggleComponent.prototype.customIcon;
    /** @type {?} */
    NgxMatTimepickerToggleComponent.prototype.timepicker;
    /** @type {?} */
    NgxMatTimepickerToggleComponent.prototype._disabled;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxMatTimepickerDirective {
    /**
     * @param {?} _elementRef
     * @param {?} _matFormField
     * @param {?} _locale
     */
    constructor(_elementRef, _matFormField, _locale) {
        this._elementRef = _elementRef;
        this._matFormField = _matFormField;
        this._locale = _locale;
        // TODO: IMPROVE DETECTING (INJECT) MAT-FORM-FIELD IF PRESENT
        this.cdkOverlayOrigin = new CdkOverlayOrigin(this._matFormField ? this._matFormField.getConnectedOverlayOrigin() : this._elementRef);
        this._format = 12;
        this._subsCtrl$ = new Subject();
        this._value = "";
        this.onTouched = () => {
        };
        this._onChange = () => {
        };
    }
    /**
     * @return {?}
     */
    get element() {
        return this._elementRef && this._elementRef.nativeElement;
    }
    /**
     * @return {?}
     */
    get format() {
        return this._format;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set format(value) {
        this._format = +value === 24 ? 24 : 12;
        const /** @type {?} */ isDynamicallyChanged = value && (this._previousFormat && this._previousFormat !== this._format);
        if (isDynamicallyChanged) {
            this.value = this._value;
            this._timepicker.updateTime(this._value);
        }
        this._previousFormat = this._format;
    }
    /**
     * @return {?}
     */
    get max() {
        return this._max;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set max(value) {
        if (typeof value === "string") {
            this._max = NgxMatTimepickerAdapter.parseTime(value, { locale: this._locale, format: this.format });
            return;
        }
        this._max = value;
    }
    /**
     * @return {?}
     */
    get min() {
        return this._min;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set min(value) {
        if (typeof value === "string") {
            this._min = NgxMatTimepickerAdapter.parseTime(value, { locale: this._locale, format: this.format });
            return;
        }
        this._min = value;
    }
    /**
     * @param {?} picker
     * @return {?}
     */
    set timepicker(picker) {
        this._registerTimepicker(picker);
    }
    /**
     * @return {?}
     */
    get value() {
        if (!this._value) {
            return "";
        }
        return NgxMatTimepickerAdapter.toLocaleTimeString(this._value, { format: this.format, locale: this._locale });
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set value(value) {
        if (!value) {
            this._value = "";
            this._updateInputValue();
            return;
        }
        const /** @type {?} */ time = NgxMatTimepickerAdapter.formatTime(value, { locale: this._locale, format: this.format });
        const /** @type {?} */ isAvailable = NgxMatTimepickerAdapter.isTimeAvailable(time, this._min, this._max, "minutes", this._timepicker.minutesGap, this._format);
        if (isAvailable) {
            this._value = time;
            this._updateInputValue();
            return;
        }
        console.warn("Selected time doesn't match min or max value");
    }
    /**
     * @param {?} time
     * @return {?}
     */
    set _defaultTime(time) {
        this._timepicker.defaultTime = NgxMatTimepickerAdapter.formatTime(time, {
            locale: this._locale,
            format: this.format
        });
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes["value"] && changes["value"].currentValue) {
            this._defaultTime = changes["value"].currentValue;
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this._unregisterTimepicker();
        this._subsCtrl$.next();
        this._subsCtrl$.complete();
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onClick(event) {
        if (!this.disableClick) {
            this._timepicker.open();
            event.stopPropagation();
        }
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnChange(fn) {
        this._onChange = fn;
    }
    /**
     * @param {?} fn
     * @return {?}
     */
    registerOnTouched(fn) {
        this.onTouched = fn;
    }
    /**
     * @param {?} isDisabled
     * @return {?}
     */
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    /**
     * @param {?} value
     * @return {?}
     */
    updateValue(value) {
        this.value = value;
        this._onChange(value);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    writeValue(value) {
        this.value = value;
        if (value) {
            this._defaultTime = value;
        }
    }
    /**
     * @param {?} picker
     * @return {?}
     */
    _registerTimepicker(picker) {
        if (picker) {
            this._timepicker = picker;
            this._timepicker.registerInput(this);
            this._timepicker.timeSet
                .pipe(takeUntil(this._subsCtrl$))
                .subscribe((time) => {
                this.value = time;
                this._onChange(this.value);
                this.onTouched();
                this._defaultTime = this._value;
            });
        }
        else {
            throw new Error("NgxMatTimepickerComponent is not defined." +
                " Please make sure you passed the timepicker to ngxMatTimepicker directive");
        }
    }
    /**
     * @return {?}
     */
    _unregisterTimepicker() {
        if (this._timepicker) {
            this._timepicker.unregisterInput();
        }
    }
    /**
     * @return {?}
     */
    _updateInputValue() {
        this._elementRef.nativeElement.value = this.value;
    }
}
NgxMatTimepickerDirective.ɵfac = function NgxMatTimepickerDirective_Factory(t) { return new (t || NgxMatTimepickerDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(MatFormField, 8), ɵngcc0.ɵɵdirectiveInject(NGX_MAT_TIMEPICKER_LOCALE)); };
NgxMatTimepickerDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgxMatTimepickerDirective, selectors: [["", "ngxMatTimepicker", ""]], hostVars: 2, hostBindings: function NgxMatTimepickerDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("blur", function NgxMatTimepickerDirective_blur_HostBindingHandler() { return ctx.onTouched(); })("click", function NgxMatTimepickerDirective_click_HostBindingHandler($event) { return ctx.onClick($event); })("change", function NgxMatTimepickerDirective_change_HostBindingHandler($event) { return ctx.updateValue($event); });
    } if (rf & 2) {
        ɵngcc0.ɵɵhostProperty("disabled", ctx.disabled);
        ɵngcc0.ɵɵattribute("cdkOverlayOrigin", ctx.cdkOverlayOrigin);
    } }, inputs: { format: "format", value: "value", max: "max", min: "min", timepicker: ["ngxMatTimepicker", "timepicker"], disabled: "disabled", disableClick: "disableClick" }, features: [ɵngcc0.ɵɵProvidersFeature([
            {
                provide: NG_VALUE_ACCESSOR,
                useExisting: NgxMatTimepickerDirective,
                multi: true
            }
        ]), ɵngcc0.ɵɵNgOnChangesFeature] });
/** @nocollapse */
NgxMatTimepickerDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: MatFormField, decorators: [{ type: Optional }, { type: Inject, args: [MatFormField,] }] },
    { type: String, decorators: [{ type: Inject, args: [NGX_MAT_TIMEPICKER_LOCALE,] }] }
];
NgxMatTimepickerDirective.propDecorators = {
    format: [{ type: Input }],
    max: [{ type: Input }],
    min: [{ type: Input }],
    timepicker: [{ type: Input, args: ["ngxMatTimepicker",] }],
    value: [{ type: Input }],
    cdkOverlayOrigin: [{ type: HostBinding, args: ["attr.cdkOverlayOrigin",] }],
    disableClick: [{ type: Input }],
    disabled: [{ type: Input }],
    onClick: [{ type: HostListener, args: ["click", ["$event"],] }],
    updateValue: [{ type: HostListener, args: ["change", ["$event"],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepickerDirective, [{
        type: Directive,
        args: [{
                selector: "[ngxMatTimepicker]",
                providers: [
                    {
                        provide: NG_VALUE_ACCESSOR,
                        useExisting: NgxMatTimepickerDirective,
                        multi: true
                    }
                ],
                // tslint:disable-next-line:no-host-metadata-property
                host: {
                    "[disabled]": "disabled",
                    "(blur)": "onTouched()"
                }
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc3.MatFormField, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [MatFormField]
            }] }, { type: String, decorators: [{
                type: Inject,
                args: [NGX_MAT_TIMEPICKER_LOCALE]
            }] }]; }, { cdkOverlayOrigin: [{
            type: HostBinding,
            args: ["attr.cdkOverlayOrigin"]
        }], format: [{
            type: Input
        }], value: [{
            type: Input
        }], max: [{
            type: Input
        }], min: [{
            type: Input
        }], timepicker: [{
            type: Input,
            args: ["ngxMatTimepicker"]
        }], 
    /**
     * @param {?} event
     * @return {?}
     */
    onClick: [{
            type: HostListener,
            args: ["click", ["$event"]]
        }], disabled: [{
            type: Input
        }], 
    /**
     * @param {?} value
     * @return {?}
     */
    updateValue: [{
            type: HostListener,
            args: ["change", ["$event"]]
        }], disableClick: [{
            type: Input
        }] }); })();
function NgxMatTimepickerDirective_tsickle_Closure_declarations() {
    /** @type {?} */
    NgxMatTimepickerDirective.prototype.cdkOverlayOrigin;
    /** @type {?} */
    NgxMatTimepickerDirective.prototype.disableClick;
    /** @type {?} */
    NgxMatTimepickerDirective.prototype.disabled;
    /** @type {?} */
    NgxMatTimepickerDirective.prototype._format;
    /** @type {?} */
    NgxMatTimepickerDirective.prototype._max;
    /** @type {?} */
    NgxMatTimepickerDirective.prototype._min;
    /** @type {?} */
    NgxMatTimepickerDirective.prototype._previousFormat;
    /** @type {?} */
    NgxMatTimepickerDirective.prototype._subsCtrl$;
    /** @type {?} */
    NgxMatTimepickerDirective.prototype._timepicker;
    /** @type {?} */
    NgxMatTimepickerDirective.prototype._value;
    /** @type {?} */
    NgxMatTimepickerDirective.prototype.onTouched;
    /** @type {?} */
    NgxMatTimepickerDirective.prototype._onChange;
    /** @type {?} */
    NgxMatTimepickerDirective.prototype._elementRef;
    /** @type {?} */
    NgxMatTimepickerDirective.prototype._matFormField;
    /** @type {?} */
    NgxMatTimepickerDirective.prototype._locale;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxMatTimepickerThemeDirective {
    /**
     * @param {?} elementRef
     */
    constructor(elementRef) {
        this._element = elementRef.nativeElement;
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        if (this.theme) {
            this.setTheme(this.theme);
        }
    }
    /**
     * @param {?} theme
     * @return {?}
     */
    setTheme(theme) {
        for (const /** @type {?} */ val in theme) {
            if (theme.hasOwnProperty(val)) {
                if (typeof theme[val] === "string") {
                    for (const /** @type {?} */ prop in theme) {
                        if (theme.hasOwnProperty(prop)) {
                            this._element.style.setProperty(`--${camelCaseToDash(prop)}`, theme[prop]);
                        }
                    }
                    return;
                }
                this.setTheme(theme[val]);
            }
        }
    }
}
NgxMatTimepickerThemeDirective.ɵfac = function NgxMatTimepickerThemeDirective_Factory(t) { return new (t || NgxMatTimepickerThemeDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
NgxMatTimepickerThemeDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgxMatTimepickerThemeDirective, selectors: [["", "ngxMatTimepickerTheme", ""]], inputs: { theme: ["ngxMatTimepickerTheme", "theme"] } });
/** @nocollapse */
NgxMatTimepickerThemeDirective.ctorParameters = () => [
    { type: ElementRef }
];
NgxMatTimepickerThemeDirective.propDecorators = {
    theme: [{ type: Input, args: ["ngxMatTimepickerTheme",] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepickerThemeDirective, [{
        type: Directive,
        args: [{ selector: "[ngxMatTimepickerTheme]" }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { theme: [{
            type: Input,
            args: ["ngxMatTimepickerTheme"]
        }] }); })();
function NgxMatTimepickerThemeDirective_tsickle_Closure_declarations() {
    /** @type {?} */
    NgxMatTimepickerThemeDirective.prototype.theme;
    /** @type {?} */
    NgxMatTimepickerThemeDirective.prototype._element;
}
/**
 * @param {?} myStr
 * @return {?}
 */
function camelCaseToDash(myStr) {
    return myStr.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxMatTimepickerHoursFaceDirective {
    constructor() {
        this.hourChange = new EventEmitter();
        this.hourSelected = new EventEmitter();
        this.hoursList = [];
        this._color = "primary";
        this._format = 24;
    }
    /**
     * @param {?} newValue
     * @return {?}
     */
    set color(newValue) {
        this._color = newValue;
    }
    /**
     * @return {?}
     */
    get color() {
        return this._color;
    }
    /**
     * @param {?} newValue
     * @return {?}
     */
    set format(newValue) {
        this._format = newValue;
        this.hoursList = NgxMatTimepickerUtils.getHours(this._format);
    }
    /**
     * @return {?}
     */
    get format() {
        return this._format;
    }
    /**
     * @param {?} time
     * @return {?}
     */
    onTimeSelected(time) {
        this.hourSelected.next(time);
    }
}
NgxMatTimepickerHoursFaceDirective.ɵfac = function NgxMatTimepickerHoursFaceDirective_Factory(t) { return new (t || NgxMatTimepickerHoursFaceDirective)(); };
NgxMatTimepickerHoursFaceDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgxMatTimepickerHoursFaceDirective, selectors: [["", "ngxMatTimepickerHoursFace", ""]], inputs: { color: "color", format: "format", maxTime: "maxTime", minTime: "minTime", selectedHour: "selectedHour" }, outputs: { hourChange: "hourChange", hourSelected: "hourSelected" } });
/** @nocollapse */
NgxMatTimepickerHoursFaceDirective.ctorParameters = () => [];
NgxMatTimepickerHoursFaceDirective.propDecorators = {
    color: [{ type: Input }],
    format: [{ type: Input }],
    hourChange: [{ type: Output }],
    hourSelected: [{ type: Output }],
    maxTime: [{ type: Input }],
    minTime: [{ type: Input }],
    selectedHour: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepickerHoursFaceDirective, [{
        type: Directive,
        args: [{
                selector: "[ngxMatTimepickerHoursFace]"
            }]
    }], function () { return []; }, { hourChange: [{
            type: Output
        }], hourSelected: [{
            type: Output
        }], color: [{
            type: Input
        }], format: [{
            type: Input
        }], maxTime: [{
            type: Input
        }], minTime: [{
            type: Input
        }], selectedHour: [{
            type: Input
        }] }); })();
function NgxMatTimepickerHoursFaceDirective_tsickle_Closure_declarations() {
    /** @type {?} */
    NgxMatTimepickerHoursFaceDirective.prototype.hourChange;
    /** @type {?} */
    NgxMatTimepickerHoursFaceDirective.prototype.hourSelected;
    /** @type {?} */
    NgxMatTimepickerHoursFaceDirective.prototype.hoursList;
    /** @type {?} */
    NgxMatTimepickerHoursFaceDirective.prototype.maxTime;
    /** @type {?} */
    NgxMatTimepickerHoursFaceDirective.prototype.minTime;
    /** @type {?} */
    NgxMatTimepickerHoursFaceDirective.prototype.selectedHour;
    /** @type {?} */
    NgxMatTimepickerHoursFaceDirective.prototype._color;
    /** @type {?} */
    NgxMatTimepickerHoursFaceDirective.prototype._format;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxMatTimepicker24HoursFaceComponent extends NgxMatTimepickerHoursFaceDirective {
    constructor() {
        super();
        this.format = 24;
    }
    /**
     * @return {?}
     */
    ngAfterContentInit() {
        this.hoursList = NgxMatTimepickerUtils.disableHours(this.hoursList, {
            min: this.minTime,
            max: this.maxTime,
            format: this.format
        });
    }
}
NgxMatTimepicker24HoursFaceComponent.ɵfac = function NgxMatTimepicker24HoursFaceComponent_Factory(t) { return new (t || NgxMatTimepicker24HoursFaceComponent)(); };
NgxMatTimepicker24HoursFaceComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxMatTimepicker24HoursFaceComponent, selectors: [["ngx-mat-timepicker-24-hours-face"]], features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 4, consts: [[3, "color", "selectedTime", "faceTime", "format", "timeChange", "timeSelected"]], template: function NgxMatTimepicker24HoursFaceComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ngx-mat-timepicker-face", 0);
        ɵngcc0.ɵɵlistener("timeChange", function NgxMatTimepicker24HoursFaceComponent_Template_ngx_mat_timepicker_face_timeChange_0_listener($event) { return ctx.hourChange.next($event); })("timeSelected", function NgxMatTimepicker24HoursFaceComponent_Template_ngx_mat_timepicker_face_timeSelected_0_listener($event) { return ctx.onTimeSelected($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("color", ctx.color)("selectedTime", ctx.selectedHour)("faceTime", ctx.hoursList)("format", ctx.format);
    } }, dependencies: function () { return [NgxMatTimepickerFaceComponent]; }, encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
NgxMatTimepicker24HoursFaceComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepicker24HoursFaceComponent, [{
        type: Component,
        args: [{
                selector: "ngx-mat-timepicker-24-hours-face",
                template: "<ngx-mat-timepicker-face [color]=\"color\"\r\n                     [selectedTime]=\"selectedHour\"\r\n                     [faceTime]=\"hoursList\"\r\n                     [format]=\"format\"\r\n                     (timeChange)=\"hourChange.next($event)\"\r\n                     (timeSelected)=\"onTimeSelected($event)\"></ngx-mat-timepicker-face>\r\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxMatTimepicker12HoursFaceComponent extends NgxMatTimepickerHoursFaceDirective {
    constructor() {
        super();
        this.format = 12;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes["period"] && changes["period"].currentValue) {
            this.hoursList = NgxMatTimepickerUtils.disableHours(this.hoursList, {
                min: this.minTime,
                max: this.maxTime,
                format: this.format,
                period: this.period
            });
        }
    }
}
NgxMatTimepicker12HoursFaceComponent.ɵfac = function NgxMatTimepicker12HoursFaceComponent_Factory(t) { return new (t || NgxMatTimepicker12HoursFaceComponent)(); };
NgxMatTimepicker12HoursFaceComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxMatTimepicker12HoursFaceComponent, selectors: [["ngx-mat-timepicker-12-hours-face"]], inputs: { period: "period" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 3, consts: [[3, "color", "selectedTime", "faceTime", "timeChange", "timeSelected"]], template: function NgxMatTimepicker12HoursFaceComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ngx-mat-timepicker-face", 0);
        ɵngcc0.ɵɵlistener("timeChange", function NgxMatTimepicker12HoursFaceComponent_Template_ngx_mat_timepicker_face_timeChange_0_listener($event) { return ctx.hourChange.next($event); })("timeSelected", function NgxMatTimepicker12HoursFaceComponent_Template_ngx_mat_timepicker_face_timeSelected_0_listener($event) { return ctx.onTimeSelected($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("color", ctx.color)("selectedTime", ctx.selectedHour)("faceTime", ctx.hoursList);
    } }, dependencies: function () { return [NgxMatTimepickerFaceComponent]; }, encapsulation: 2, changeDetection: 0 });
/** @nocollapse */
NgxMatTimepicker12HoursFaceComponent.ctorParameters = () => [];
NgxMatTimepicker12HoursFaceComponent.propDecorators = {
    period: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepicker12HoursFaceComponent, [{
        type: Component,
        args: [{
                selector: "ngx-mat-timepicker-12-hours-face",
                template: "<ngx-mat-timepicker-face [color]=\"color\"\r\n                     [selectedTime]=\"selectedHour\"\r\n                     [faceTime]=\"hoursList\"\r\n                     (timeChange)=\"hourChange.next($event)\"\r\n                     (timeSelected)=\"onTimeSelected($event)\"></ngx-mat-timepicker-face>\r\n",
                changeDetection: ChangeDetectionStrategy.OnPush
            }]
    }], function () { return []; }, { period: [{
            type: Input
        }] }); })();
function NgxMatTimepicker12HoursFaceComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    NgxMatTimepicker12HoursFaceComponent.prototype.period;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxMatTimepickerMinutesFaceComponent {
    constructor() {
        this.minuteChange = new EventEmitter();
        this.minutesList = [];
        this.timeUnit = NgxMatTimepickerUnits;
        this._color = "primary";
    }
    /**
     * @param {?} newValue
     * @return {?}
     */
    set color(newValue) {
        this._color = newValue;
    }
    /**
     * @return {?}
     */
    get color() {
        return this._color;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes["period"] && changes["period"].currentValue) {
            const /** @type {?} */ minutes = NgxMatTimepickerUtils.getMinutes(this.minutesGap);
            this.minutesList = NgxMatTimepickerUtils.disableMinutes(minutes, this.selectedHour, {
                min: this.minTime,
                max: this.maxTime,
                format: this.format,
                period: this.period
            });
        }
    }
}
NgxMatTimepickerMinutesFaceComponent.ɵfac = function NgxMatTimepickerMinutesFaceComponent_Factory(t) { return new (t || NgxMatTimepickerMinutesFaceComponent)(); };
NgxMatTimepickerMinutesFaceComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxMatTimepickerMinutesFaceComponent, selectors: [["ngx-mat-timepicker-minutes-face"]], inputs: { color: "color", format: "format", maxTime: "maxTime", minTime: "minTime", minutesGap: "minutesGap", period: "period", selectedHour: "selectedHour", selectedMinute: "selectedMinute" }, outputs: { minuteChange: "minuteChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 5, consts: [[3, "color", "faceTime", "selectedTime", "minutesGap", "unit", "timeChange"]], template: function NgxMatTimepickerMinutesFaceComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ngx-mat-timepicker-face", 0);
        ɵngcc0.ɵɵlistener("timeChange", function NgxMatTimepickerMinutesFaceComponent_Template_ngx_mat_timepicker_face_timeChange_0_listener($event) { return ctx.minuteChange.next($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("color", ctx.color)("faceTime", ctx.minutesList)("selectedTime", ctx.selectedMinute)("minutesGap", ctx.minutesGap)("unit", ctx.timeUnit.MINUTE);
    } }, dependencies: function () { return [NgxMatTimepickerFaceComponent]; }, encapsulation: 2 });
/** @nocollapse */
NgxMatTimepickerMinutesFaceComponent.ctorParameters = () => [];
NgxMatTimepickerMinutesFaceComponent.propDecorators = {
    color: [{ type: Input }],
    format: [{ type: Input }],
    maxTime: [{ type: Input }],
    minTime: [{ type: Input }],
    minuteChange: [{ type: Output }],
    minutesGap: [{ type: Input }],
    period: [{ type: Input }],
    selectedHour: [{ type: Input }],
    selectedMinute: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepickerMinutesFaceComponent, [{
        type: Component,
        args: [{
                selector: "ngx-mat-timepicker-minutes-face",
                template: "<ngx-mat-timepicker-face [color]=\"color\"\r\n                     [faceTime]=\"minutesList\"\r\n                     [selectedTime]=\"selectedMinute\"\r\n                     [minutesGap]=\"minutesGap\"\r\n                     (timeChange)=\"minuteChange.next($event)\"\r\n                     [unit]=\"timeUnit.MINUTE\"></ngx-mat-timepicker-face>\r\n"
            }]
    }], function () { return []; }, { minuteChange: [{
            type: Output
        }], color: [{
            type: Input
        }], format: [{
            type: Input
        }], maxTime: [{
            type: Input
        }], minTime: [{
            type: Input
        }], minutesGap: [{
            type: Input
        }], period: [{
            type: Input
        }], selectedHour: [{
            type: Input
        }], selectedMinute: [{
            type: Input
        }] }); })();
function NgxMatTimepickerMinutesFaceComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    NgxMatTimepickerMinutesFaceComponent.prototype.format;
    /** @type {?} */
    NgxMatTimepickerMinutesFaceComponent.prototype.maxTime;
    /** @type {?} */
    NgxMatTimepickerMinutesFaceComponent.prototype.minTime;
    /** @type {?} */
    NgxMatTimepickerMinutesFaceComponent.prototype.minuteChange;
    /** @type {?} */
    NgxMatTimepickerMinutesFaceComponent.prototype.minutesGap;
    /** @type {?} */
    NgxMatTimepickerMinutesFaceComponent.prototype.minutesList;
    /** @type {?} */
    NgxMatTimepickerMinutesFaceComponent.prototype.period;
    /** @type {?} */
    NgxMatTimepickerMinutesFaceComponent.prototype.selectedHour;
    /** @type {?} */
    NgxMatTimepickerMinutesFaceComponent.prototype.selectedMinute;
    /** @type {?} */
    NgxMatTimepickerMinutesFaceComponent.prototype.timeUnit;
    /** @type {?} */
    NgxMatTimepickerMinutesFaceComponent.prototype._color;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @param {?} angle
 * @param {?} step
 * @return {?}
 */
function roundAngle(angle, step) {
    return Math.round(angle / step) * step;
}
/**
 * @param {?} x0
 * @param {?} y0
 * @param {?} x
 * @param {?} y
 * @param {?} currentAngle
 * @return {?}
 */
function countAngleByCords(x0, y0, x, y, currentAngle) {
    if (y > y0 && x >= x0) { // II quarter
        // II quarter
        return 180 - currentAngle;
    }
    else if (y > y0 && x < x0) { // III quarter
        // III quarter
        return 180 + currentAngle;
    }
    else if (y < y0 && x < x0) { // IV quarter
        // IV quarter
        return 360 - currentAngle;
    }
    else { // I quarter
        // I quarter
        return currentAngle;
    }
}
const /** @type {?} */ CLOCK_HAND_STYLES = {
    small: {
        height: "75px",
        top: "calc(50% - 75px)"
    },
    large: {
        height: "103px",
        top: "calc(50% - 103px)"
    }
};
class NgxMatTimepickerFaceComponent {
    constructor() {
        this.color = "primary";
        this.innerClockFaceSize = 85;
        this.timeChange = new EventEmitter();
        this.timeSelected = new EventEmitter();
        this.timeUnit = NgxMatTimepickerUnits;
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this._setClockHandPosition();
        this._addTouchEvents();
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        const /** @type {?} */ faceTimeChanges = changes["faceTime"];
        const /** @type {?} */ selectedTimeChanges = changes["selectedTime"];
        if ((faceTimeChanges && faceTimeChanges.currentValue)
            && (selectedTimeChanges && selectedTimeChanges.currentValue)) {
            /* Set time according to passed an input value */
            this.selectedTime = this.faceTime.find(time => time.time === this.selectedTime.time);
        }
        if (selectedTimeChanges && selectedTimeChanges.currentValue) {
            this._setClockHandPosition();
        }
        if (faceTimeChanges && faceTimeChanges.currentValue) {
            // To avoid an error ExpressionChangedAfterItHasBeenCheckedError
            setTimeout(() => this._selectAvailableTime());
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this._removeTouchEvents();
    }
    /**
     * @param {?} e
     * @return {?}
     */
    onMousedown(e) {
        e.preventDefault();
        this._isStarted = true;
    }
    /**
     * @param {?} e
     * @return {?}
     */
    onMouseup(e) {
        e.preventDefault();
        this._isStarted = false;
    }
    /**
     * @param {?} e
     * @return {?}
     */
    selectTime(e) {
        if (!this._isStarted && (e instanceof MouseEvent && e.type !== "click")) {
            return;
        }
        const /** @type {?} */ clockFaceCords = this.clockFace.nativeElement.getBoundingClientRect();
        /* Get x0 and y0 of the circle */
        const /** @type {?} */ centerX = clockFaceCords.left + clockFaceCords.width / 2;
        const /** @type {?} */ centerY = clockFaceCords.top + clockFaceCords.height / 2;
        /* Counting the arctangent and convert it to from radian to deg */
        const /** @type {?} */ arctangent = Math.atan(Math.abs(e.clientX - centerX) / Math.abs(e.clientY - centerY)) * 180 / Math.PI;
        /* Get angle according to quadrant */
        const /** @type {?} */ circleAngle = countAngleByCords(centerX, centerY, e.clientX, e.clientY, arctangent);
        /* Check if selected time from the inner clock face (24 hours format only) */
        const /** @type {?} */ isInnerClockChosen = this.format && this._isInnerClockFace(centerX, centerY, e.clientX, e.clientY);
        /* Round angle according to angle step */
        const /** @type {?} */ angleStep = this.unit === NgxMatTimepickerUnits.MINUTE ? (6 * (this.minutesGap || 1)) : 30;
        const /** @type {?} */ roundedAngle = roundAngle(circleAngle, angleStep);
        const /** @type {?} */ angle = (roundedAngle || 360) + (isInnerClockChosen ? 360 : 0);
        const /** @type {?} */ selectedTime = this.faceTime.find(val => val.angle === angle);
        if (selectedTime && !selectedTime.disabled) {
            this.timeChange.next(selectedTime);
            /* To let know whether user ended interaction with clock face */
            if (!this._isStarted) {
                this.timeSelected.next(selectedTime.time);
            }
        }
    }
    /**
     * @param {?} _item_
     * @param {?} time
     * @return {?}
     */
    trackByTime(_item_, time) {
        return time.time;
    }
    /**
     * @return {?}
     */
    _addTouchEvents() {
        this._touchStartHandler = this.onMousedown.bind(this);
        this._touchEndHandler = this.onMouseup.bind(this);
        this.clockFace.nativeElement.addEventListener("touchstart", this._touchStartHandler);
        this.clockFace.nativeElement.addEventListener("touchend", this._touchEndHandler);
    }
    /**
     * @return {?}
     */
    _decreaseClockHand() {
        this.clockHand.nativeElement.style.height = CLOCK_HAND_STYLES.small.height;
        this.clockHand.nativeElement.style.top = CLOCK_HAND_STYLES.small.top;
    }
    /**
     * @return {?}
     */
    _increaseClockHand() {
        this.clockHand.nativeElement.style.height = CLOCK_HAND_STYLES.large.height;
        this.clockHand.nativeElement.style.top = CLOCK_HAND_STYLES.large.top;
    }
    /**
     * @param {?} x0
     * @param {?} y0
     * @param {?} x
     * @param {?} y
     * @return {?}
     */
    _isInnerClockFace(x0, y0, x, y) {
        /* Detect whether time from the inner clock face or not (24 format only) */
        return Math.sqrt(Math.pow(x - x0, 2) + Math.pow(y - y0, 2)) < this.innerClockFaceSize;
    }
    /**
     * @return {?}
     */
    _removeTouchEvents() {
        this.clockFace.nativeElement.removeEventListener("touchstart", this._touchStartHandler);
        this.clockFace.nativeElement.removeEventListener("touchend", this._touchEndHandler);
    }
    /**
     * @return {?}
     */
    _selectAvailableTime() {
        const /** @type {?} */ currentTime = this.faceTime.find(time => this.selectedTime.time === time.time);
        this.isClockFaceDisabled = this.faceTime.every(time => time.disabled);
        if ((currentTime && currentTime.disabled) && !this.isClockFaceDisabled) {
            const /** @type {?} */ availableTime = this.faceTime.find(time => !time.disabled);
            this.timeChange.next(availableTime);
        }
    }
    /**
     * @return {?}
     */
    _setClockHandPosition() {
        if (this.format === 24) {
            if (this.selectedTime.time > 12 || this.selectedTime.time === 0) {
                this._decreaseClockHand();
            }
            else {
                this._increaseClockHand();
            }
        }
        this.clockHand.nativeElement.style.transform = `rotate(${this.selectedTime.angle}deg)`;
    }
}
NgxMatTimepickerFaceComponent.ɵfac = function NgxMatTimepickerFaceComponent_Factory(t) { return new (t || NgxMatTimepickerFaceComponent)(); };
NgxMatTimepickerFaceComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxMatTimepickerFaceComponent, selectors: [["ngx-mat-timepicker-face"]], viewQuery: function NgxMatTimepickerFaceComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c3, 7);
        ɵngcc0.ɵɵviewQuery(_c4, 7, ElementRef);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.clockFace = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.clockHand = _t.first);
    } }, hostBindings: function NgxMatTimepickerFaceComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mousedown", function NgxMatTimepickerFaceComponent_mousedown_HostBindingHandler($event) { return ctx.onMousedown($event); })("mouseup", function NgxMatTimepickerFaceComponent_mouseup_HostBindingHandler($event) { return ctx.onMouseup($event); })("click", function NgxMatTimepickerFaceComponent_click_HostBindingHandler($event) { return ctx.selectTime($event); })("touchmove", function NgxMatTimepickerFaceComponent_touchmove_HostBindingHandler($event) { return ctx.selectTime($event.changedTouches[0]); })("touchend", function NgxMatTimepickerFaceComponent_touchend_HostBindingHandler($event) { return ctx.selectTime($event.changedTouches[0]); })("mousemove", function NgxMatTimepickerFaceComponent_mousemove_HostBindingHandler($event) { return ctx.selectTime($event); });
    } }, inputs: { color: "color", selectedTime: "selectedTime", faceTime: "faceTime", format: "format", minutesGap: "minutesGap", unit: "unit" }, outputs: { timeChange: "timeChange", timeSelected: "timeSelected" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c7, decls: 11, vars: 9, consts: [["hourButton", ""], [1, "clock-face"], ["clockFace", ""], ["class", "clock-face__container", 4, "ngIf", "ngIfElse"], [1, "clock-face__clock-hand", 3, "color", "ngClass", "hidden"], ["clockHand", ""], ["mat-mini-fab", "", 3, "color", 4, "ngIf"], [1, "clock-face__center", 3, "color"], ["minutesFace", ""], ["mat-mini-fab", "", 1, "mat-elevation-z0", 3, "color", "ngStyle", "disabled"], [1, "clock-face__container"], ["class", "clock-face__number clock-face__number--outer", 3, "ngStyle", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "clock-face__inner", 4, "ngIf"], [1, "clock-face__number", "clock-face__number--outer", 3, "ngStyle"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "clock-face__inner"], ["class", "clock-face__number clock-face__number--inner", 3, "top", "ngStyle", "height", 4, "ngFor", "ngForOf", "ngForTrackBy"], [1, "clock-face__number", "clock-face__number--inner", 3, "ngStyle"], ["mat-mini-fab", "", 3, "color"], [1, "clock-face__clock-hand_minute_dot"], ["mat-mini-fab", "", 1, "mat-elevation-z0", 3, "disableRipple", "color", "ngStyle"]], template: function NgxMatTimepickerFaceComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef(_c7);
        ɵngcc0.ɵɵtemplate(0, NgxMatTimepickerFaceComponent_ng_template_0_Template, 4, 13, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementStart(2, "div", 1, 2);
        ɵngcc0.ɵɵtemplate(4, NgxMatTimepickerFaceComponent_div_4_Template, 4, 7, "div", 3);
        ɵngcc0.ɵɵelementStart(5, "mat-toolbar", 4, 5);
        ɵngcc0.ɵɵtemplate(7, NgxMatTimepickerFaceComponent_button_7_Template, 2, 1, "button", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(8, "mat-toolbar", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, NgxMatTimepickerFaceComponent_ng_template_9_Template, 2, 2, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r6 = ɵngcc0.ɵɵreference(10);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", ctx.unit !== ctx.timeUnit.MINUTE)("ngIfElse", _r6);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("color", ctx.color)("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c8, ctx.unit === ctx.timeUnit.MINUTE))("hidden", ctx.isClockFaceDisabled);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.unit === ctx.timeUnit.MINUTE);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("color", ctx.color);
    } }, dependencies: function () { return [ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgStyle, ɵngcc9.MatButton, ɵngcc10.MatToolbar, ɵngcc1.SlicePipe, NgxMatTimepickerActiveHourPipe, NgxMatTimepickerActiveMinutePipe, NgxMatTimepickerMinutesFormatterPipe, NgxMatTimepickerTimeLocalizerPipe]; }, styles: [".clock-face[_ngcontent-%COMP%]{background-color:hsla(0,0%,78.4%,.5)!important;border-radius:50%;box-sizing:border-box;display:flex;height:290px;justify-content:center;position:relative;width:290px}.clock-face__inner[_ngcontent-%COMP%]{height:100%;left:0;position:absolute;top:0;width:100%}.clock-face[_ngcontent-%COMP%]   [mat-mini-fab][_ngcontent-%COMP%]{box-shadow:none}.clock-face[_ngcontent-%COMP%]   [mat-mini-fab][_ngcontent-%COMP%]:not(.mat-primary):not(.mat-accent):not(.mat-warn){background:transparent}.clock-face__container[_ngcontent-%COMP%]{margin-left:-2px}.clock-face__number[_ngcontent-%COMP%]{left:calc(50% - 25px);position:absolute;text-align:center;top:calc(50% - 125px);transform-origin:25px 100%;width:50px;z-index:2}.clock-face__number--outer[_ngcontent-%COMP%]{height:125px}.clock-face__number--outer[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{font-size:16px}.clock-face__number--inner[_ngcontent-%COMP%] > span[_ngcontent-%COMP%]{font-size:14px}.clock-face__clock-hand[_ngcontent-%COMP%]{height:103px;padding:0;position:absolute;top:calc(50% - 103px);transform-origin:1px 100%;width:2px;z-index:1}.clock-face__center[_ngcontent-%COMP%]{border-radius:50%;height:8px;left:50%;margin:-4px;padding:0;position:absolute;top:50%;width:8px}.clock-face__clock-hand_minute[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]{align-items:center;box-sizing:content-box;display:flex;justify-content:center;left:calc(50% - 20px);position:absolute;top:-22px}.clock-face__clock-hand_minute[_ngcontent-%COMP%] > button[_ngcontent-%COMP%]   .clock-face__clock-hand_minute_dot[_ngcontent-%COMP%]{background:#fff;border-radius:50%;display:block;height:4px;width:4px}@media (max-device-width:1023px) and (orientation:landscape){.clock-face[_ngcontent-%COMP%]{height:250px;width:250px}}@media screen and (max-width:360px){.clock-face[_ngcontent-%COMP%]{height:250px;width:250px}}"], changeDetection: 0 });
NgxMatTimepickerFaceComponent.propDecorators = {
    clockFace: [{ type: ViewChild, args: ["clockFace", { static: true },] }],
    clockHand: [{ type: ViewChild, args: ["clockHand", { static: true, read: ElementRef },] }],
    color: [{ type: Input }],
    faceTime: [{ type: Input }],
    format: [{ type: Input }],
    minutesGap: [{ type: Input }],
    selectedTime: [{ type: Input }],
    timeChange: [{ type: Output }],
    timeSelected: [{ type: Output }],
    unit: [{ type: Input }],
    onMousedown: [{ type: HostListener, args: ["mousedown", ["$event"],] }],
    onMouseup: [{ type: HostListener, args: ["mouseup", ["$event"],] }],
    selectTime: [{ type: HostListener, args: ["click", ["$event"],] }, { type: HostListener, args: ["touchmove", ["$event.changedTouches[0]"],] }, { type: HostListener, args: ["touchend", ["$event.changedTouches[0]"],] }, { type: HostListener, args: ["mousemove", ["$event"],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepickerFaceComponent, [{
        type: Component,
        args: [{ selector: "ngx-mat-timepicker-face", template: "<ng-template #hourButton\r\n             let-time>\r\n    <button mat-mini-fab\r\n            class=\"mat-elevation-z0\"\r\n            [color]=\"(time.time | activeHour: selectedTime?.time : isClockFaceDisabled) ? color : undefined\"\r\n            [ngStyle]=\"{'transform': 'rotateZ(-'+ time.angle +'deg)'}\"\r\n            [disabled]=\"time.disabled\">\r\n        {{time.time | timeLocalizer: timeUnit.HOUR}}\r\n    </button>\r\n</ng-template>\r\n<div class=\"clock-face\"\r\n     #clockFace>\r\n    <div *ngIf=\"unit !== timeUnit.MINUTE;else minutesFace\"\r\n         class=\"clock-face__container\">\r\n        <div class=\"clock-face__number clock-face__number--outer\"\r\n             [ngStyle]=\"{'transform': 'rotateZ('+ time.angle +'deg)'}\"\r\n             *ngFor=\"let time of faceTime | slice: 0 : 12; trackBy: trackByTime\">\r\n            <ng-content *ngTemplateOutlet=\"hourButton; context: {$implicit: time}\"></ng-content>\r\n        </div>\r\n        <div class=\"clock-face__inner\"\r\n             *ngIf=\"faceTime.length > 12\">\r\n            <div class=\"clock-face__number clock-face__number--inner\"\r\n                 [style.top]=\"'calc(50% - ' + innerClockFaceSize + 'px)'\"\r\n                 [ngStyle]=\"{'transform': 'rotateZ('+ time.angle +'deg)'}\"\r\n                 [style.height.px]=\"innerClockFaceSize\"\r\n                 *ngFor=\"let time of faceTime | slice: 12 : 24; trackBy: trackByTime\">\r\n                <ng-content *ngTemplateOutlet=\"hourButton; context: {$implicit: time}\"></ng-content>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <mat-toolbar class=\"clock-face__clock-hand\"\r\n                 [color]=\"color\"\r\n                 [ngClass]=\"{'clock-face__clock-hand_minute': unit === timeUnit.MINUTE}\"\r\n                 #clockHand\r\n                 [hidden]=\"isClockFaceDisabled\">\r\n        <button mat-mini-fab\r\n                *ngIf=\"unit === timeUnit.MINUTE\"\r\n                [color]=\"color\">\r\n            <span class=\"clock-face__clock-hand_minute_dot\"></span>\r\n        </button>\r\n    </mat-toolbar>\r\n    <mat-toolbar class=\"clock-face__center\"\r\n                 [color]=\"color\"></mat-toolbar>\r\n</div>\r\n<ng-template #minutesFace>\r\n    <div class=\"clock-face__container\">\r\n        <div class=\"clock-face__number clock-face__number--outer\"\r\n             [ngStyle]=\"{'transform': 'rotateZ('+ time.angle +'deg)'}\"\r\n             *ngFor=\"let time of faceTime; trackBy: trackByTime\">\r\n            <button mat-mini-fab\r\n                    class=\"mat-elevation-z0\"\r\n                    [disableRipple]=\"time.time % minutesGap !== 0\"\r\n                    [color]=\"(time.time | activeMinute: selectedTime?.time:minutesGap:isClockFaceDisabled) ? color : undefined\"\r\n                    [ngStyle]=\"{'transform': 'rotateZ(-'+ time.angle +'deg)'}\">\r\n                {{time.time | minutesFormatter: minutesGap | timeLocalizer: timeUnit.MINUTE}}\r\n            </button>\r\n        </div>\r\n    </div>\r\n</ng-template>\r\n", changeDetection: ChangeDetectionStrategy.OnPush, styles: [".clock-face{background-color:hsla(0,0%,78.4%,.5)!important;border-radius:50%;box-sizing:border-box;display:flex;height:290px;justify-content:center;position:relative;width:290px}.clock-face__inner{height:100%;left:0;position:absolute;top:0;width:100%}.clock-face [mat-mini-fab]{box-shadow:none}.clock-face [mat-mini-fab]:not(.mat-primary):not(.mat-accent):not(.mat-warn){background:transparent}.clock-face__container{margin-left:-2px}.clock-face__number{left:calc(50% - 25px);position:absolute;text-align:center;top:calc(50% - 125px);transform-origin:25px 100%;width:50px;z-index:2}.clock-face__number--outer{height:125px}.clock-face__number--outer>span{font-size:16px}.clock-face__number--inner>span{font-size:14px}.clock-face__clock-hand{height:103px;padding:0;position:absolute;top:calc(50% - 103px);transform-origin:1px 100%;width:2px;z-index:1}.clock-face__center{border-radius:50%;height:8px;left:50%;margin:-4px;padding:0;position:absolute;top:50%;width:8px}.clock-face__clock-hand_minute>button{align-items:center;box-sizing:content-box;display:flex;justify-content:center;left:calc(50% - 20px);position:absolute;top:-22px}.clock-face__clock-hand_minute>button .clock-face__clock-hand_minute_dot{background:#fff;border-radius:50%;display:block;height:4px;width:4px}@media (max-device-width:1023px) and (orientation:landscape){.clock-face{height:250px;width:250px}}@media screen and (max-width:360px){.clock-face{height:250px;width:250px}}"] }]
    }], function () { return []; }, { color: [{
            type: Input
        }], timeChange: [{
            type: Output
        }], timeSelected: [{
            type: Output
        }], selectedTime: [{
            type: Input
        }], 
    /**
     * @param {?} e
     * @return {?}
     */
    onMousedown: [{
            type: HostListener,
            args: ["mousedown", ["$event"]]
        }], 
    /**
     * @param {?} e
     * @return {?}
     */
    onMouseup: [{
            type: HostListener,
            args: ["mouseup", ["$event"]]
        }], 
    /**
     * @param {?} e
     * @return {?}
     */
    selectTime: [{
            type: HostListener,
            args: ["click", ["$event"]]
        }, {
            type: HostListener,
            args: ["touchmove", ["$event.changedTouches[0]"]]
        }, {
            type: HostListener,
            args: ["touchend", ["$event.changedTouches[0]"]]
        }, {
            type: HostListener,
            args: ["mousemove", ["$event"]]
        }], clockFace: [{
            type: ViewChild,
            args: ["clockFace", { static: true }]
        }], clockHand: [{
            type: ViewChild,
            args: ["clockHand", { static: true, read: ElementRef }]
        }], faceTime: [{
            type: Input
        }], format: [{
            type: Input
        }], minutesGap: [{
            type: Input
        }], unit: [{
            type: Input
        }] }); })();
function NgxMatTimepickerFaceComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    NgxMatTimepickerFaceComponent.prototype.clockFace;
    /** @type {?} */
    NgxMatTimepickerFaceComponent.prototype.clockHand;
    /** @type {?} */
    NgxMatTimepickerFaceComponent.prototype.color;
    /** @type {?} */
    NgxMatTimepickerFaceComponent.prototype.faceTime;
    /** @type {?} */
    NgxMatTimepickerFaceComponent.prototype.format;
    /** @type {?} */
    NgxMatTimepickerFaceComponent.prototype.innerClockFaceSize;
    /** @type {?} */
    NgxMatTimepickerFaceComponent.prototype.isClockFaceDisabled;
    /** @type {?} */
    NgxMatTimepickerFaceComponent.prototype.minutesGap;
    /** @type {?} */
    NgxMatTimepickerFaceComponent.prototype.selectedTime;
    /** @type {?} */
    NgxMatTimepickerFaceComponent.prototype.timeChange;
    /** @type {?} */
    NgxMatTimepickerFaceComponent.prototype.timeSelected;
    /** @type {?} */
    NgxMatTimepickerFaceComponent.prototype.timeUnit;
    /** @type {?} */
    NgxMatTimepickerFaceComponent.prototype.unit;
    /** @type {?} */
    NgxMatTimepickerFaceComponent.prototype._isStarted;
    /** @type {?} */
    NgxMatTimepickerFaceComponent.prototype._touchEndHandler;
    /** @type {?} */
    NgxMatTimepickerFaceComponent.prototype._touchStartHandler;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxMatTimepickerDialComponent {
    /**
     * @param {?} _locale
     */
    constructor(_locale) {
        this._locale = _locale;
        this.hourChanged = new EventEmitter();
        this.meridiems = Info.meridiems({ locale: this._locale });
        this.minuteChanged = new EventEmitter();
        this.periodChanged = new EventEmitter();
        this.timeUnit = NgxMatTimepickerUnits;
        this.timeUnitChanged = new EventEmitter();
        this._color = "primary";
    }
    /**
     * @param {?} newValue
     * @return {?}
     */
    set color(newValue) {
        this._color = newValue;
    }
    /**
     * @return {?}
     */
    get color() {
        return this._color;
    }
    /**
     * @param {?} hour
     * @return {?}
     */
    changeHour(hour) {
        this.hourChanged.next(hour);
    }
    /**
     * @param {?} minute
     * @return {?}
     */
    changeMinute(minute) {
        this.minuteChanged.next(minute);
    }
    /**
     * @param {?} period
     * @return {?}
     */
    changePeriod(period) {
        this.periodChanged.next(period);
    }
    /**
     * @param {?} unit
     * @return {?}
     */
    changeTimeUnit(unit) {
        this.timeUnitChanged.next(unit);
    }
    /**
     * @return {?}
     */
    hideHint() {
        this.isHintVisible = false;
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        const /** @type {?} */ periodChanged = changes["period"] && changes["period"].currentValue;
        if (periodChanged || changes["format"] && changes["format"].currentValue) {
            const /** @type {?} */ hours = NgxMatTimepickerUtils.getHours(this.format);
            this.hours = NgxMatTimepickerUtils.disableHours(hours, {
                min: this.minTime,
                max: this.maxTime,
                format: this.format,
                period: this.period
            });
        }
        if (periodChanged || changes["hour"] && changes["hour"].currentValue) {
            const /** @type {?} */ minutes = NgxMatTimepickerUtils.getMinutes(this.minutesGap);
            this.minutes = NgxMatTimepickerUtils.disableMinutes(minutes, +this.hour, {
                min: this.minTime,
                max: this.maxTime,
                format: this.format,
                period: this.period
            });
        }
    }
    /**
     * @return {?}
     */
    showHint() {
        this.isHintVisible = true;
    }
}
NgxMatTimepickerDialComponent.ɵfac = function NgxMatTimepickerDialComponent_Factory(t) { return new (t || NgxMatTimepickerDialComponent)(ɵngcc0.ɵɵdirectiveInject(NGX_MAT_TIMEPICKER_LOCALE)); };
NgxMatTimepickerDialComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxMatTimepickerDialComponent, selectors: [["ngx-mat-timepicker-dial"]], inputs: { color: "color", activeTimeUnit: "activeTimeUnit", editableHintTmpl: "editableHintTmpl", format: "format", hour: "hour", hoursOnly: "hoursOnly", isEditable: "isEditable", maxTime: "maxTime", minTime: "minTime", minute: "minute", minutesGap: "minutesGap", period: "period" }, outputs: { hourChanged: "hourChanged", minuteChanged: "minuteChanged", periodChanged: "periodChanged", timeUnitChanged: "timeUnitChanged" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 9, vars: 14, consts: [[1, "timepicker-dial"], [1, "timepicker-dial__container"], [1, "timepicker-dial__time"], [3, "timeList", "time", "timeUnit", "isActive", "isEditable", "timeUnitChanged", "timeChanged", "focused", "unfocused"], [3, "timeList", "time", "timeUnit", "isActive", "isEditable", "minutesGap", "disabled", "timeUnitChanged", "timeChanged", "focused", "unfocused"], ["class", "timepicker-dial__period", 3, "selectedPeriod", "activeTimeUnit", "maxTime", "minTime", "format", "hours", "minutes", "selectedHour", "meridiems", "periodChanged", 4, "ngIf"], [3, "ngClass", 4, "ngIf"], [1, "timepicker-dial__period", 3, "selectedPeriod", "activeTimeUnit", "maxTime", "minTime", "format", "hours", "minutes", "selectedHour", "meridiems", "periodChanged"], [3, "ngClass"], [4, "ngTemplateOutlet"], ["editableHintDefault", ""], [1, "timepicker-dial__hint"]], template: function NgxMatTimepickerDialComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "ngx-mat-timepicker-dial-control", 3);
        ɵngcc0.ɵɵlistener("timeUnitChanged", function NgxMatTimepickerDialComponent_Template_ngx_mat_timepicker_dial_control_timeUnitChanged_3_listener($event) { return ctx.changeTimeUnit($event); })("timeChanged", function NgxMatTimepickerDialComponent_Template_ngx_mat_timepicker_dial_control_timeChanged_3_listener($event) { return ctx.changeHour($event); })("focused", function NgxMatTimepickerDialComponent_Template_ngx_mat_timepicker_dial_control_focused_3_listener() { return ctx.showHint(); })("unfocused", function NgxMatTimepickerDialComponent_Template_ngx_mat_timepicker_dial_control_unfocused_3_listener() { return ctx.hideHint(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "span");
        ɵngcc0.ɵɵtext(5, ":");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "ngx-mat-timepicker-dial-control", 4);
        ɵngcc0.ɵɵlistener("timeUnitChanged", function NgxMatTimepickerDialComponent_Template_ngx_mat_timepicker_dial_control_timeUnitChanged_6_listener($event) { return ctx.changeTimeUnit($event); })("timeChanged", function NgxMatTimepickerDialComponent_Template_ngx_mat_timepicker_dial_control_timeChanged_6_listener($event) { return ctx.changeMinute($event); })("focused", function NgxMatTimepickerDialComponent_Template_ngx_mat_timepicker_dial_control_focused_6_listener() { return ctx.showHint(); })("unfocused", function NgxMatTimepickerDialComponent_Template_ngx_mat_timepicker_dial_control_unfocused_6_listener() { return ctx.hideHint(); });
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵtemplate(7, NgxMatTimepickerDialComponent_ngx_mat_timepicker_period_7_Template, 1, 9, "ngx-mat-timepicker-period", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, NgxMatTimepickerDialComponent_div_8_Template, 4, 4, "div", 6);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("timeList", ctx.hours)("time", ctx.hour)("timeUnit", ctx.timeUnit.HOUR)("isActive", ctx.activeTimeUnit === ctx.timeUnit.HOUR)("isEditable", ctx.isEditable);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("timeList", ctx.minutes)("time", ctx.minute)("timeUnit", ctx.timeUnit.MINUTE)("isActive", ctx.activeTimeUnit === ctx.timeUnit.MINUTE)("isEditable", ctx.isEditable)("minutesGap", ctx.minutesGap)("disabled", ctx.hoursOnly);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.format !== 24);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.isEditable || ctx.editableHintTmpl);
    } }, dependencies: function () { return [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, NgxMatTimepickerDialControlComponent, NgxMatTimepickerPeriodComponent]; }, styles: [".timepicker-dial[_ngcontent-%COMP%]{text-align:center}.timepicker-dial__container[_ngcontent-%COMP%]{-webkit-tap-highlight-color:rgba(0,0,0,0);align-items:center;display:flex;justify-content:center}.timepicker-dial__time[_ngcontent-%COMP%]{align-items:baseline;display:flex;font-size:50px;line-height:normal}.timepicker-dial__period[_ngcontent-%COMP%]{display:block;margin-left:10px}.timepicker-dial__hint-container--hidden[_ngcontent-%COMP%]{visibility:hidden}.timepicker-dial__hint[_ngcontent-%COMP%]{display:inline-block;font-size:10px}.timepicker-dial__hint[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{font-size:14px}"], changeDetection: 0 });
/** @nocollapse */
NgxMatTimepickerDialComponent.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [NGX_MAT_TIMEPICKER_LOCALE,] }] }
];
NgxMatTimepickerDialComponent.propDecorators = {
    activeTimeUnit: [{ type: Input }],
    color: [{ type: Input }],
    editableHintTmpl: [{ type: Input }],
    format: [{ type: Input }],
    hour: [{ type: Input }],
    hourChanged: [{ type: Output }],
    hoursOnly: [{ type: Input }],
    isEditable: [{ type: Input }],
    maxTime: [{ type: Input }],
    minTime: [{ type: Input }],
    minute: [{ type: Input }],
    minuteChanged: [{ type: Output }],
    minutesGap: [{ type: Input }],
    period: [{ type: Input }],
    periodChanged: [{ type: Output }],
    timeUnitChanged: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepickerDialComponent, [{
        type: Component,
        args: [{ selector: "ngx-mat-timepicker-dial", template: "<div class=\"timepicker-dial\">\r\n    <div class=\"timepicker-dial__container\">\r\n        <div class=\"timepicker-dial__time\">\r\n            <ngx-mat-timepicker-dial-control [timeList]=\"hours\"\r\n                                         [time]=\"hour\"\r\n                                         [timeUnit]=\"timeUnit.HOUR\"\r\n                                         [isActive]=\"activeTimeUnit === timeUnit.HOUR\"\r\n                                         [isEditable]=\"isEditable\"\r\n                                         (timeUnitChanged)=\"changeTimeUnit($event)\"\r\n                                         (timeChanged)=\"changeHour($event)\"\r\n                                         (focused)=\"showHint()\"\r\n                                         (unfocused)=\"hideHint()\">\r\n\r\n            </ngx-mat-timepicker-dial-control>\r\n            <span>:</span>\r\n            <ngx-mat-timepicker-dial-control [timeList]=\"minutes\"\r\n                                         [time]=\"minute\"\r\n                                         [timeUnit]=\"timeUnit.MINUTE\"\r\n                                         [isActive]=\"activeTimeUnit === timeUnit.MINUTE\"\r\n                                         [isEditable]=\"isEditable\"\r\n                                         [minutesGap]=\"minutesGap\"\r\n                                         [disabled]=\"hoursOnly\"\r\n                                         (timeUnitChanged)=\"changeTimeUnit($event)\"\r\n                                         (timeChanged)=\"changeMinute($event)\"\r\n                                         (focused)=\"showHint()\"\r\n                                         (unfocused)=\"hideHint()\">\r\n\r\n            </ngx-mat-timepicker-dial-control>\r\n        </div>\r\n        <ngx-mat-timepicker-period class=\"timepicker-dial__period\"\r\n                                   *ngIf=\"format !== 24\"\r\n                                   [selectedPeriod]=\"period\"\r\n                                   [activeTimeUnit]=\"activeTimeUnit\"\r\n                                   [maxTime]=\"maxTime\"\r\n                                   [minTime]=\"minTime\"\r\n                                   [format]=\"format\"\r\n                                   [hours]=\"hours\"\r\n                                   [minutes]=\"minutes\"\r\n                                   [selectedHour]=\"hour\"\r\n                                   [meridiems]=\"meridiems\"\r\n                                   (periodChanged)=\"changePeriod($event)\"></ngx-mat-timepicker-period>\r\n    </div>\r\n    <div *ngIf=\"isEditable || editableHintTmpl\"\r\n         [ngClass]=\"{'timepicker-dial__hint-container--hidden': !isHintVisible}\">\r\n        <ng-container *ngTemplateOutlet=\"editableHintTmpl ? editableHintTmpl : editableHintDefault\"></ng-container>\r\n        <ng-template #editableHintDefault>\r\n            <small class=\"timepicker-dial__hint\"> * use arrows (<span>&#8645;</span>) to change the time</small>\r\n        </ng-template>\r\n    </div>\r\n</div>\r\n", changeDetection: ChangeDetectionStrategy.OnPush, styles: [".timepicker-dial{text-align:center}.timepicker-dial__container{-webkit-tap-highlight-color:rgba(0,0,0,0);align-items:center;display:flex;justify-content:center}.timepicker-dial__time{align-items:baseline;display:flex;font-size:50px;line-height:normal}.timepicker-dial__period{display:block;margin-left:10px}.timepicker-dial__hint-container--hidden{visibility:hidden}.timepicker-dial__hint{display:inline-block;font-size:10px}.timepicker-dial__hint span{font-size:14px}"] }]
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [NGX_MAT_TIMEPICKER_LOCALE]
            }] }]; }, { hourChanged: [{
            type: Output
        }], minuteChanged: [{
            type: Output
        }], periodChanged: [{
            type: Output
        }], timeUnitChanged: [{
            type: Output
        }], color: [{
            type: Input
        }], activeTimeUnit: [{
            type: Input
        }], editableHintTmpl: [{
            type: Input
        }], format: [{
            type: Input
        }], hour: [{
            type: Input
        }], hoursOnly: [{
            type: Input
        }], isEditable: [{
            type: Input
        }], maxTime: [{
            type: Input
        }], minTime: [{
            type: Input
        }], minute: [{
            type: Input
        }], minutesGap: [{
            type: Input
        }], period: [{
            type: Input
        }] }); })();
function NgxMatTimepickerDialComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    NgxMatTimepickerDialComponent.prototype.activeTimeUnit;
    /** @type {?} */
    NgxMatTimepickerDialComponent.prototype.editableHintTmpl;
    /** @type {?} */
    NgxMatTimepickerDialComponent.prototype.format;
    /** @type {?} */
    NgxMatTimepickerDialComponent.prototype.hour;
    /** @type {?} */
    NgxMatTimepickerDialComponent.prototype.hourChanged;
    /** @type {?} */
    NgxMatTimepickerDialComponent.prototype.hours;
    /** @type {?} */
    NgxMatTimepickerDialComponent.prototype.hoursOnly;
    /** @type {?} */
    NgxMatTimepickerDialComponent.prototype.isEditable;
    /** @type {?} */
    NgxMatTimepickerDialComponent.prototype.isHintVisible;
    /** @type {?} */
    NgxMatTimepickerDialComponent.prototype.maxTime;
    /** @type {?} */
    NgxMatTimepickerDialComponent.prototype.meridiems;
    /** @type {?} */
    NgxMatTimepickerDialComponent.prototype.minTime;
    /** @type {?} */
    NgxMatTimepickerDialComponent.prototype.minute;
    /** @type {?} */
    NgxMatTimepickerDialComponent.prototype.minuteChanged;
    /** @type {?} */
    NgxMatTimepickerDialComponent.prototype.minutes;
    /** @type {?} */
    NgxMatTimepickerDialComponent.prototype.minutesGap;
    /** @type {?} */
    NgxMatTimepickerDialComponent.prototype.period;
    /** @type {?} */
    NgxMatTimepickerDialComponent.prototype.periodChanged;
    /** @type {?} */
    NgxMatTimepickerDialComponent.prototype.timeUnit;
    /** @type {?} */
    NgxMatTimepickerDialComponent.prototype.timeUnitChanged;
    /** @type {?} */
    NgxMatTimepickerDialComponent.prototype._color;
    /** @type {?} */
    NgxMatTimepickerDialComponent.prototype._locale;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/** @enum {string} */
const NgxMatTimepickerMeasure = {
    hour: "hour",
    minute: "minute",
};

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxMatTimepickerParserPipe {
    /**
     * @param {?} _locale
     */
    constructor(_locale) {
        this._locale = _locale;
        this._numberingSystem = DateTime.local().setLocale(this._locale).resolvedLocaleOpts().numberingSystem;
    }
    /**
     * @param {?} time
     * @param {?=} timeUnit
     * @return {?}
     */
    transform(time, timeUnit = NgxMatTimepickerUnits.HOUR) {
        if (time == null || time === "") {
            return "";
        }
        if (!isNaN(+time)) {
            return `${time}`;
        }
        if (timeUnit === NgxMatTimepickerUnits.MINUTE) {
            return this._parseTime(time, "mm", NgxMatTimepickerMeasure.minute).toString();
        }
        return this._parseTime(time, "HH", NgxMatTimepickerMeasure.hour).toString();
    }
    /**
     * @param {?} time
     * @param {?} format
     * @param {?} timeMeasure
     * @return {?}
     */
    _parseTime(time, format, timeMeasure) {
        const /** @type {?} */ parsedTime = DateTime.fromFormat(String(time), format, { numberingSystem: this._numberingSystem })[timeMeasure];
        if (!isNaN(parsedTime)) {
            return parsedTime;
        }
        throw new Error(`Cannot parse time - ${time}`);
    }
}
NgxMatTimepickerParserPipe.ɵfac = function NgxMatTimepickerParserPipe_Factory(t) { return new (t || NgxMatTimepickerParserPipe)(ɵngcc0.ɵɵdirectiveInject(NGX_MAT_TIMEPICKER_LOCALE, 16)); };
NgxMatTimepickerParserPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "ngxMatTimepickerParser", type: NgxMatTimepickerParserPipe, pure: true });
NgxMatTimepickerParserPipe.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: NgxMatTimepickerParserPipe, factory: NgxMatTimepickerParserPipe.ɵfac });
/** @nocollapse */
NgxMatTimepickerParserPipe.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [NGX_MAT_TIMEPICKER_LOCALE,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepickerParserPipe, [{
        type: Pipe,
        args: [{
                name: "ngxMatTimepickerParser"
            }]
    }, {
        type: Injectable
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [NGX_MAT_TIMEPICKER_LOCALE]
            }] }]; }, null); })();
function NgxMatTimepickerParserPipe_tsickle_Closure_declarations() {
    /** @type {?} */
    NgxMatTimepickerParserPipe.prototype._numberingSystem;
    /** @type {?} */
    NgxMatTimepickerParserPipe.prototype._locale;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @return {?}
 */
function retainSelection() {
    this.selectionStart = this.selectionEnd;
}
class NgxMatTimepickerDialControlComponent {
    /**
     * @param {?} _elRef
     * @param {?} _timeParserPipe
     */
    constructor(_elRef, _timeParserPipe) {
        this._elRef = _elRef;
        this._timeParserPipe = _timeParserPipe;
        this.focused = new EventEmitter();
        this.timeChanged = new EventEmitter();
        this.timeUnitChanged = new EventEmitter();
        this.unfocused = new EventEmitter();
    }
    /**
     * @return {?}
     */
    get _selectedTime() {
        if (!!this.time) {
            return this.timeList.find(t => t.time === +this.time);
        }
    }
    /**
     * @param {?} e
     * @return {?}
     */
    changeTimeByKeyboard(e) {
        const /** @type {?} */ char = String.fromCharCode(e.keyCode);
        if (isTimeDisabledToChange(this.time, char, this.timeList)) {
            e.preventDefault();
        }
    }
    /**
     * @return {?}
     */
    ngAfterViewInit() {
        this._elRef.nativeElement.querySelector("input").addEventListener("select", retainSelection, false);
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this._elRef.nativeElement.querySelector("input").removeEventListener("select", retainSelection);
    }
    /**
     * @param {?} e
     * @return {?}
     */
    onKeydown(e) {
        if (!NgxMatTimepickerUtils.isDigit(e)) {
            e.preventDefault();
        }
        else {
            this._changeTimeByArrow(e.keyCode);
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    onModelChange(value) {
        this.time = this._timeParserPipe.transform(value, this.timeUnit);
    }
    /**
     * @param {?} event
     * @param {?} unit
     * @return {?}
     */
    saveTimeAndChangeTimeUnit(event, unit) {
        event.preventDefault();
        this.previousTime = this.time;
        this.timeUnitChanged.next(unit);
        this.focused.next();
    }
    /**
     * @return {?}
     */
    updateTime() {
        if (this._selectedTime) {
            this.timeChanged.next(this._selectedTime);
            this.previousTime = this._selectedTime.time;
        }
    }
    /**
     * @param {?} amount
     * @return {?}
     */
    _addTime(amount) {
        return `0${+this.time + amount}`.substr(-2);
    }
    /**
     * @param {?} keyCode
     * @return {?}
     */
    _changeTimeByArrow(keyCode) {
        let /** @type {?} */ time;
        // arrow up
        if (keyCode === 38) {
            time = this._addTime(this.minutesGap || 1);
        }
        // arrow down
        else if (keyCode === 40) {
            time = this._addTime(-1 * (this.minutesGap || 1));
        }
        if (!isTimeUnavailable(time, this.timeList)) {
            this.time = time;
            this.updateTime();
        }
    }
}
NgxMatTimepickerDialControlComponent.ɵfac = function NgxMatTimepickerDialControlComponent_Factory(t) { return new (t || NgxMatTimepickerDialControlComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(NgxMatTimepickerParserPipe)); };
NgxMatTimepickerDialControlComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxMatTimepickerDialControlComponent, selectors: [["ngx-mat-timepicker-dial-control"]], inputs: { time: "time", disabled: "disabled", isActive: "isActive", isEditable: "isEditable", minutesGap: "minutesGap", timeList: "timeList", timeUnit: "timeUnit" }, outputs: { focused: "focused", timeChanged: "timeChanged", timeUnitChanged: "timeUnitChanged", unfocused: "unfocused" }, features: [ɵngcc0.ɵɵProvidersFeature([NgxMatTimepickerParserPipe])], decls: 3, vars: 2, consts: [["class", "timepicker-dial__control timepicker-dial__item", "readonly", "", 3, "ngClass", "ngModel", "disabled", "ngxMatTimepickerAutofocus", "ngModelChange", "input", "focus", 4, "ngIf", "ngIfElse"], ["editableTemplate", ""], ["readonly", "", 1, "timepicker-dial__control", "timepicker-dial__item", 3, "ngClass", "ngModel", "disabled", "ngxMatTimepickerAutofocus", "ngModelChange", "input", "focus"], [1, "timepicker-dial__control", "timepicker-dial__item", "timepicker-dial__control_editable", 3, "ngClass", "ngModel", "disabled", "ngxMatTimepickerAutofocus", "ngModelChange", "input", "focus", "keydown", "keypress"]], template: function NgxMatTimepickerDialControlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, NgxMatTimepickerDialControlComponent_input_0_Template, 2, 10, "input", 0);
        ɵngcc0.ɵɵtemplate(1, NgxMatTimepickerDialControlComponent_ng_template_1_Template, 3, 13, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isEditable)("ngIfElse", _r1);
    } }, dependencies: function () { return [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc2.DefaultValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgModel, NgxMatTimepickerAutofocusDirective, NgxMatTimepickerParserPipe, NgxMatTimepickerTimeLocalizerPipe]; }, styles: [".timepicker-dial__control[_ngcontent-%COMP%]{background-color:transparent;border:none;border-radius:3px;color:inherit;font-size:50px;padding:0;text-align:center;width:60px}.timepicker-dial__control[_ngcontent-%COMP%]:focus{background-color:rgba(0,0,0,.1);outline:none}.timepicker-dial__control[_ngcontent-%COMP%]:disabled{cursor:default}"] });
/** @nocollapse */
NgxMatTimepickerDialControlComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: NgxMatTimepickerParserPipe }
];
NgxMatTimepickerDialControlComponent.propDecorators = {
    disabled: [{ type: Input }],
    focused: [{ type: Output }],
    isActive: [{ type: Input }],
    isEditable: [{ type: Input }],
    minutesGap: [{ type: Input }],
    time: [{ type: Input }],
    timeChanged: [{ type: Output }],
    timeList: [{ type: Input }],
    timeUnit: [{ type: Input }],
    timeUnitChanged: [{ type: Output }],
    unfocused: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepickerDialControlComponent, [{
        type: Component,
        args: [{ selector: "ngx-mat-timepicker-dial-control", template: "<input class=\"timepicker-dial__control timepicker-dial__item\"\r\n       [ngClass]=\"{'active': isActive}\"\r\n       [ngModel]=\"time | timeLocalizer: timeUnit: true\"\r\n       (ngModelChange)=\"time = $event\"\r\n       [disabled]=\"disabled\"\r\n       (input)=\"updateTime()\"\r\n       (focus)=\"saveTimeAndChangeTimeUnit($event, timeUnit)\"\r\n       readonly\r\n       [ngxMatTimepickerAutofocus]=\"isActive\"\r\n       *ngIf=\"!isEditable;else editableTemplate\">\r\n\r\n<ng-template #editableTemplate>\r\n    <input class=\"timepicker-dial__control timepicker-dial__item timepicker-dial__control_editable\"\r\n           [ngClass]=\"{'active': isActive}\"\r\n           [ngModel]=\"time | ngxMatTimepickerParser: timeUnit | timeLocalizer: timeUnit : true\"\r\n           (ngModelChange)=\"onModelChange($event)\"\r\n           [disabled]=\"disabled\"\r\n           (input)=\"updateTime()\"\r\n           (focus)=\"saveTimeAndChangeTimeUnit($event, timeUnit)\"\r\n           [ngxMatTimepickerAutofocus]=\"isActive\"\r\n           (keydown)=\"onKeydown($event)\"\r\n           (keypress)=\"changeTimeByKeyboard($event)\">\r\n</ng-template>\r\n", providers: [NgxMatTimepickerParserPipe], styles: [".timepicker-dial__control{background-color:transparent;border:none;border-radius:3px;color:inherit;font-size:50px;padding:0;text-align:center;width:60px}.timepicker-dial__control:focus{background-color:rgba(0,0,0,.1);outline:none}.timepicker-dial__control:disabled{cursor:default}"] }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: NgxMatTimepickerParserPipe }]; }, { focused: [{
            type: Output
        }], timeChanged: [{
            type: Output
        }], timeUnitChanged: [{
            type: Output
        }], unfocused: [{
            type: Output
        }], time: [{
            type: Input
        }], disabled: [{
            type: Input
        }], isActive: [{
            type: Input
        }], isEditable: [{
            type: Input
        }], minutesGap: [{
            type: Input
        }], timeList: [{
            type: Input
        }], timeUnit: [{
            type: Input
        }] }); })();
function NgxMatTimepickerDialControlComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    NgxMatTimepickerDialControlComponent.prototype.disabled;
    /** @type {?} */
    NgxMatTimepickerDialControlComponent.prototype.focused;
    /** @type {?} */
    NgxMatTimepickerDialControlComponent.prototype.isActive;
    /** @type {?} */
    NgxMatTimepickerDialControlComponent.prototype.isEditable;
    /** @type {?} */
    NgxMatTimepickerDialControlComponent.prototype.minutesGap;
    /** @type {?} */
    NgxMatTimepickerDialControlComponent.prototype.previousTime;
    /** @type {?} */
    NgxMatTimepickerDialControlComponent.prototype.time;
    /** @type {?} */
    NgxMatTimepickerDialControlComponent.prototype.timeChanged;
    /** @type {?} */
    NgxMatTimepickerDialControlComponent.prototype.timeList;
    /** @type {?} */
    NgxMatTimepickerDialControlComponent.prototype.timeUnit;
    /** @type {?} */
    NgxMatTimepickerDialControlComponent.prototype.timeUnitChanged;
    /** @type {?} */
    NgxMatTimepickerDialControlComponent.prototype.unfocused;
    /** @type {?} */
    NgxMatTimepickerDialControlComponent.prototype._elRef;
    /** @type {?} */
    NgxMatTimepickerDialControlComponent.prototype._timeParserPipe;
}
/**
 * @param {?} currentTime
 * @param {?} nextTime
 * @param {?} timeList
 * @return {?}
 */
function isTimeDisabledToChange(currentTime, nextTime, timeList) {
    const /** @type {?} */ isNumber = /\d/.test(nextTime);
    if (isNumber) {
        const /** @type {?} */ time = currentTime + nextTime;
        return isTimeUnavailable(time, timeList);
    }
}
/**
 * @param {?} time
 * @param {?} timeList
 * @return {?}
 */
function isTimeUnavailable(time, timeList) {
    const /** @type {?} */ selectedTime = timeList.find(value => value.time === +time);
    return !selectedTime || (selectedTime && selectedTime.disabled);
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxMatTimepickerPeriodComponent {
    constructor() {
        this.isPeriodAvailable = true;
        this.periodChanged = new EventEmitter();
        this.timePeriod = NgxMatTimepickerPeriods;
    }
    /**
     * @return {?}
     */
    animationDone() {
        this.isPeriodAvailable = true;
    }
    /**
     * @param {?} period
     * @return {?}
     */
    changePeriod(period) {
        this.isPeriodAvailable = this._isSwitchPeriodAvailable(period);
        if (this.isPeriodAvailable) {
            this.periodChanged.next(period);
        }
    }
    /**
     * @param {?} period
     * @return {?}
     */
    _getDisabledTimeByPeriod(period) {
        switch (this.activeTimeUnit) {
            case NgxMatTimepickerUnits.HOUR:
                return NgxMatTimepickerUtils.disableHours(this.hours, {
                    min: this.minTime,
                    max: this.maxTime,
                    format: this.format,
                    period
                });
            case NgxMatTimepickerUnits.MINUTE:
                return NgxMatTimepickerUtils.disableMinutes(this.minutes, +this.selectedHour, {
                    min: this.minTime,
                    max: this.maxTime,
                    format: this.format,
                    period
                });
            default:
                throw new Error("no such NgxMatTimepickerUnits");
        }
    }
    /**
     * @param {?} period
     * @return {?}
     */
    _isSwitchPeriodAvailable(period) {
        const /** @type {?} */ time = this._getDisabledTimeByPeriod(period);
        return !time.every(t => t.disabled);
    }
}
NgxMatTimepickerPeriodComponent.ɵfac = function NgxMatTimepickerPeriodComponent_Factory(t) { return new (t || NgxMatTimepickerPeriodComponent)(); };
NgxMatTimepickerPeriodComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxMatTimepickerPeriodComponent, selectors: [["ngx-mat-timepicker-period"]], inputs: { activeTimeUnit: "activeTimeUnit", format: "format", hours: "hours", maxTime: "maxTime", meridiems: "meridiems", minTime: "minTime", minutes: "minutes", selectedHour: "selectedHour", selectedPeriod: "selectedPeriod" }, outputs: { periodChanged: "periodChanged" }, decls: 6, vars: 9, consts: [[1, "timepicker-period"], ["type", "button", 1, "timepicker-dial__item", "timepicker-period__btn", 3, "ngClass", "click"], ["class", "timepicker-period__warning", 4, "ngIf"], [1, "timepicker-period__warning"]], template: function NgxMatTimepickerPeriodComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
        ɵngcc0.ɵɵlistener("click", function NgxMatTimepickerPeriodComponent_Template_button_click_1_listener() { return ctx.changePeriod(ctx.timePeriod.AM); });
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "button", 1);
        ɵngcc0.ɵɵlistener("click", function NgxMatTimepickerPeriodComponent_Template_button_click_3_listener() { return ctx.changePeriod(ctx.timePeriod.PM); });
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, NgxMatTimepickerPeriodComponent_div_5_Template, 3, 1, "div", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c10, ctx.selectedPeriod === ctx.timePeriod.AM));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.meridiems[0]);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c10, ctx.selectedPeriod === ctx.timePeriod.PM));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.meridiems[1]);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.isPeriodAvailable);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgIf], styles: [".timepicker-period[_ngcontent-%COMP%]{display:flex;flex-direction:column;position:relative}.timepicker-period__btn[_ngcontent-%COMP%]{-moz-user-select:none;-webkit-user-select:none;background-color:transparent;border:0;border-radius:3px;color:inherit;font-size:18px;font-weight:500;opacity:.5;outline:none;padding:1px 3px;transition:background-color .5s;user-select:none}.timepicker-period__btn.active[_ngcontent-%COMP%]{opacity:1}.timepicker-period__btn[_ngcontent-%COMP%]:focus{background-color:rgba(0,0,0,.07)}.timepicker-period__warning[_ngcontent-%COMP%]{background-color:rgba(0,0,0,.55);border-radius:3px;left:-20px;padding:5px 10px;position:absolute;top:40px;width:200px}.timepicker-period__warning[_ngcontent-%COMP%] > p[_ngcontent-%COMP%]{font-size:12px;margin:0}"], data: { animation: [
            trigger("scaleInOut", [
                transition(":enter", [
                    style({ transform: "scale(0)" }),
                    animate(".2s", style({ transform: "scale(1)" })),
                    sequence([
                        animate("3s", style({ opacity: 1 })),
                        animate(".3s", style({ opacity: 0 }))
                    ])
                ])
            ])
        ] } });
NgxMatTimepickerPeriodComponent.propDecorators = {
    activeTimeUnit: [{ type: Input }],
    format: [{ type: Input }],
    hours: [{ type: Input }],
    maxTime: [{ type: Input }],
    meridiems: [{ type: Input }],
    minTime: [{ type: Input }],
    minutes: [{ type: Input }],
    periodChanged: [{ type: Output }],
    selectedHour: [{ type: Input }],
    selectedPeriod: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepickerPeriodComponent, [{
        type: Component,
        args: [{ selector: "ngx-mat-timepicker-period", template: "<div class=\"timepicker-period\">\r\n    <button class=\"timepicker-dial__item timepicker-period__btn\"\r\n            [ngClass]=\"{'active': selectedPeriod === timePeriod.AM}\"\r\n            (click)=\"changePeriod(timePeriod.AM)\"\r\n            type=\"button\">{{meridiems[0]}}</button>\r\n    <button class=\"timepicker-dial__item timepicker-period__btn\"\r\n            [ngClass]=\"{'active': selectedPeriod === timePeriod.PM}\"\r\n            (click)=\"changePeriod(timePeriod.PM)\"\r\n            type=\"button\">{{meridiems[1]}}</button>\r\n    <div class=\"timepicker-period__warning\"\r\n         [@scaleInOut]\r\n         (@scaleInOut.done)=\"animationDone()\"\r\n         *ngIf=\"!isPeriodAvailable\">\r\n        <p>Current time would be invalid in this period.</p>\r\n    </div>\r\n</div>\r\n", animations: [
                    trigger("scaleInOut", [
                        transition(":enter", [
                            style({ transform: "scale(0)" }),
                            animate(".2s", style({ transform: "scale(1)" })),
                            sequence([
                                animate("3s", style({ opacity: 1 })),
                                animate(".3s", style({ opacity: 0 }))
                            ])
                        ])
                    ])
                ], styles: [".timepicker-period{display:flex;flex-direction:column;position:relative}.timepicker-period__btn{-moz-user-select:none;-webkit-user-select:none;background-color:transparent;border:0;border-radius:3px;color:inherit;font-size:18px;font-weight:500;opacity:.5;outline:none;padding:1px 3px;transition:background-color .5s;user-select:none}.timepicker-period__btn.active{opacity:1}.timepicker-period__btn:focus{background-color:rgba(0,0,0,.07)}.timepicker-period__warning{background-color:rgba(0,0,0,.55);border-radius:3px;left:-20px;padding:5px 10px;position:absolute;top:40px;width:200px}.timepicker-period__warning>p{font-size:12px;margin:0}"] }]
    }], function () { return []; }, { periodChanged: [{
            type: Output
        }], activeTimeUnit: [{
            type: Input
        }], format: [{
            type: Input
        }], hours: [{
            type: Input
        }], maxTime: [{
            type: Input
        }], meridiems: [{
            type: Input
        }], minTime: [{
            type: Input
        }], minutes: [{
            type: Input
        }], selectedHour: [{
            type: Input
        }], selectedPeriod: [{
            type: Input
        }] }); })();
function NgxMatTimepickerPeriodComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    NgxMatTimepickerPeriodComponent.prototype.activeTimeUnit;
    /** @type {?} */
    NgxMatTimepickerPeriodComponent.prototype.format;
    /** @type {?} */
    NgxMatTimepickerPeriodComponent.prototype.hours;
    /** @type {?} */
    NgxMatTimepickerPeriodComponent.prototype.isPeriodAvailable;
    /** @type {?} */
    NgxMatTimepickerPeriodComponent.prototype.maxTime;
    /** @type {?} */
    NgxMatTimepickerPeriodComponent.prototype.meridiems;
    /** @type {?} */
    NgxMatTimepickerPeriodComponent.prototype.minTime;
    /** @type {?} */
    NgxMatTimepickerPeriodComponent.prototype.minutes;
    /** @type {?} */
    NgxMatTimepickerPeriodComponent.prototype.periodChanged;
    /** @type {?} */
    NgxMatTimepickerPeriodComponent.prototype.selectedHour;
    /** @type {?} */
    NgxMatTimepickerPeriodComponent.prototype.selectedPeriod;
    /** @type {?} */
    NgxMatTimepickerPeriodComponent.prototype.timePeriod;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxMatTimepickerTimeFormatterPipe {
    /**
     * @param {?} time
     * @param {?} timeUnit
     * @return {?}
     */
    transform(time, timeUnit) {
        if (time == null || time === '') {
            return time;
        }
        switch (timeUnit) {
            case NgxMatTimepickerUnits.HOUR:
                return DateTime.fromObject({ hour: +time }).toFormat("HH");
            case NgxMatTimepickerUnits.MINUTE:
                return DateTime.fromObject({ minute: +time }).toFormat("mm");
            default:
                throw new Error("no such time unit");
        }
    }
}
NgxMatTimepickerTimeFormatterPipe.ɵfac = function NgxMatTimepickerTimeFormatterPipe_Factory(t) { return new (t || NgxMatTimepickerTimeFormatterPipe)(); };
NgxMatTimepickerTimeFormatterPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "timeFormatter", type: NgxMatTimepickerTimeFormatterPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepickerTimeFormatterPipe, [{
        type: Pipe,
        args: [{
                name: "timeFormatter"
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxMatTimepickerMinutesFormatterPipe {
    /**
     * @param {?} minute
     * @param {?=} gap
     * @return {?}
     */
    transform(minute, gap = 5) {
        if (!minute) {
            return minute;
        }
        return minute % gap === 0 ? minute : '';
    }
}
NgxMatTimepickerMinutesFormatterPipe.ɵfac = function NgxMatTimepickerMinutesFormatterPipe_Factory(t) { return new (t || NgxMatTimepickerMinutesFormatterPipe)(); };
NgxMatTimepickerMinutesFormatterPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "minutesFormatter", type: NgxMatTimepickerMinutesFormatterPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepickerMinutesFormatterPipe, [{
        type: Pipe,
        args: [{
                name: 'minutesFormatter'
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxMatTimepickerAutofocusDirective {
    /**
     * @param {?} _element
     * @param {?} document
     */
    constructor(_element, document) {
        this._element = _element;
        this.document = document;
        this._activeElement = this.document.activeElement;
    }
    /**
     * @return {?}
     */
    ngOnChanges() {
        if (this.isFocusActive) {
            // To avoid ExpressionChangedAfterItHasBeenCheckedError;
            setTimeout(() => this._element.nativeElement.focus({ preventScroll: true }));
        }
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        // To avoid ExpressionChangedAfterItHasBeenCheckedError;
        setTimeout(() => this._activeElement.focus({ preventScroll: true }));
    }
}
NgxMatTimepickerAutofocusDirective.ɵfac = function NgxMatTimepickerAutofocusDirective_Factory(t) { return new (t || NgxMatTimepickerAutofocusDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(DOCUMENT, 8)); };
NgxMatTimepickerAutofocusDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: NgxMatTimepickerAutofocusDirective, selectors: [["", "ngxMatTimepickerAutofocus", ""]], inputs: { isFocusActive: ["ngxMatTimepickerAutofocus", "isFocusActive"] }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
/** @nocollapse */
NgxMatTimepickerAutofocusDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [DOCUMENT,] }] }
];
NgxMatTimepickerAutofocusDirective.propDecorators = {
    isFocusActive: [{ type: Input, args: ["ngxMatTimepickerAutofocus",] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepickerAutofocusDirective, [{
        type: Directive,
        args: [{
                selector: "[ngxMatTimepickerAutofocus]"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [DOCUMENT]
            }] }]; }, { isFocusActive: [{
            type: Input,
            args: ["ngxMatTimepickerAutofocus"]
        }] }); })();
function NgxMatTimepickerAutofocusDirective_tsickle_Closure_declarations() {
    /** @type {?} */
    NgxMatTimepickerAutofocusDirective.prototype.isFocusActive;
    /** @type {?} */
    NgxMatTimepickerAutofocusDirective.prototype._activeElement;
    /** @type {?} */
    NgxMatTimepickerAutofocusDirective.prototype._element;
    /** @type {?} */
    NgxMatTimepickerAutofocusDirective.prototype.document;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * @param {?} currentTime
 * @param {?} nextTime
 * @return {?}
 */
function concatTime(currentTime, nextTime) {
    const /** @type {?} */ isNumber = /\d/.test(nextTime);
    if (isNumber) {
        const /** @type {?} */ time = currentTime + nextTime;
        return +time;
    }
}
class NgxMatTimepickerControlComponent {
    /**
     * @param {?} _timeParser
     */
    constructor(_timeParser) {
        this._timeParser = _timeParser;
        this.id = NgxMatTimepickerControlComponent.nextId++;
        this.timeChanged = new EventEmitter();
        this._color = "primary";
        this._floatLabel = "never";
    }
    /**
     * @param {?} newValue
     * @return {?}
     */
    set color(newValue) {
        this._color = newValue;
    }
    /**
     * @return {?}
     */
    get color() {
        return this._color;
    }
    /**
     * @param {?} newValue
     * @return {?}
     */
    set floatLabel(newValue) {
        this._floatLabel = newValue;
    }
    /**
     * @return {?}
     */
    get floatLabel() {
        return this._floatLabel;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    changeTime(event) {
        event.stopPropagation();
        const /** @type {?} */ char = String.fromCharCode(event.keyCode);
        const /** @type {?} */ time = concatTime(String(this.time), char);
        this._changeTimeIfValid(time);
    }
    /**
     * @return {?}
     */
    decrease() {
        if (!this.disabled) {
            let /** @type {?} */ previousTime = +this.time - 1;
            if (previousTime < this.min) {
                previousTime = this.max;
            }
            if (this._isSelectedTimeDisabled(previousTime)) {
                previousTime = this._getAvailableTime(previousTime, this._getPrevAvailableTime.bind(this));
            }
            if (previousTime !== this.time) {
                this.timeChanged.emit(previousTime);
            }
        }
    }
    /**
     * @return {?}
     */
    increase() {
        if (!this.disabled) {
            let /** @type {?} */ nextTime = +this.time + 1;
            if (nextTime > this.max) {
                nextTime = this.min;
            }
            if (this._isSelectedTimeDisabled(nextTime)) {
                nextTime = this._getAvailableTime(nextTime, this._getNextAvailableTime.bind(this));
            }
            if (nextTime !== this.time) {
                this.timeChanged.emit(nextTime);
            }
        }
    }
    /**
     * @param {?} changes
     * @return {?}
     */
    ngOnChanges(changes) {
        if (changes["timeList"] && this.time != null) {
            if (this._isSelectedTimeDisabled(this.time)) {
                this._setAvailableTime();
            }
        }
    }
    /**
     * @return {?}
     */
    onBlur() {
        this.isFocused = false;
        if (this._previousTime !== this.time) {
            this._changeTimeIfValid(+this.time);
        }
    }
    /**
     * @return {?}
     */
    onFocus() {
        this.isFocused = true;
        this._previousTime = this.time;
    }
    /**
     * @param {?} event
     * @return {?}
     */
    onKeydown(event) {
        event.stopPropagation();
        if (!NgxMatTimepickerUtils.isDigit(event)) {
            event.preventDefault();
        }
        switch (event.key) {
            case "ArrowUp":
                this.increase();
                break;
            case "ArrowDown":
                this.decrease();
                break;
        }
        if (this.preventTyping && event.key !== "Tab") {
            event.preventDefault();
        }
    }
    /**
     * @param {?} value
     * @return {?}
     */
    onModelChange(value) {
        this.time = +this._timeParser.transform(value, this.timeUnit);
    }
    /**
     * @param {?} value
     * @return {?}
     */
    _changeTimeIfValid(value) {
        if (!isNaN(value)) {
            this.time = value;
            if (this.time > this.max) {
                const /** @type {?} */ timeString = String(value);
                this.time = +timeString[timeString.length - 1];
            }
            if (this.time < this.min) {
                this.time = this.min;
            }
            this.timeChanged.emit(this.time);
        }
    }
    /**
     * @param {?} currentTime
     * @param {?} fn
     * @return {?}
     */
    _getAvailableTime(currentTime, fn) {
        const /** @type {?} */ currentTimeIndex = this.timeList.findIndex(time => time.time === currentTime);
        const /** @type {?} */ availableTime = fn(currentTimeIndex);
        return availableTime != null ? availableTime : this.time;
    }
    /**
     * @param {?} index
     * @return {?}
     */
    _getNextAvailableTime(index) {
        const /** @type {?} */ timeCollection = this.timeList;
        const /** @type {?} */ maxValue = timeCollection.length;
        for (let /** @type {?} */ i = index + 1; i < maxValue; i++) {
            const /** @type {?} */ time = timeCollection[i];
            if (!time.disabled) {
                return time.time;
            }
        }
    }
    /**
     * @param {?} index
     * @return {?}
     */
    _getPrevAvailableTime(index) {
        for (let /** @type {?} */ i = index; i >= 0; i--) {
            const /** @type {?} */ time = this.timeList[i];
            if (!time.disabled) {
                return time.time;
            }
        }
    }
    /**
     * @param {?} time
     * @return {?}
     */
    _isSelectedTimeDisabled(time) {
        return this.timeList.find((faceTime) => faceTime.time === time).disabled;
    }
    /**
     * @return {?}
     */
    _setAvailableTime() {
        this.time = this.timeList.find(t => !t.disabled).time;
        this.timeChanged.emit(this.time);
    }
}
NgxMatTimepickerControlComponent.ɵfac = function NgxMatTimepickerControlComponent_Factory(t) { return new (t || NgxMatTimepickerControlComponent)(ɵngcc0.ɵɵdirectiveInject(NgxMatTimepickerParserPipe)); };
NgxMatTimepickerControlComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxMatTimepickerControlComponent, selectors: [["ngx-mat-timepicker-time-control"]], inputs: { color: "color", floatLabel: "floatLabel", time: "time", disabled: "disabled", max: "max", min: "min", placeholder: "placeholder", preventTyping: "preventTyping", timeList: "timeList", timeUnit: "timeUnit" }, outputs: { timeChanged: "timeChanged" }, features: [ɵngcc0.ɵɵProvidersFeature([NgxMatTimepickerParserPipe]), ɵngcc0.ɵɵNgOnChangesFeature], decls: 13, vars: 17, consts: [[1, "ngx-mat-timepicker-control", 3, "color", "floatLabel", "ngClass"], ["matInput", "", "maxlength", "2", 3, "id", "name", "ngModel", "placeholder", "disabled", "ngModelChange", "keydown", "keypress", "focus", "blur"], ["matSuffix", "", 1, "arrows-wrap"], ["role", "button", 1, "arrow", 3, "click"], ["xmlns", "http://www.w3.org/2000/svg", "height", "18", "viewBox", "0 0 24 24", "width", "18"], ["d", "M0 0h24v24H0z", "fill", "none"], ["d", "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"], ["d", "M0 0h24v24H0V0z", "fill", "none"], ["d", "M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"]], template: function NgxMatTimepickerControlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "mat-form-field", 0)(1, "input", 1);
        ɵngcc0.ɵɵlistener("ngModelChange", function NgxMatTimepickerControlComponent_Template_input_ngModelChange_1_listener($event) { return ctx.onModelChange($event); })("keydown", function NgxMatTimepickerControlComponent_Template_input_keydown_1_listener($event) { return ctx.onKeydown($event); })("keypress", function NgxMatTimepickerControlComponent_Template_input_keypress_1_listener($event) { return ctx.changeTime($event); })("focus", function NgxMatTimepickerControlComponent_Template_input_focus_1_listener() { return ctx.onFocus(); })("blur", function NgxMatTimepickerControlComponent_Template_input_blur_1_listener() { return ctx.onBlur(); });
        ɵngcc0.ɵɵpipe(2, "timeLocalizer");
        ɵngcc0.ɵɵpipe(3, "ngxMatTimepickerParser");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 2)(5, "span", 3);
        ɵngcc0.ɵɵlistener("click", function NgxMatTimepickerControlComponent_Template_span_click_5_listener() { return ctx.increase(); });
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(6, "svg", 4);
        ɵngcc0.ɵɵelement(7, "path", 5)(8, "path", 6);
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵnamespaceHTML();
        ɵngcc0.ɵɵelementStart(9, "span", 3);
        ɵngcc0.ɵɵlistener("click", function NgxMatTimepickerControlComponent_Template_span_click_9_listener() { return ctx.decrease(); });
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(10, "svg", 4);
        ɵngcc0.ɵɵelement(11, "path", 7)(12, "path", 8);
        ɵngcc0.ɵɵelementEnd()()()();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("color", ctx.color)("floatLabel", ctx.floatLabel)("ngClass", ɵngcc0.ɵɵpureFunction1(15, _c10, ctx.isFocused));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate1("id", "ngx_mat_timepicker_field_", ctx.id, "")("name", "ngx_mat_timepicker_field_", ctx.id, "");
        ɵngcc0.ɵɵproperty("ngModel", ɵngcc0.ɵɵpipeBind3(2, 8, ɵngcc0.ɵɵpipeBind2(3, 12, ctx.time, ctx.timeUnit), ctx.timeUnit, true))("placeholder", ctx.placeholder)("disabled", ctx.disabled);
    } }, dependencies: function () { return [ɵngcc1.NgClass, ɵngcc2.DefaultValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.MaxLengthValidator, ɵngcc2.NgModel, ɵngcc3.MatFormField, ɵngcc3.MatSuffix, ɵngcc12.MatInput, NgxMatTimepickerParserPipe, NgxMatTimepickerTimeLocalizerPipe]; }, styles: [".ngx-mat-timepicker-control[_ngcontent-%COMP%]{min-width:60px;width:60px}.ngx-mat-timepicker-control[_ngcontent-%COMP%]   input[_ngcontent-%COMP%]{text-align:center}.ngx-mat-timepicker-control[_ngcontent-%COMP%]   .arrows-wrap[_ngcontent-%COMP%]{bottom:-8px;display:flex;flex-direction:column;position:absolute;right:0}.ngx-mat-timepicker-control[_ngcontent-%COMP%]   .arrows-wrap[_ngcontent-%COMP%] > .arrow[_ngcontent-%COMP%]{-moz-user-select:none;-webkit-user-select:none;cursor:pointer;height:15px;opacity:.5;text-align:center;transition:opacity .2s;user-select:none}.ngx-mat-timepicker-control[_ngcontent-%COMP%]   .arrows-wrap[_ngcontent-%COMP%] > .arrow[_ngcontent-%COMP%]:hover{opacity:1}"], changeDetection: 0 });
NgxMatTimepickerControlComponent.nextId = 0;
/** @nocollapse */
NgxMatTimepickerControlComponent.ctorParameters = () => [
    { type: NgxMatTimepickerParserPipe }
];
NgxMatTimepickerControlComponent.propDecorators = {
    color: [{ type: Input }],
    disabled: [{ type: Input }],
    floatLabel: [{ type: Input }],
    max: [{ type: Input }],
    min: [{ type: Input }],
    placeholder: [{ type: Input }],
    preventTyping: [{ type: Input }],
    time: [{ type: Input }],
    timeChanged: [{ type: Output }],
    timeList: [{ type: Input }],
    timeUnit: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepickerControlComponent, [{
        type: Component,
        args: [{ selector: "ngx-mat-timepicker-time-control", template: "<mat-form-field [color]=\"color\"\r\n                [floatLabel]=\"floatLabel\"\r\n                [ngClass]=\"{'active': isFocused}\"\r\n                class=\"ngx-mat-timepicker-control\">\r\n    <input id=\"ngx_mat_timepicker_field_{{id}}\"\r\n           name=\"ngx_mat_timepicker_field_{{id}}\"\r\n           matInput\r\n           maxlength=\"2\"\r\n           [ngModel]=\"time | ngxMatTimepickerParser: timeUnit | timeLocalizer: timeUnit : true\"\r\n           (ngModelChange)=\"onModelChange($event)\"\r\n           [placeholder]=\"placeholder\"\r\n           [disabled]=\"disabled\"\r\n           (keydown)=\"onKeydown($event)\"\r\n           (keypress)=\"changeTime($event)\"\r\n           (focus)=\"onFocus()\"\r\n           (blur)=\"onBlur()\" />\r\n    <div class=\"arrows-wrap\"\r\n         matSuffix>\r\n        <span class=\"arrow\"\r\n              role=\"button\"\r\n              (click)=\"increase()\">\r\n            <svg xmlns=\"http://www.w3.org/2000/svg\"\r\n                 height=\"18\"\r\n                 viewBox=\"0 0 24 24\"\r\n                 width=\"18\">\r\n                <path d=\"M0 0h24v24H0z\"\r\n                      fill=\"none\" />\r\n                <path d=\"M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z\" />\r\n            </svg>\r\n        </span>\r\n        <span class=\"arrow\"\r\n              role=\"button\"\r\n              (click)=\"decrease()\">\r\n            <svg xmlns=\"http://www.w3.org/2000/svg\"\r\n                 height=\"18\"\r\n                 viewBox=\"0 0 24 24\"\r\n                 width=\"18\">\r\n                <path d=\"M0 0h24v24H0V0z\"\r\n                      fill=\"none\" />\r\n                <path d=\"M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z\" />\r\n            </svg>\r\n        </span>\r\n    </div>\r\n</mat-form-field>\r\n", changeDetection: ChangeDetectionStrategy.OnPush, providers: [NgxMatTimepickerParserPipe], styles: [".ngx-mat-timepicker-control{min-width:60px;width:60px}.ngx-mat-timepicker-control input{text-align:center}.ngx-mat-timepicker-control .arrows-wrap{bottom:-8px;display:flex;flex-direction:column;position:absolute;right:0}.ngx-mat-timepicker-control .arrows-wrap>.arrow{-moz-user-select:none;-webkit-user-select:none;cursor:pointer;height:15px;opacity:.5;text-align:center;transition:opacity .2s;user-select:none}.ngx-mat-timepicker-control .arrows-wrap>.arrow:hover{opacity:1}"] }]
    }], function () { return [{ type: NgxMatTimepickerParserPipe }]; }, { timeChanged: [{
            type: Output
        }], color: [{
            type: Input
        }], floatLabel: [{
            type: Input
        }], time: [{
            type: Input
        }], disabled: [{
            type: Input
        }], max: [{
            type: Input
        }], min: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], preventTyping: [{
            type: Input
        }], timeList: [{
            type: Input
        }], timeUnit: [{
            type: Input
        }] }); })();
function NgxMatTimepickerControlComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    NgxMatTimepickerControlComponent.nextId;
    /** @type {?} */
    NgxMatTimepickerControlComponent.prototype.disabled;
    /** @type {?} */
    NgxMatTimepickerControlComponent.prototype.id;
    /** @type {?} */
    NgxMatTimepickerControlComponent.prototype.isFocused;
    /** @type {?} */
    NgxMatTimepickerControlComponent.prototype.max;
    /** @type {?} */
    NgxMatTimepickerControlComponent.prototype.min;
    /** @type {?} */
    NgxMatTimepickerControlComponent.prototype.placeholder;
    /** @type {?} */
    NgxMatTimepickerControlComponent.prototype.preventTyping;
    /** @type {?} */
    NgxMatTimepickerControlComponent.prototype.time;
    /** @type {?} */
    NgxMatTimepickerControlComponent.prototype.timeChanged;
    /** @type {?} */
    NgxMatTimepickerControlComponent.prototype.timeList;
    /** @type {?} */
    NgxMatTimepickerControlComponent.prototype.timeUnit;
    /** @type {?} */
    NgxMatTimepickerControlComponent.prototype._color;
    /** @type {?} */
    NgxMatTimepickerControlComponent.prototype._floatLabel;
    /** @type {?} */
    NgxMatTimepickerControlComponent.prototype._previousTime;
    /** @type {?} */
    NgxMatTimepickerControlComponent.prototype._timeParser;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxMatTimepickerTimeLocalizerPipe {
    /**
     * @param {?} _locale
     */
    constructor(_locale) {
        this._locale = _locale;
    }
    /**
     * @param {?} time
     * @param {?} timeUnit
     * @param {?=} isKeyboardEnabled
     * @return {?}
     */
    transform(time, timeUnit, isKeyboardEnabled = false) {
        if (time == null || time === "") {
            return "";
        }
        switch (timeUnit) {
            case NgxMatTimepickerUnits.HOUR: {
                const /** @type {?} */ format = (time === 0 || isKeyboardEnabled) ? "HH" : "H";
                return this._formatTime(NgxMatTimepickerMeasure.hour, time, format);
            }
            case NgxMatTimepickerUnits.MINUTE:
                return this._formatTime(NgxMatTimepickerMeasure.minute, time, "mm");
            default:
                throw new Error(`There is no Time Unit with type ${timeUnit}`);
        }
    }
    /**
     * @param {?} timeMeasure
     * @param {?} time
     * @param {?} format
     * @return {?}
     */
    _formatTime(timeMeasure, time, format) {
        try {
            return DateTime.fromObject({ [timeMeasure]: +time }).setLocale(this._locale).toFormat(format);
        }
        catch (_a) {
            throw new Error(`Cannot format provided time - ${time} to locale - ${this._locale}`);
        }
    }
}
NgxMatTimepickerTimeLocalizerPipe.ɵfac = function NgxMatTimepickerTimeLocalizerPipe_Factory(t) { return new (t || NgxMatTimepickerTimeLocalizerPipe)(ɵngcc0.ɵɵdirectiveInject(NGX_MAT_TIMEPICKER_LOCALE, 16)); };
NgxMatTimepickerTimeLocalizerPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "timeLocalizer", type: NgxMatTimepickerTimeLocalizerPipe, pure: true });
/** @nocollapse */
NgxMatTimepickerTimeLocalizerPipe.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [NGX_MAT_TIMEPICKER_LOCALE,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepickerTimeLocalizerPipe, [{
        type: Pipe,
        args: [{
                name: "timeLocalizer"
            }]
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [NGX_MAT_TIMEPICKER_LOCALE]
            }] }]; }, null); })();
function NgxMatTimepickerTimeLocalizerPipe_tsickle_Closure_declarations() {
    /** @type {?} */
    NgxMatTimepickerTimeLocalizerPipe.prototype._locale;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxMatTimepickerActiveHourPipe {
    /**
     * @param {?} hour
     * @param {?} currentHour
     * @param {?} isClockFaceDisabled
     * @return {?}
     */
    transform(hour, currentHour, isClockFaceDisabled) {
        if (hour == null || isClockFaceDisabled) {
            return false;
        }
        return hour === currentHour;
    }
}
NgxMatTimepickerActiveHourPipe.ɵfac = function NgxMatTimepickerActiveHourPipe_Factory(t) { return new (t || NgxMatTimepickerActiveHourPipe)(); };
NgxMatTimepickerActiveHourPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "activeHour", type: NgxMatTimepickerActiveHourPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepickerActiveHourPipe, [{
        type: Pipe,
        args: [{
                name: 'activeHour'
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxMatTimepickerActiveMinutePipe {
    /**
     * @param {?} minute
     * @param {?} currentMinute
     * @param {?} gap
     * @param {?} isClockFaceDisabled
     * @return {?}
     */
    transform(minute, currentMinute, gap, isClockFaceDisabled) {
        if (minute == null || isClockFaceDisabled) {
            return false;
        }
        const /** @type {?} */ defaultGap = 5;
        return ((currentMinute === minute) && (minute % (gap || defaultGap) === 0));
    }
}
NgxMatTimepickerActiveMinutePipe.ɵfac = function NgxMatTimepickerActiveMinutePipe_Factory(t) { return new (t || NgxMatTimepickerActiveMinutePipe)(); };
NgxMatTimepickerActiveMinutePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "activeMinute", type: NgxMatTimepickerActiveMinutePipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepickerActiveMinutePipe, [{
        type: Pipe,
        args: [{
                name: 'activeMinute'
            }]
    }], null, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxMatTimepickerContentComponent {
}
NgxMatTimepickerContentComponent.ɵfac = function NgxMatTimepickerContentComponent_Factory(t) { return new (t || NgxMatTimepickerContentComponent)(); };
NgxMatTimepickerContentComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxMatTimepickerContentComponent, selectors: [["ngx-mat-timepicker-content"]], inputs: { appendToInput: "appendToInput", inputElement: "inputElement" }, ngContentSelectors: _c11, decls: 5, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["timepickerModal", ""], ["timepickerOutlet", ""], [4, "ngTemplateOutlet"]], template: function NgxMatTimepickerContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, NgxMatTimepickerContentComponent_div_0_Template, 2, 1, "div", 0);
        ɵngcc0.ɵɵtemplate(1, NgxMatTimepickerContentComponent_ng_template_1_Template, 1, 1, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(3, NgxMatTimepickerContentComponent_ng_template_3_Template, 1, 0, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.appendToInput)("ngIfElse", _r1);
    } }, dependencies: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet], encapsulation: 2 });
NgxMatTimepickerContentComponent.propDecorators = {
    appendToInput: [{ type: Input }],
    inputElement: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepickerContentComponent, [{
        type: Component,
        args: [{
                selector: "ngx-mat-timepicker-content",
                template: "<div *ngIf=\"appendToInput;else timepickerModal\">\r\n\t<ng-container *ngTemplateOutlet=\"timepickerOutlet\"></ng-container>\r\n</div>\r\n<ng-template #timepickerModal>\r\n\t<ng-container *ngTemplateOutlet=\"timepickerOutlet\"></ng-container>\r\n</ng-template>\r\n<ng-template #timepickerOutlet>\r\n\t<ng-content></ng-content>\r\n</ng-template>\r\n"
            }]
    }], null, { appendToInput: [{
            type: Input
        }], inputElement: [{
            type: Input
        }] }); })();
function NgxMatTimepickerContentComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    NgxMatTimepickerContentComponent.prototype.appendToInput;
    /** @type {?} */
    NgxMatTimepickerContentComponent.prototype.inputElement;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxMatTimepickerStandaloneComponent extends NgxMatTimepickerBaseDirective {
    /**
     * @param {?} data
     * @param {?} timepickerSrv
     * @param {?} eventSrv
     * @param {?} locale
     */
    constructor(data, timepickerSrv, eventSrv, locale) {
        super(timepickerSrv, eventSrv, locale, data);
        this.data = data;
    }
    /**
     * @return {?}
     */
    close() {
        this.data.timepickerBaseRef.close();
    }
}
NgxMatTimepickerStandaloneComponent.ɵfac = function NgxMatTimepickerStandaloneComponent_Factory(t) { return new (t || NgxMatTimepickerStandaloneComponent)(ɵngcc0.ɵɵdirectiveInject(NGX_MAT_TIMEPICKER_CONFIG), ɵngcc0.ɵɵdirectiveInject(NgxMatTimepickerService), ɵngcc0.ɵɵdirectiveInject(NgxMatTimepickerEventService), ɵngcc0.ɵɵdirectiveInject(NGX_MAT_TIMEPICKER_LOCALE)); };
NgxMatTimepickerStandaloneComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NgxMatTimepickerStandaloneComponent, selectors: [["ngx-mat-timepicker-standalone"]], hostVars: 2, hostBindings: function NgxMatTimepickerStandaloneComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵclassProp("mat-app-background", true);
    } }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 20, vars: 28, consts: [["cancelBtnDefault", ""], ["confirmBtnDefault", ""], ["cdkTrapFocus", "", "cdkTrapFocusAutoCapture", "", 3, "appendToInput", "inputElement", "ngxMatTimepickerTheme"], [1, "timepicker", 3, "ngClass"], [1, "timepicker-header", 3, "color"], [3, "color", "format", "hour", "minute", "period", "activeTimeUnit", "minTime", "maxTime", "isEditable", "editableHintTmpl", "minutesGap", "hoursOnly", "periodChanged", "timeUnitChanged", "hourChanged", "minuteChanged"], [1, "timepicker__main-content"], [1, "timepicker__body", 3, "ngSwitch"], [4, "ngSwitchCase"], [3, "color", "selectedMinute", "selectedHour", "minTime", "maxTime", "format", "period", "minutesGap", "minuteChange", 4, "ngSwitchCase"], [1, "ngx-mat-timepicker-standalone-actions"], [3, "click"], [4, "ngTemplateOutlet"], ["mat-button", "", 3, "color"], [3, "color", "selectedHour", "minTime", "maxTime", "format", "hourChange", "hourSelected", 4, "ngIf", "ngIfElse"], ["ampmHours", ""], [3, "color", "selectedHour", "minTime", "maxTime", "format", "hourChange", "hourSelected"], [3, "color", "selectedHour", "period", "minTime", "maxTime", "hourChange", "hourSelected"], [3, "color", "selectedMinute", "selectedHour", "minTime", "maxTime", "format", "period", "minutesGap", "minuteChange"]], template: function NgxMatTimepickerStandaloneComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, NgxMatTimepickerStandaloneComponent_ng_template_0_Template, 2, 1, "ng-template", null, 0, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(2, NgxMatTimepickerStandaloneComponent_ng_template_2_Template, 2, 1, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementStart(4, "ngx-mat-timepicker-content", 2)(5, "div", 3)(6, "mat-toolbar", 4)(7, "ngx-mat-timepicker-dial", 5);
        ɵngcc0.ɵɵlistener("periodChanged", function NgxMatTimepickerStandaloneComponent_Template_ngx_mat_timepicker_dial_periodChanged_7_listener($event) { return ctx.changePeriod($event); })("timeUnitChanged", function NgxMatTimepickerStandaloneComponent_Template_ngx_mat_timepicker_dial_timeUnitChanged_7_listener($event) { return ctx.changeTimeUnit($event); })("hourChanged", function NgxMatTimepickerStandaloneComponent_Template_ngx_mat_timepicker_dial_hourChanged_7_listener($event) { return ctx.onHourChange($event); })("minuteChanged", function NgxMatTimepickerStandaloneComponent_Template_ngx_mat_timepicker_dial_minuteChanged_7_listener($event) { return ctx.onMinuteChange($event); });
        ɵngcc0.ɵɵpipe(8, "async");
        ɵngcc0.ɵɵpipe(9, "async");
        ɵngcc0.ɵɵpipe(10, "async");
        ɵngcc0.ɵɵelementEnd()();
        ɵngcc0.ɵɵelementStart(11, "div", 6)(12, "div", 7);
        ɵngcc0.ɵɵtemplate(13, NgxMatTimepickerStandaloneComponent_div_13_Template, 4, 2, "div", 8);
        ɵngcc0.ɵɵtemplate(14, NgxMatTimepickerStandaloneComponent_ngx_mat_timepicker_minutes_face_14_Template, 4, 14, "ngx-mat-timepicker-minutes-face", 9);
        ɵngcc0.ɵɵelementEnd()()()();
        ɵngcc0.ɵɵelementStart(15, "div", 10)(16, "div", 11);
        ɵngcc0.ɵɵlistener("click", function NgxMatTimepickerStandaloneComponent_Template_div_click_16_listener() { return ctx.close(); });
        ɵngcc0.ɵɵtemplate(17, NgxMatTimepickerStandaloneComponent_ng_container_17_Template, 1, 0, "ng-container", 12);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(18, "div", 11);
        ɵngcc0.ɵɵlistener("click", function NgxMatTimepickerStandaloneComponent_Template_div_click_18_listener() { return ctx.setTime(); });
        ɵngcc0.ɵɵtemplate(19, NgxMatTimepickerStandaloneComponent_ng_container_19_Template, 1, 0, "ng-container", 12);
        ɵngcc0.ɵɵelementEnd()();
    } if (rf & 2) {
        const _r0 = ɵngcc0.ɵɵreference(1);
        const _r2 = ɵngcc0.ɵɵreference(3);
        let tmp_7_0;
        let tmp_8_0;
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("appendToInput", ctx.data.appendToInput)("inputElement", ctx.data.inputElement)("ngxMatTimepickerTheme", ctx.data.theme);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ctx.data.timepickerClass);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("color", ctx.color);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("color", ctx.color)("format", ctx.data.format)("hour", (tmp_7_0 = ɵngcc0.ɵɵpipeBind1(8, 22, ctx.selectedHour)) == null ? null : tmp_7_0.time)("minute", (tmp_8_0 = ɵngcc0.ɵɵpipeBind1(9, 24, ctx.selectedMinute)) == null ? null : tmp_8_0.time)("period", ɵngcc0.ɵɵpipeBind1(10, 26, ctx.selectedPeriod))("activeTimeUnit", ctx.activeTimeUnit)("minTime", ctx.data.minTime)("maxTime", ctx.data.maxTime)("isEditable", ctx.data.enableKeyboardInput)("editableHintTmpl", ctx.data.editableHintTmpl)("minutesGap", ctx.data.minutesGap)("hoursOnly", ctx.data.hoursOnly);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵproperty("ngSwitch", ctx.activeTimeUnit);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.timeUnit.HOUR);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngSwitchCase", ctx.timeUnit.MINUTE);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.data.cancelBtnTmpl ? ctx.data.cancelBtnTmpl : _r0);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.data.confirmBtnTmpl ? ctx.data.confirmBtnTmpl : _r2);
    } }, dependencies: [ɵngcc1.NgClass, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgSwitch, ɵngcc1.NgSwitchCase, ɵngcc8.CdkTrapFocus, ɵngcc9.MatButton, ɵngcc10.MatToolbar, NgxMatTimepickerDialComponent, NgxMatTimepickerMinutesFaceComponent, NgxMatTimepicker12HoursFaceComponent, NgxMatTimepicker24HoursFaceComponent, NgxMatTimepickerThemeDirective, NgxMatTimepickerContentComponent, ɵngcc1.AsyncPipe], styles: ["ngx-mat-timepicker-standalone{border-radius:4px;display:block;padding:8px}ngx-mat-timepicker-standalone ngx-mat-timepicker-content{display:block}ngx-mat-timepicker-standalone ngx-mat-timepicker-content mat-toolbar.timepicker-header{align-items:center;display:flex;justify-content:center}ngx-mat-timepicker-standalone ngx-mat-timepicker-content mat-toolbar.timepicker-header.is-editable{height:auto}ngx-mat-timepicker-standalone ngx-mat-timepicker-content .clock-face{margin:16px}ngx-mat-timepicker-standalone .ngx-mat-timepicker-standalone-actions{display:flex;flex-direction:row;justify-content:flex-end}"], encapsulation: 2 });
/** @nocollapse */
NgxMatTimepickerStandaloneComponent.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [NGX_MAT_TIMEPICKER_CONFIG,] }] },
    { type: NgxMatTimepickerService },
    { type: NgxMatTimepickerEventService },
    { type: String, decorators: [{ type: Inject, args: [NGX_MAT_TIMEPICKER_LOCALE,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepickerStandaloneComponent, [{
        type: Component,
        args: [{ selector: "ngx-mat-timepicker-standalone", template: "<ng-template #cancelBtnDefault>\r\n\t<button mat-button\r\n\t\t\t[color]=\"color\">CANCEL\r\n\t</button>\r\n</ng-template>\r\n<ng-template #confirmBtnDefault>\r\n\t<button mat-button\r\n\t\t\t[color]=\"color\">OK\r\n\t</button>\r\n</ng-template>\r\n<ngx-mat-timepicker-content [appendToInput]=\"data.appendToInput\"\r\n\t\t\t\t\t\t\t[inputElement]=\"data.inputElement\"\r\n\t\t\t\t\t\t\t[ngxMatTimepickerTheme]=\"data.theme\"\r\n\t\t\t\t\t\t\tcdkTrapFocus\r\n\t\t\t\t\t\t\tcdkTrapFocusAutoCapture>\r\n\t<div class=\"timepicker\"\r\n\t\t [ngClass]=\"data.timepickerClass\">\r\n\t\t<mat-toolbar [color]=\"color\"\r\n\t\t\t\t\t class=\"timepicker-header\">\r\n\t\t\t<ngx-mat-timepicker-dial [color]=\"color\"\r\n\t\t\t\t\t\t\t\t\t [format]=\"data.format\"\r\n\t\t\t\t\t\t\t\t\t [hour]=\"(selectedHour | async)?.time\"\r\n\t\t\t\t\t\t\t\t\t [minute]=\"(selectedMinute | async)?.time\"\r\n\t\t\t\t\t\t\t\t\t [period]=\"selectedPeriod | async\"\r\n\t\t\t\t\t\t\t\t\t [activeTimeUnit]=\"activeTimeUnit\"\r\n\t\t\t\t\t\t\t\t\t [minTime]=\"data.minTime\"\r\n\t\t\t\t\t\t\t\t\t [maxTime]=\"data.maxTime\"\r\n\t\t\t\t\t\t\t\t\t [isEditable]=\"data.enableKeyboardInput\"\r\n\t\t\t\t\t\t\t\t\t [editableHintTmpl]=\"data.editableHintTmpl\"\r\n\t\t\t\t\t\t\t\t\t [minutesGap]=\"data.minutesGap\"\r\n\t\t\t\t\t\t\t\t\t [hoursOnly]=\"data.hoursOnly\"\r\n\t\t\t\t\t\t\t\t\t (periodChanged)=\"changePeriod($event)\"\r\n\t\t\t\t\t\t\t\t\t (timeUnitChanged)=\"changeTimeUnit($event)\"\r\n\t\t\t\t\t\t\t\t\t (hourChanged)=\"onHourChange($event)\"\r\n\t\t\t\t\t\t\t\t\t (minuteChanged)=\"onMinuteChange($event)\">\r\n\t\t\t</ngx-mat-timepicker-dial>\r\n\t\t</mat-toolbar>\r\n\t\t<div class=\"timepicker__main-content\">\r\n\t\t\t<div class=\"timepicker__body\"\r\n\t\t\t\t [ngSwitch]=\"activeTimeUnit\">\r\n\t\t\t\t<div *ngSwitchCase=\"timeUnit.HOUR\">\r\n\t\t\t\t\t<ngx-mat-timepicker-24-hours-face *ngIf=\"data.format === 24;else ampmHours\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t  [color]=\"color\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t  (hourChange)=\"onHourChange($event)\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t  [selectedHour]=\"selectedHour | async\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t  [minTime]=\"data.minTime\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t  [maxTime]=\"data.maxTime\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t  [format]=\"data.format\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t  (hourSelected)=\"onHourSelected($event)\"></ngx-mat-timepicker-24-hours-face>\r\n\t\t\t\t\t<ng-template #ampmHours>\r\n\t\t\t\t\t\t<ngx-mat-timepicker-12-hours-face\r\n\t\t\t\t\t\t\t\t[color]=\"color\"\r\n\t\t\t\t\t\t\t\t(hourChange)=\"onHourChange($event)\"\r\n\t\t\t\t\t\t\t\t[selectedHour]=\"selectedHour | async\"\r\n\t\t\t\t\t\t\t\t[period]=\"selectedPeriod | async\"\r\n\t\t\t\t\t\t\t\t[minTime]=\"data.minTime\"\r\n\t\t\t\t\t\t\t\t[maxTime]=\"data.maxTime\"\r\n\t\t\t\t\t\t\t\t(hourSelected)=\"onHourSelected($event)\"></ngx-mat-timepicker-12-hours-face>\r\n\t\t\t\t\t</ng-template>\r\n\t\t\t\t</div>\r\n\t\t\t\t<ngx-mat-timepicker-minutes-face *ngSwitchCase=\"timeUnit.MINUTE\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t [color]=\"color\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t [selectedMinute]=\"selectedMinute | async\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t [selectedHour]=\"(selectedHour | async)?.time\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t [minTime]=\"data.minTime\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t [maxTime]=\"data.maxTime\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t [format]=\"data.format\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t [period]=\"selectedPeriod | async\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t [minutesGap]=\"data.minutesGap\"\r\n\t\t\t\t\t\t\t\t\t\t\t\t (minuteChange)=\"onMinuteChange($event)\"></ngx-mat-timepicker-minutes-face>\r\n\t\t\t</div>\r\n\t\t</div>\r\n\t</div>\r\n</ngx-mat-timepicker-content>\r\n\r\n<div class=\"ngx-mat-timepicker-standalone-actions\">\r\n\t<div (click)=\"close()\">\r\n\t\t<ng-container\r\n\t\t\t\t*ngTemplateOutlet=\"data.cancelBtnTmpl ? data.cancelBtnTmpl : cancelBtnDefault\"></ng-container>\r\n\t</div>\r\n\t<div (click)=\"setTime()\">\r\n\t\t<ng-container\r\n\t\t\t\t*ngTemplateOutlet=\"data.confirmBtnTmpl ? data.confirmBtnTmpl : confirmBtnDefault\"></ng-container>\r\n\t</div>\r\n</div>\r\n", host: {
                    "[class.mat-app-background]": "true"
                }, encapsulation: ViewEncapsulation.None, styles: ["ngx-mat-timepicker-standalone{border-radius:4px;display:block;padding:8px}ngx-mat-timepicker-standalone ngx-mat-timepicker-content{display:block}ngx-mat-timepicker-standalone ngx-mat-timepicker-content mat-toolbar.timepicker-header{align-items:center;display:flex;justify-content:center}ngx-mat-timepicker-standalone ngx-mat-timepicker-content mat-toolbar.timepicker-header.is-editable{height:auto}ngx-mat-timepicker-standalone ngx-mat-timepicker-content .clock-face{margin:16px}ngx-mat-timepicker-standalone .ngx-mat-timepicker-standalone-actions{display:flex;flex-direction:row;justify-content:flex-end}"] }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [NGX_MAT_TIMEPICKER_CONFIG]
            }] }, { type: NgxMatTimepickerService }, { type: NgxMatTimepickerEventService }, { type: String, decorators: [{
                type: Inject,
                args: [NGX_MAT_TIMEPICKER_LOCALE]
            }] }]; }, null); })();
function NgxMatTimepickerStandaloneComponent_tsickle_Closure_declarations() {
    /** @type {?} */
    NgxMatTimepickerStandaloneComponent.prototype.data;
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
class NgxMatTimepickerModule {
    /**
     * @param {?} locale
     * @return {?}
     */
    static setLocale(locale) {
        return {
            ngModule: NgxMatTimepickerModule,
            providers: [
                { provide: NGX_MAT_TIMEPICKER_LOCALE, useValue: locale },
                { provide: NGX_MAT_TIMEPICKER_CONFIG, useValue: undefined },
            ]
        };
    }
}
NgxMatTimepickerModule.ɵfac = function NgxMatTimepickerModule_Factory(t) { return new (t || NgxMatTimepickerModule)(); };
NgxMatTimepickerModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxMatTimepickerModule });
NgxMatTimepickerModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule,
        A11yModule,
        FormsModule,
        MatButtonModule,
        MatFormFieldModule,
        MatDialogModule,
        MatInputModule,
        MatSelectModule,
        MatToolbarModule,
        MatIconModule,
        OverlayModule,
        PortalModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxMatTimepickerModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    A11yModule,
                    FormsModule,
                    MatButtonModule,
                    MatFormFieldModule,
                    MatDialogModule,
                    MatInputModule,
                    MatSelectModule,
                    MatToolbarModule,
                    MatIconModule,
                    OverlayModule,
                    PortalModule
                ],
                exports: [
                    NgxMatTimepickerComponent,
                    NgxMatTimepickerToggleComponent,
                    NgxMatTimepickerFieldComponent,
                    NgxMatTimepickerDirective,
                    NgxMatTimepickerToggleIconDirective
                ],
                declarations: [
                    NgxMatTimepickerBaseDirective,
                    NgxMatTimepickerHoursFaceDirective,
                    NgxMatTimepickerActiveHourPipe,
                    NgxMatTimepickerActiveMinutePipe,
                    NgxMatTimepickerComponent,
                    NgxMatTimepickerDialComponent,
                    NgxMatTimepickerDialControlComponent,
                    NgxMatTimepickerDialogComponent,
                    NgxMatTimepickerDirective,
                    NgxMatTimepickerFaceComponent,
                    NgxMatTimepickerMinutesFaceComponent,
                    NgxMatTimepickerPeriodComponent,
                    NgxMatTimepickerStandaloneComponent,
                    NgxMatTimepickerToggleComponent,
                    NgxMatTimepicker12HoursFaceComponent,
                    NgxMatTimepicker24HoursFaceComponent,
                    NgxMatTimepickerToggleIconDirective,
                    NgxMatTimepickerAutofocusDirective,
                    NgxMatTimepickerMinutesFormatterPipe,
                    NgxMatTimepickerThemeDirective,
                    NgxMatTimepickerFieldComponent,
                    NgxMatTimepickerControlComponent,
                    NgxMatTimepickerParserPipe,
                    NgxMatTimepickerContentComponent,
                    NgxMatTimepickerTimeFormatterPipe,
                    NgxMatTimepickerTimeLocalizerPipe
                ],
                entryComponents: [
                    NgxMatTimepickerDialogComponent,
                    NgxMatTimepickerStandaloneComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxMatTimepickerModule, { declarations: function () { return [NgxMatTimepickerBaseDirective, NgxMatTimepickerHoursFaceDirective, NgxMatTimepickerActiveHourPipe, NgxMatTimepickerActiveMinutePipe, NgxMatTimepickerComponent, NgxMatTimepickerDialComponent, NgxMatTimepickerDialControlComponent, NgxMatTimepickerDialogComponent, NgxMatTimepickerDirective, NgxMatTimepickerFaceComponent, NgxMatTimepickerMinutesFaceComponent, NgxMatTimepickerPeriodComponent, NgxMatTimepickerStandaloneComponent, NgxMatTimepickerToggleComponent, NgxMatTimepicker12HoursFaceComponent, NgxMatTimepicker24HoursFaceComponent, NgxMatTimepickerToggleIconDirective, NgxMatTimepickerAutofocusDirective, NgxMatTimepickerMinutesFormatterPipe, NgxMatTimepickerThemeDirective, NgxMatTimepickerFieldComponent, NgxMatTimepickerControlComponent, NgxMatTimepickerParserPipe, NgxMatTimepickerContentComponent, NgxMatTimepickerTimeFormatterPipe, NgxMatTimepickerTimeLocalizerPipe]; }, imports: function () { return [CommonModule,
        A11yModule,
        FormsModule,
        MatButtonModule,
        MatFormFieldModule,
        MatDialogModule,
        MatInputModule,
        MatSelectModule,
        MatToolbarModule,
        MatIconModule,
        OverlayModule,
        PortalModule]; }, exports: function () { return [NgxMatTimepickerComponent, NgxMatTimepickerToggleComponent, NgxMatTimepickerFieldComponent, NgxMatTimepickerDirective, NgxMatTimepickerToggleIconDirective]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { NgxMatTimepickerDirective, NgxMatTimepickerFieldComponent, NgxMatTimepickerModule, NgxMatTimepickerToggleComponent, NgxMatTimepickerToggleIconDirective, NgxMatTimepickerService as ɵa, NGX_MAT_TIMEPICKER_LOCALE as ɵb, NgxMatTimepickerComponent as ɵc, NGX_MAT_TIMEPICKER_CONFIG as ɵd, NgxMatTimepickerEventService as ɵe, NgxMatTimepickerBaseDirective as ɵf, NgxMatTimepickerHoursFaceDirective as ɵg, NgxMatTimepickerActiveHourPipe as ɵh, NgxMatTimepickerActiveMinutePipe as ɵi, NgxMatTimepickerDialComponent as ɵj, NgxMatTimepickerDialControlComponent as ɵk, NgxMatTimepickerParserPipe as ɵl, NgxMatTimepickerDialogComponent as ɵm, NgxMatTimepickerFaceComponent as ɵn, NgxMatTimepickerMinutesFaceComponent as ɵo, NgxMatTimepickerPeriodComponent as ɵp, NgxMatTimepickerStandaloneComponent as ɵq, NgxMatTimepicker12HoursFaceComponent as ɵr, NgxMatTimepicker24HoursFaceComponent as ɵs, NgxMatTimepickerAutofocusDirective as ɵt, NgxMatTimepickerMinutesFormatterPipe as ɵu, NgxMatTimepickerThemeDirective as ɵv, NgxMatTimepickerControlComponent as ɵw, NgxMatTimepickerContentComponent as ɵx, NgxMatTimepickerTimeFormatterPipe as ɵy, NgxMatTimepickerTimeLocalizerPipe as ɵz };

